import t_inputs from '@/constants/test_Distil_Absorber.json';
//临时任务列表
export const tempTasks = [
    {
        "id": 4,
        "name": "新计算任务",
        "input_data": "{\"name\":\"Rectisol-Tower#6_#9\",\"flow_id\":1001,\"description\":\"低温甲醇洗的6塔（甲醇-水分离）和9塔（尾气洗涤）工艺流程\",\"inputs\":{\"global_physical_method\":\"SRK\",\"streams\":[{\"name\":\"31-89\",\"section\":\"methanol\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0.006249734},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.994},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":2.45e-297},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":2.12e-11},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":1.61e-15},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":1e-9},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":3.9e-12},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":27764.9,\"f_unit\":\"kg/h\",\"t\":95.05,\"t_unit\":\"C\",\"p\":0.3,\"p_unit\":\"MPa\"}},{\"name\":\"31-901\",\"section\":\"methanol\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0.030337456},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.969662544},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":6.97e-30},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":3.64e-42},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":1.5e-23},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":5.19e-24},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":10857.1,\"f_unit\":\"kg/h\",\"t\":95.44,\"t_unit\":\"C\",\"p\":0.15,\"p_unit\":\"MPa\"}},{\"name\":\"31-891\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-90\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-95\",\"section\":\"methanol\",\"type\":\"内部\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0.98778741},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.000842},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":8.46e-9},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":3.65e-7},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0.0111},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":2.49e-7},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0.000227753},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":4.16e-7},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":6.65e-7},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":13933.5,\"f_unit\":\"kg/h\",\"t\":117.703,\"t_unit\":\"C\",\"p\":0.6,\"p_unit\":\"MPa\"}},{\"name\":\"31-99o\",\"type\":\"出料\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"V\",\"rule\":\"D\"}},{\"name\":\"31-91\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"B\"}},{\"name\":\"31-60\",\"section\":\"gas\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.00010801},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0.000140013},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0.000360033},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0.735937706},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0.00009},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0.263344228},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":0.00001},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":0.00001},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"V\",\"f\":375063,\"f_unit\":\"kg/h\",\"t\":30.5,\"t_unit\":\"C\",\"p\":0.105,\"p_unit\":\"MPa\"}},{\"name\":\"31-100\",\"section\":\"gas\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.00027},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0.00001},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0.00026},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0.99931},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0.00015},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":0},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":0},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"V\",\"f\":49761.5,\"f_unit\":\"kg/h\",\"t\":30.5,\"t_unit\":\"C\",\"p\":0.1,\"p_unit\":\"MPa\"}},{\"name\":\"31-94A\",\"section\":\"gas\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":1},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":0},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":0},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":8041.83,\"f_unit\":\"kg/h\",\"t\":25.2,\"t_unit\":\"C\",\"p\":0.15,\"p_unit\":\"MPa\"}},{\"name\":\"31-94B\",\"section\":\"gas\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":1},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":0},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":0},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":8052.5,\"f_unit\":\"kg/h\",\"t\":25.2,\"t_unit\":\"C\",\"p\":0.15,\"p_unit\":\"MPa\"}},{\"name\":\"S1\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S6\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S11\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S12\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S2\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S5\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-60100\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-6010A\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-6010B\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-94AS11\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-94BS12\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"IMPURE\",\"type\":\"出料\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"type\":\"出料\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-61A\",\"type\":\"出料\",\"materials\":[],\"params\":{\"physical_method\":\"NRTL-RK\",\"mode\":\"TP\",\"phase\":\"V\",\"rule\":\"D\"}},{\"name\":\"31-61B\",\"type\":\"出料\",\"materials\":[],\"params\":{\"physical_method\":\"NRTL-RK\",\"mode\":\"TP\",\"phase\":\"V\",\"rule\":\"D\"}},{\"name\":\"31-95A\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"NRTL-RK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"B\"}},{\"name\":\"31-95B\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"NRTL-RK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"B\"}}],\"elements\":[{\"name\":\"B1\",\"section\":\"methanol\",\"type\":\"Pump\",\"physical_method\":\"SRK\",\"phase\":\"L\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-89\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-891\",\"rule\":\"M\"}],\"params\":{\"deltaP\":0.5,\"p_unit\":\"MPa\"}},{\"name\":\"P-109\",\"section\":\"methanol\",\"type\":\"Pump\",\"physical_method\":\"SRK\",\"phase\":\"L\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-901\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-90\",\"rule\":\"M\"}],\"params\":{\"deltaP\":0.15,\"p_unit\":\"MPa\"}},{\"name\":\"T-106\",\"section\":\"methanol\",\"type\":\"DistilStrict\",\"physical_method\":\"NRTL-RK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-891\",\"rule\":\"M\"},{\"name\":\"31-90\",\"rule\":\"M\"},{\"name\":\"31-95\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-99o\",\"rule\":\"D\"},{\"name\":\"31-91\",\"rule\":\"B\"}],\"params\":{\"type\":\"Distil\",\"N\":45,\"Ns\":[1,21,30],\"No\":[1,45],\"P_D\":0.3,\"pressure_drop\":0.03,\"p_unit\":\"MPa\",\"SPEC\":\"Partial\",\"eff\":[{\"start\":1,\"end\":45,\"value\":1}],\"murphree\":0,\"T_drop\":0,\"S1\":\"B\",\"S2\":\"QC\",\"V1\":12140.5,\"V1_unit\":\"kg/h\",\"V2\":0,\"V_list\":{\"NV\":[],\"W\":[]},\"L_list\":{\"NL\":[],\"U\":[]},\"Q_list\":{\"NQ\":[],\"QH\":[]},\"max_iter_outer\":1000,\"max_iter_inner\":30,\"max_notimproved_count\":100,\"max_inner_notconverged_count\":20,\"TOL\":0.00001,\"im_mode\":2,\"h\":1,\"D_col\":1.785,\"theta\":0.1,\"h_w\":0.0508,\"C_v\":0.7325,\"d_hole\":0.0127}},{\"name\":\"E128-A\",\"section\":\"heat\",\"type\":\"ShellAndTubeExchanger\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"S6\",\"rule\":\"M\"},{\"name\":\"31-91\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-95\",\"rule\":\"M\"},{\"name\":\"S1\",\"rule\":\"M\"}],\"params\":{\"type\":\"TEMA E\",\"UA\":2708.97463582,\"flow_type\":\"counter\",\"efficiency\":0.91,\"hot_out_T\":36.5,\"t_unit\":\"C\",\"stream_type\":{\"stream_in_cold\":1,\"stream_in_hot\":2,\"stream_out_cold\":1,\"stream_out_hot\":2}}},{\"name\":\"P-110\",\"section\":\"gas\",\"type\":\"Pump\",\"physical_method\":\"SRK\",\"phase\":\"L\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-95A\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"S2\",\"rule\":\"M\"}],\"params\":{\"p\":0.6,\"p_unit\":\"MPa\"}},{\"name\":\"P-111\",\"type\":\"Pump\",\"section\":\"gas\",\"physical_method\":\"SRK\",\"phase\":\"L\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-95B\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"S5\",\"rule\":\"M\"}],\"params\":{\"p\":0.6,\"p_unit\":\"MPa\"}},{\"name\":\"B14\",\"section\":\"gas\",\"type\":\"Splitter\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"S1\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"S11\",\"rule\":\"M\"},{\"name\":\"S12\",\"rule\":\"M\"},{\"name\":\"IMPURE\",\"rule\":\"M\"}],\"params\":{\"output_f\":[3000,3000,-1],\"f_unit\":\"kg/h\"}},{\"name\":\"B7\",\"section\":\"gas\",\"type\":\"Splitter\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-60100\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-6010A\",\"rule\":\"M\"},{\"name\":\"31-6010B\",\"rule\":\"M\"}],\"params\":{\"output_f\":[0.5,0.5],\"f_unit\":\"frac\"}},{\"name\":\"B6\",\"section\":\"gas\",\"type\":\"Mixer\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-60\",\"rule\":\"M\"},{\"name\":\"31-100\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-60100\",\"rule\":\"M\"}]},{\"name\":\"B11\",\"section\":\"gas\",\"type\":\"Mixer\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"S2\",\"rule\":\"M\"},{\"name\":\"S5\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"S6\",\"rule\":\"M\"}]},{\"name\":\"B12\",\"section\":\"gas\",\"type\":\"Mixer\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-94A\",\"rule\":\"M\"},{\"name\":\"S11\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-94AS11\",\"rule\":\"M\"}]},{\"name\":\"B13\",\"section\":\"gas\",\"type\":\"Mixer\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-94B\",\"rule\":\"M\"},{\"name\":\"S12\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-94BS12\",\"rule\":\"M\"}]},{\"name\":\"T-109A\",\"section\":\"gas\",\"type\":\"DistilStrict\",\"physical_method\":\"NRTL-RK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-94AS11\",\"rule\":\"M\"},{\"name\":\"31-6010A\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-61A\",\"rule\":\"D\"},{\"name\":\"31-95A\",\"rule\":\"B\"}],\"params\":{\"type\":\"Absorber\",\"N\":4,\"Ns\":[1,4],\"No\":[1,4],\"P_D\":0.09,\"pressure_drop\":0.01,\"p_unit\":\"MPa\",\"eff\":[{\"start\":1,\"end\":4,\"value\":0.1}],\"murphree\":1,\"V_list\":{\"NV\":[],\"W\":[]},\"L_list\":{\"NL\":[],\"U\":[]},\"Q_list\":{\"NQ\":[],\"QH\":[]},\"max_iter_outer\":1000,\"max_iter_inner\":30,\"max_notimproved_count\":100,\"max_inner_notconverged_count\":50,\"TOL\":0.00001,\"im_mode\":2,\"h\":1,\"D_col\":1.785,\"theta\":0.1,\"h_w\":0.0508,\"C_v\":0.7325,\"d_hole\":0.0127}},{\"name\":\"T-109B\",\"section\":\"gas\",\"type\":\"DistilStrict\",\"physical_method\":\"NRTL-RK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-94BS12\",\"rule\":\"M\"},{\"name\":\"31-6010B\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-61B\",\"rule\":\"D\"},{\"name\":\"31-95B\",\"rule\":\"B\"}],\"params\":{\"type\":\"Absorber\",\"N\":4,\"Ns\":[1,4],\"No\":[1,4],\"P_D\":0.09,\"pressure_drop\":0.01,\"p_unit\":\"MPa\",\"eff\":[{\"start\":1,\"end\":4,\"value\":0.1}],\"murphree\":1,\"V_list\":{\"NV\":[],\"W\":[]},\"L_list\":{\"NL\":[],\"U\":[]},\"Q_list\":{\"NQ\":[],\"QH\":[]},\"max_iter_outer\":1000,\"max_iter_inner\":30,\"max_notimproved_count\":100,\"max_inner_notconverged_count\":50,\"TOL\":0.00001,\"im_mode\":2,\"h\":1,\"D_col\":1.785,\"theta\":0.1,\"h_w\":0.0508,\"C_v\":0.7325,\"d_hole\":0.0127}}]}}",
        "status": "completed",
        "result_path": "/data/user/0/com.allenwuwang.T109T106cal/cache/calc_d6cf09b8-ed08-467e-b140-577a57b9f0a0.json",
        "tags": [
            "test"
        ],
        "created_at": "2026-03-01T17:58:16.226Z",
        "updated_at": "2026-03-01T17:59:13.684Z",
        "started_at": "2026-03-01T17:58:34.832Z",
        "finished_at": "2026-03-01T17:59:13.684Z",
        "rowIndex": 0,
        "selectVisable": false
    },
    {
        "id": 5,
        "name": "新计算任务2",
        "input_data": "{\"name\":\"Rectisol-Tower#6_#9\",\"flow_id\":1001,\"description\":\"低温甲醇洗的6塔（甲醇-水分离）和9塔（尾气洗涤）工艺流程\",\"inputs\":{\"global_physical_method\":\"SRK\",\"streams\":[{\"name\":\"31-89\",\"section\":\"methanol\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0.006249734},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.994},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":2.45e-297},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":2.12e-11},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":1.61e-15},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":1e-9},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":3.9e-12},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":27764.9,\"f_unit\":\"kg/h\",\"t\":95.05,\"t_unit\":\"C\",\"p\":0.3,\"p_unit\":\"MPa\"}},{\"name\":\"31-901\",\"section\":\"methanol\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0.030337456},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.969662544},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":6.97e-30},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":3.64e-42},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":1.5e-23},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":5.19e-24},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":10857.1,\"f_unit\":\"kg/h\",\"t\":95.44,\"t_unit\":\"C\",\"p\":0.15,\"p_unit\":\"MPa\"}},{\"name\":\"31-891\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-90\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-95\",\"section\":\"methanol\",\"type\":\"内部\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0.98778741},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.000842},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":8.46e-9},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":3.65e-7},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0.0111},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":2.49e-7},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0.000227753},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":4.16e-7},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":6.65e-7},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":13933.5,\"f_unit\":\"kg/h\",\"t\":117.703,\"t_unit\":\"C\",\"p\":0.6,\"p_unit\":\"MPa\"}},{\"name\":\"31-99o\",\"type\":\"出料\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"V\",\"rule\":\"D\"}},{\"name\":\"31-91\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"B\"}},{\"name\":\"31-60\",\"section\":\"gas\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.00010801},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0.000140013},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0.000360033},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0.735937706},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0.00009},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0.263344228},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":0.00001},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":0.00001},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"V\",\"f\":375063,\"f_unit\":\"kg/h\",\"t\":30.5,\"t_unit\":\"C\",\"p\":0.105,\"p_unit\":\"MPa\"}},{\"name\":\"31-100\",\"section\":\"gas\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.00027},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0.00001},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0.00026},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0.99931},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0.00015},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":0},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":0},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"V\",\"f\":49761.5,\"f_unit\":\"kg/h\",\"t\":30.5,\"t_unit\":\"C\",\"p\":0.1,\"p_unit\":\"MPa\"}},{\"name\":\"31-94A\",\"section\":\"gas\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":1},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":0},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":0},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":8041.83,\"f_unit\":\"kg/h\",\"t\":25.2,\"t_unit\":\"C\",\"p\":0.15,\"p_unit\":\"MPa\"}},{\"name\":\"31-94B\",\"section\":\"gas\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":1},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":0},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":0},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":8052.5,\"f_unit\":\"kg/h\",\"t\":25.2,\"t_unit\":\"C\",\"p\":0.15,\"p_unit\":\"MPa\"}},{\"name\":\"S1\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S6\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S11\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S12\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S2\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S5\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-60100\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-6010A\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-6010B\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-94AS11\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-94BS12\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"IMPURE\",\"type\":\"出料\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"type\":\"出料\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-61A\",\"type\":\"出料\",\"materials\":[],\"params\":{\"physical_method\":\"NRTL-RK\",\"mode\":\"TP\",\"phase\":\"V\",\"rule\":\"D\"}},{\"name\":\"31-61B\",\"type\":\"出料\",\"materials\":[],\"params\":{\"physical_method\":\"NRTL-RK\",\"mode\":\"TP\",\"phase\":\"V\",\"rule\":\"D\"}},{\"name\":\"31-95A\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"NRTL-RK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"B\"}},{\"name\":\"31-95B\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"NRTL-RK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"B\"}}],\"elements\":[{\"name\":\"B1\",\"section\":\"methanol\",\"type\":\"Pump\",\"physical_method\":\"SRK\",\"phase\":\"L\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-89\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-891\",\"rule\":\"M\"}],\"params\":{\"deltaP\":0.5,\"p_unit\":\"MPa\"}},{\"name\":\"P-109\",\"section\":\"methanol\",\"type\":\"Pump\",\"physical_method\":\"SRK\",\"phase\":\"L\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-901\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-90\",\"rule\":\"M\"}],\"params\":{\"deltaP\":0.15,\"p_unit\":\"MPa\"}},{\"name\":\"T-106\",\"section\":\"methanol\",\"type\":\"DistilStrict\",\"physical_method\":\"NRTL-RK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-891\",\"rule\":\"M\"},{\"name\":\"31-90\",\"rule\":\"M\"},{\"name\":\"31-95\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-99o\",\"rule\":\"D\"},{\"name\":\"31-91\",\"rule\":\"B\"}],\"params\":{\"type\":\"Distil\",\"N\":45,\"Ns\":[1,21,30],\"No\":[1,45],\"P_D\":0.3,\"pressure_drop\":0.03,\"p_unit\":\"MPa\",\"SPEC\":\"Partial\",\"eff\":[{\"start\":1,\"end\":45,\"value\":1}],\"murphree\":0,\"T_drop\":0,\"S1\":\"B\",\"S2\":\"QC\",\"V1\":12140.5,\"V1_unit\":\"kg/h\",\"V2\":0,\"V_list\":{\"NV\":[],\"W\":[]},\"L_list\":{\"NL\":[],\"U\":[]},\"Q_list\":{\"NQ\":[],\"QH\":[]},\"max_iter_outer\":1000,\"max_iter_inner\":30,\"max_notimproved_count\":100,\"max_inner_notconverged_count\":20,\"TOL\":0.00001,\"im_mode\":2,\"h\":1,\"D_col\":1.785,\"theta\":0.1,\"h_w\":0.0508,\"C_v\":0.7325,\"d_hole\":0.0127}},{\"name\":\"E128-A\",\"section\":\"heat\",\"type\":\"ShellAndTubeExchanger\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"S6\",\"rule\":\"M\"},{\"name\":\"31-91\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-95\",\"rule\":\"M\"},{\"name\":\"S1\",\"rule\":\"M\"}],\"params\":{\"type\":\"TEMA E\",\"UA\":2708.97463582,\"flow_type\":\"counter\",\"efficiency\":0.91,\"hot_out_T\":36.5,\"t_unit\":\"C\",\"stream_type\":{\"stream_in_cold\":1,\"stream_in_hot\":2,\"stream_out_cold\":1,\"stream_out_hot\":2}}},{\"name\":\"P-110\",\"section\":\"gas\",\"type\":\"Pump\",\"physical_method\":\"SRK\",\"phase\":\"L\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-95A\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"S2\",\"rule\":\"M\"}],\"params\":{\"p\":0.6,\"p_unit\":\"MPa\"}},{\"name\":\"P-111\",\"type\":\"Pump\",\"section\":\"gas\",\"physical_method\":\"SRK\",\"phase\":\"L\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-95B\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"S5\",\"rule\":\"M\"}],\"params\":{\"p\":0.6,\"p_unit\":\"MPa\"}},{\"name\":\"B14\",\"section\":\"gas\",\"type\":\"Splitter\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"S1\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"S11\",\"rule\":\"M\"},{\"name\":\"S12\",\"rule\":\"M\"},{\"name\":\"IMPURE\",\"rule\":\"M\"}],\"params\":{\"output_f\":[3000,3000,-1],\"f_unit\":\"kg/h\"}},{\"name\":\"B7\",\"section\":\"gas\",\"type\":\"Splitter\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-60100\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-6010A\",\"rule\":\"M\"},{\"name\":\"31-6010B\",\"rule\":\"M\"}],\"params\":{\"output_f\":[0.5,0.5],\"f_unit\":\"frac\"}},{\"name\":\"B6\",\"section\":\"gas\",\"type\":\"Mixer\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-60\",\"rule\":\"M\"},{\"name\":\"31-100\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-60100\",\"rule\":\"M\"}]},{\"name\":\"B11\",\"section\":\"gas\",\"type\":\"Mixer\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"S2\",\"rule\":\"M\"},{\"name\":\"S5\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"S6\",\"rule\":\"M\"}]},{\"name\":\"B12\",\"section\":\"gas\",\"type\":\"Mixer\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-94A\",\"rule\":\"M\"},{\"name\":\"S11\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-94AS11\",\"rule\":\"M\"}]},{\"name\":\"B13\",\"section\":\"gas\",\"type\":\"Mixer\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-94B\",\"rule\":\"M\"},{\"name\":\"S12\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-94BS12\",\"rule\":\"M\"}]},{\"name\":\"T-109A\",\"section\":\"gas\",\"type\":\"DistilStrict\",\"physical_method\":\"NRTL-RK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-94AS11\",\"rule\":\"M\"},{\"name\":\"31-6010A\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-61A\",\"rule\":\"D\"},{\"name\":\"31-95A\",\"rule\":\"B\"}],\"params\":{\"type\":\"Absorber\",\"N\":4,\"Ns\":[1,4],\"No\":[1,4],\"P_D\":0.09,\"pressure_drop\":0.01,\"p_unit\":\"MPa\",\"eff\":[{\"start\":1,\"end\":4,\"value\":0.1}],\"murphree\":1,\"V_list\":{\"NV\":[],\"W\":[]},\"L_list\":{\"NL\":[],\"U\":[]},\"Q_list\":{\"NQ\":[],\"QH\":[]},\"max_iter_outer\":1000,\"max_iter_inner\":30,\"max_notimproved_count\":100,\"max_inner_notconverged_count\":50,\"TOL\":0.00001,\"im_mode\":2,\"h\":1,\"D_col\":1.785,\"theta\":0.1,\"h_w\":0.0508,\"C_v\":0.7325,\"d_hole\":0.0127}},{\"name\":\"T-109B\",\"section\":\"gas\",\"type\":\"DistilStrict\",\"physical_method\":\"NRTL-RK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-94BS12\",\"rule\":\"M\"},{\"name\":\"31-6010B\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-61B\",\"rule\":\"D\"},{\"name\":\"31-95B\",\"rule\":\"B\"}],\"params\":{\"type\":\"Absorber\",\"N\":4,\"Ns\":[1,4],\"No\":[1,4],\"P_D\":0.09,\"pressure_drop\":0.01,\"p_unit\":\"MPa\",\"eff\":[{\"start\":1,\"end\":4,\"value\":0.1}],\"murphree\":1,\"V_list\":{\"NV\":[],\"W\":[]},\"L_list\":{\"NL\":[],\"U\":[]},\"Q_list\":{\"NQ\":[],\"QH\":[]},\"max_iter_outer\":1000,\"max_iter_inner\":30,\"max_notimproved_count\":100,\"max_inner_notconverged_count\":50,\"TOL\":0.00001,\"im_mode\":2,\"h\":1,\"D_col\":1.785,\"theta\":0.1,\"h_w\":0.0508,\"C_v\":0.7325,\"d_hole\":0.0127}}]}}",
        "status": "completed",
        "result_path": "/data/user/0/com.allenwuwang.T109T106cal/cache/calc_d6cf09b8-ed08-467e-b140-577a57b9f0a0.json",
        "tags": [
            "test"
        ],
        "created_at": "2026-03-01T17:58:16.226Z",
        "updated_at": "2026-03-01T17:59:13.684Z",
        "started_at": "2026-03-01T17:58:34.832Z",
        "finished_at": "2026-03-01T17:59:13.684Z",
        "rowIndex": 1,
        "selectVisable": false
    },
    {
        "id": 6,
        "name": "新计算任务3",
        "input_data": "{\"name\":\"Rectisol-Tower#6_#9\",\"flow_id\":1001,\"description\":\"低温甲醇洗的6塔（甲醇-水分离）和9塔（尾气洗涤）工艺流程\",\"inputs\":{\"global_physical_method\":\"SRK\",\"streams\":[{\"name\":\"31-89\",\"section\":\"methanol\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0.006249734},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.994},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":2.45e-297},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":2.12e-11},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":1.61e-15},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":1e-9},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":3.9e-12},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":27764.9,\"f_unit\":\"kg/h\",\"t\":95.05,\"t_unit\":\"C\",\"p\":0.3,\"p_unit\":\"MPa\"}},{\"name\":\"31-901\",\"section\":\"methanol\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0.030337456},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.969662544},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":6.97e-30},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":3.64e-42},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":1.5e-23},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":5.19e-24},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":10857.1,\"f_unit\":\"kg/h\",\"t\":95.44,\"t_unit\":\"C\",\"p\":0.15,\"p_unit\":\"MPa\"}},{\"name\":\"31-891\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-90\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-95\",\"section\":\"methanol\",\"type\":\"内部\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0.98778741},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.000842},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":8.46e-9},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":3.65e-7},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0.0111},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":2.49e-7},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0.000227753},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":4.16e-7},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":6.65e-7},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":13933.5,\"f_unit\":\"kg/h\",\"t\":117.703,\"t_unit\":\"C\",\"p\":0.6,\"p_unit\":\"MPa\"}},{\"name\":\"31-99o\",\"type\":\"出料\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"V\",\"rule\":\"D\"}},{\"name\":\"31-91\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"B\"}},{\"name\":\"31-60\",\"section\":\"gas\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.00010801},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0.000140013},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0.000360033},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0.735937706},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0.00009},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0.263344228},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":0.00001},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":0.00001},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"V\",\"f\":375063,\"f_unit\":\"kg/h\",\"t\":30.5,\"t_unit\":\"C\",\"p\":0.105,\"p_unit\":\"MPa\"}},{\"name\":\"31-100\",\"section\":\"gas\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.00027},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0.00001},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0.00026},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0.99931},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0.00015},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":0},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":0},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"V\",\"f\":49761.5,\"f_unit\":\"kg/h\",\"t\":30.5,\"t_unit\":\"C\",\"p\":0.1,\"p_unit\":\"MPa\"}},{\"name\":\"31-94A\",\"section\":\"gas\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":1},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":0},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":0},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":8041.83,\"f_unit\":\"kg/h\",\"t\":25.2,\"t_unit\":\"C\",\"p\":0.15,\"p_unit\":\"MPa\"}},{\"name\":\"31-94B\",\"section\":\"gas\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":1},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":0},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":0},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":8052.5,\"f_unit\":\"kg/h\",\"t\":25.2,\"t_unit\":\"C\",\"p\":0.15,\"p_unit\":\"MPa\"}},{\"name\":\"S1\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S6\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S11\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S12\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S2\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S5\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-60100\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-6010A\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-6010B\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-94AS11\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-94BS12\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"IMPURE\",\"type\":\"出料\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"type\":\"出料\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-61A\",\"type\":\"出料\",\"materials\":[],\"params\":{\"physical_method\":\"NRTL-RK\",\"mode\":\"TP\",\"phase\":\"V\",\"rule\":\"D\"}},{\"name\":\"31-61B\",\"type\":\"出料\",\"materials\":[],\"params\":{\"physical_method\":\"NRTL-RK\",\"mode\":\"TP\",\"phase\":\"V\",\"rule\":\"D\"}},{\"name\":\"31-95A\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"NRTL-RK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"B\"}},{\"name\":\"31-95B\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"NRTL-RK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"B\"}}],\"elements\":[{\"name\":\"B1\",\"section\":\"methanol\",\"type\":\"Pump\",\"physical_method\":\"SRK\",\"phase\":\"L\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-89\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-891\",\"rule\":\"M\"}],\"params\":{\"deltaP\":0.5,\"p_unit\":\"MPa\"}},{\"name\":\"P-109\",\"section\":\"methanol\",\"type\":\"Pump\",\"physical_method\":\"SRK\",\"phase\":\"L\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-901\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-90\",\"rule\":\"M\"}],\"params\":{\"deltaP\":0.15,\"p_unit\":\"MPa\"}},{\"name\":\"T-106\",\"section\":\"methanol\",\"type\":\"DistilStrict\",\"physical_method\":\"NRTL-RK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-891\",\"rule\":\"M\"},{\"name\":\"31-90\",\"rule\":\"M\"},{\"name\":\"31-95\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-99o\",\"rule\":\"D\"},{\"name\":\"31-91\",\"rule\":\"B\"}],\"params\":{\"type\":\"Distil\",\"N\":45,\"Ns\":[1,21,30],\"No\":[1,45],\"P_D\":0.3,\"pressure_drop\":0.03,\"p_unit\":\"MPa\",\"SPEC\":\"Partial\",\"eff\":[{\"start\":1,\"end\":45,\"value\":1}],\"murphree\":0,\"T_drop\":0,\"S1\":\"B\",\"S2\":\"QC\",\"V1\":12140.5,\"V1_unit\":\"kg/h\",\"V2\":0,\"V_list\":{\"NV\":[],\"W\":[]},\"L_list\":{\"NL\":[],\"U\":[]},\"Q_list\":{\"NQ\":[],\"QH\":[]},\"max_iter_outer\":1000,\"max_iter_inner\":30,\"max_notimproved_count\":100,\"max_inner_notconverged_count\":20,\"TOL\":0.00001,\"im_mode\":2,\"h\":1,\"D_col\":1.785,\"theta\":0.1,\"h_w\":0.0508,\"C_v\":0.7325,\"d_hole\":0.0127}},{\"name\":\"E128-A\",\"section\":\"heat\",\"type\":\"ShellAndTubeExchanger\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"S6\",\"rule\":\"M\"},{\"name\":\"31-91\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-95\",\"rule\":\"M\"},{\"name\":\"S1\",\"rule\":\"M\"}],\"params\":{\"type\":\"TEMA E\",\"UA\":2708.97463582,\"flow_type\":\"counter\",\"efficiency\":0.91,\"hot_out_T\":36.5,\"t_unit\":\"C\",\"stream_type\":{\"stream_in_cold\":1,\"stream_in_hot\":2,\"stream_out_cold\":1,\"stream_out_hot\":2}}},{\"name\":\"P-110\",\"section\":\"gas\",\"type\":\"Pump\",\"physical_method\":\"SRK\",\"phase\":\"L\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-95A\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"S2\",\"rule\":\"M\"}],\"params\":{\"p\":0.6,\"p_unit\":\"MPa\"}},{\"name\":\"P-111\",\"type\":\"Pump\",\"section\":\"gas\",\"physical_method\":\"SRK\",\"phase\":\"L\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-95B\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"S5\",\"rule\":\"M\"}],\"params\":{\"p\":0.6,\"p_unit\":\"MPa\"}},{\"name\":\"B14\",\"section\":\"gas\",\"type\":\"Splitter\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"S1\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"S11\",\"rule\":\"M\"},{\"name\":\"S12\",\"rule\":\"M\"},{\"name\":\"IMPURE\",\"rule\":\"M\"}],\"params\":{\"output_f\":[3000,3000,-1],\"f_unit\":\"kg/h\"}},{\"name\":\"B7\",\"section\":\"gas\",\"type\":\"Splitter\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-60100\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-6010A\",\"rule\":\"M\"},{\"name\":\"31-6010B\",\"rule\":\"M\"}],\"params\":{\"output_f\":[0.5,0.5],\"f_unit\":\"frac\"}},{\"name\":\"B6\",\"section\":\"gas\",\"type\":\"Mixer\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-60\",\"rule\":\"M\"},{\"name\":\"31-100\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-60100\",\"rule\":\"M\"}]},{\"name\":\"B11\",\"section\":\"gas\",\"type\":\"Mixer\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"S2\",\"rule\":\"M\"},{\"name\":\"S5\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"S6\",\"rule\":\"M\"}]},{\"name\":\"B12\",\"section\":\"gas\",\"type\":\"Mixer\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-94A\",\"rule\":\"M\"},{\"name\":\"S11\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-94AS11\",\"rule\":\"M\"}]},{\"name\":\"B13\",\"section\":\"gas\",\"type\":\"Mixer\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-94B\",\"rule\":\"M\"},{\"name\":\"S12\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-94BS12\",\"rule\":\"M\"}]},{\"name\":\"T-109A\",\"section\":\"gas\",\"type\":\"DistilStrict\",\"physical_method\":\"NRTL-RK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-94AS11\",\"rule\":\"M\"},{\"name\":\"31-6010A\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-61A\",\"rule\":\"D\"},{\"name\":\"31-95A\",\"rule\":\"B\"}],\"params\":{\"type\":\"Absorber\",\"N\":4,\"Ns\":[1,4],\"No\":[1,4],\"P_D\":0.09,\"pressure_drop\":0.01,\"p_unit\":\"MPa\",\"eff\":[{\"start\":1,\"end\":4,\"value\":0.1}],\"murphree\":1,\"V_list\":{\"NV\":[],\"W\":[]},\"L_list\":{\"NL\":[],\"U\":[]},\"Q_list\":{\"NQ\":[],\"QH\":[]},\"max_iter_outer\":1000,\"max_iter_inner\":30,\"max_notimproved_count\":100,\"max_inner_notconverged_count\":50,\"TOL\":0.00001,\"im_mode\":2,\"h\":1,\"D_col\":1.785,\"theta\":0.1,\"h_w\":0.0508,\"C_v\":0.7325,\"d_hole\":0.0127}},{\"name\":\"T-109B\",\"section\":\"gas\",\"type\":\"DistilStrict\",\"physical_method\":\"NRTL-RK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-94BS12\",\"rule\":\"M\"},{\"name\":\"31-6010B\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-61B\",\"rule\":\"D\"},{\"name\":\"31-95B\",\"rule\":\"B\"}],\"params\":{\"type\":\"Absorber\",\"N\":4,\"Ns\":[1,4],\"No\":[1,4],\"P_D\":0.09,\"pressure_drop\":0.01,\"p_unit\":\"MPa\",\"eff\":[{\"start\":1,\"end\":4,\"value\":0.1}],\"murphree\":1,\"V_list\":{\"NV\":[],\"W\":[]},\"L_list\":{\"NL\":[],\"U\":[]},\"Q_list\":{\"NQ\":[],\"QH\":[]},\"max_iter_outer\":1000,\"max_iter_inner\":30,\"max_notimproved_count\":100,\"max_inner_notconverged_count\":50,\"TOL\":0.00001,\"im_mode\":2,\"h\":1,\"D_col\":1.785,\"theta\":0.1,\"h_w\":0.0508,\"C_v\":0.7325,\"d_hole\":0.0127}}]}}",
        "status": "completed",
        "result_path": "/data/user/0/com.allenwuwang.T109T106cal/cache/calc_d6cf09b8-ed08-467e-b140-577a57b9f0a0.json",
        "tags": [
            "test"
        ],
        "created_at": "2026-03-01T17:58:16.226Z",
        "updated_at": "2026-03-01T17:59:13.684Z",
        "started_at": "2026-03-01T17:58:34.832Z",
        "finished_at": "2026-03-01T17:59:13.684Z",
        "rowIndex": 2,
        "selectVisable": false
    },
    {
        "id": 7,
        "name": "新计算任务4",
        "input_data": "{\"name\":\"Rectisol-Tower#6_#9\",\"flow_id\":1001,\"description\":\"低温甲醇洗的6塔（甲醇-水分离）和9塔（尾气洗涤）工艺流程\",\"inputs\":{\"global_physical_method\":\"SRK\",\"streams\":[{\"name\":\"31-89\",\"section\":\"methanol\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0.006249734},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.994},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":2.45e-297},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":2.12e-11},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":1.61e-15},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":1e-9},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":3.9e-12},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":27764.9,\"f_unit\":\"kg/h\",\"t\":95.05,\"t_unit\":\"C\",\"p\":0.3,\"p_unit\":\"MPa\"}},{\"name\":\"31-901\",\"section\":\"methanol\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0.030337456},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.969662544},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":6.97e-30},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":3.64e-42},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":1.5e-23},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":5.19e-24},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":10857.1,\"f_unit\":\"kg/h\",\"t\":95.44,\"t_unit\":\"C\",\"p\":0.15,\"p_unit\":\"MPa\"}},{\"name\":\"31-891\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-90\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-95\",\"section\":\"methanol\",\"type\":\"内部\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0.98778741},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.000842},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":8.46e-9},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":3.65e-7},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0.0111},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":2.49e-7},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0.000227753},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":4.16e-7},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":6.65e-7},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":13933.5,\"f_unit\":\"kg/h\",\"t\":117.703,\"t_unit\":\"C\",\"p\":0.6,\"p_unit\":\"MPa\"}},{\"name\":\"31-99o\",\"type\":\"出料\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"V\",\"rule\":\"D\"}},{\"name\":\"31-91\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"B\"}},{\"name\":\"31-60\",\"section\":\"gas\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.00010801},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0.000140013},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0.000360033},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0.735937706},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0.00009},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0.263344228},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":0.00001},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":0.00001},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"V\",\"f\":375063,\"f_unit\":\"kg/h\",\"t\":30.5,\"t_unit\":\"C\",\"p\":0.105,\"p_unit\":\"MPa\"}},{\"name\":\"31-100\",\"section\":\"gas\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":0},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0.00027},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0.00001},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0.00026},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0.99931},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0.00015},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":0},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":0},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"V\",\"f\":49761.5,\"f_unit\":\"kg/h\",\"t\":30.5,\"t_unit\":\"C\",\"p\":0.1,\"p_unit\":\"MPa\"}},{\"name\":\"31-94A\",\"section\":\"gas\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":1},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":0},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":0},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":8041.83,\"f_unit\":\"kg/h\",\"t\":25.2,\"t_unit\":\"C\",\"p\":0.15,\"p_unit\":\"MPa\"}},{\"name\":\"31-94B\",\"section\":\"gas\",\"type\":\"进料\",\"materials\":[{\"cas\":\"7732-18-5\",\"name\":\"H2O\",\"molar_frac\":1},{\"cas\":\"67-56-1\",\"name\":\"MEOH\",\"molar_frac\":0},{\"cas\":\"1333-74-0\",\"name\":\"H2\",\"molar_frac\":0},{\"cas\":\"630-08-0\",\"name\":\"CO\",\"molar_frac\":0},{\"cas\":\"124-38-9\",\"name\":\"CO2\",\"molar_frac\":0},{\"cas\":\"74-82-8\",\"name\":\"CH4\",\"molar_frac\":0},{\"cas\":\"7727-37-9\",\"name\":\"N2\",\"molar_frac\":0},{\"cas\":\"7664-41-7\",\"name\":\"NH3\",\"molar_frac\":0},{\"cas\":\"74-90-8\",\"name\":\"HCN\",\"molar_frac\":0},{\"cas\":\"7783-06-4\",\"name\":\"H2S\",\"molar_frac\":0},{\"cas\":\"463-58-1\",\"name\":\"COS\",\"molar_frac\":0},{\"cas\":\"7440-37-1\",\"name\":\"AR\",\"molar_frac\":0}],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"f\":8052.5,\"f_unit\":\"kg/h\",\"t\":25.2,\"t_unit\":\"C\",\"p\":0.15,\"p_unit\":\"MPa\"}},{\"name\":\"S1\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S6\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S11\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S12\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S2\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"S5\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-60100\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-6010A\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-6010B\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-94AS11\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-94BS12\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"IMPURE\",\"type\":\"出料\",\"materials\":[],\"params\":{\"physical_method\":\"SRK\",\"type\":\"出料\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"M\"}},{\"name\":\"31-61A\",\"type\":\"出料\",\"materials\":[],\"params\":{\"physical_method\":\"NRTL-RK\",\"mode\":\"TP\",\"phase\":\"V\",\"rule\":\"D\"}},{\"name\":\"31-61B\",\"type\":\"出料\",\"materials\":[],\"params\":{\"physical_method\":\"NRTL-RK\",\"mode\":\"TP\",\"phase\":\"V\",\"rule\":\"D\"}},{\"name\":\"31-95A\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"NRTL-RK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"B\"}},{\"name\":\"31-95B\",\"type\":\"内部\",\"materials\":[],\"params\":{\"physical_method\":\"NRTL-RK\",\"mode\":\"TP\",\"phase\":\"L\",\"rule\":\"B\"}}],\"elements\":[{\"name\":\"B1\",\"section\":\"methanol\",\"type\":\"Pump\",\"physical_method\":\"SRK\",\"phase\":\"L\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-89\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-891\",\"rule\":\"M\"}],\"params\":{\"deltaP\":0.5,\"p_unit\":\"MPa\"}},{\"name\":\"P-109\",\"section\":\"methanol\",\"type\":\"Pump\",\"physical_method\":\"SRK\",\"phase\":\"L\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-901\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-90\",\"rule\":\"M\"}],\"params\":{\"deltaP\":0.15,\"p_unit\":\"MPa\"}},{\"name\":\"T-106\",\"section\":\"methanol\",\"type\":\"DistilStrict\",\"physical_method\":\"NRTL-RK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-891\",\"rule\":\"M\"},{\"name\":\"31-90\",\"rule\":\"M\"},{\"name\":\"31-95\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-99o\",\"rule\":\"D\"},{\"name\":\"31-91\",\"rule\":\"B\"}],\"params\":{\"type\":\"Distil\",\"N\":45,\"Ns\":[1,21,30],\"No\":[1,45],\"P_D\":0.3,\"pressure_drop\":0.03,\"p_unit\":\"MPa\",\"SPEC\":\"Partial\",\"eff\":[{\"start\":1,\"end\":45,\"value\":1}],\"murphree\":0,\"T_drop\":0,\"S1\":\"B\",\"S2\":\"QC\",\"V1\":12140.5,\"V1_unit\":\"kg/h\",\"V2\":0,\"V_list\":{\"NV\":[],\"W\":[]},\"L_list\":{\"NL\":[],\"U\":[]},\"Q_list\":{\"NQ\":[],\"QH\":[]},\"max_iter_outer\":1000,\"max_iter_inner\":30,\"max_notimproved_count\":100,\"max_inner_notconverged_count\":20,\"TOL\":0.00001,\"im_mode\":2,\"h\":1,\"D_col\":1.785,\"theta\":0.1,\"h_w\":0.0508,\"C_v\":0.7325,\"d_hole\":0.0127}},{\"name\":\"E128-A\",\"section\":\"heat\",\"type\":\"ShellAndTubeExchanger\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"S6\",\"rule\":\"M\"},{\"name\":\"31-91\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-95\",\"rule\":\"M\"},{\"name\":\"S1\",\"rule\":\"M\"}],\"params\":{\"type\":\"TEMA E\",\"UA\":2708.97463582,\"flow_type\":\"counter\",\"efficiency\":0.91,\"hot_out_T\":36.5,\"t_unit\":\"C\",\"stream_type\":{\"stream_in_cold\":1,\"stream_in_hot\":2,\"stream_out_cold\":1,\"stream_out_hot\":2}}},{\"name\":\"P-110\",\"section\":\"gas\",\"type\":\"Pump\",\"physical_method\":\"SRK\",\"phase\":\"L\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-95A\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"S2\",\"rule\":\"M\"}],\"params\":{\"p\":0.6,\"p_unit\":\"MPa\"}},{\"name\":\"P-111\",\"type\":\"Pump\",\"section\":\"gas\",\"physical_method\":\"SRK\",\"phase\":\"L\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-95B\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"S5\",\"rule\":\"M\"}],\"params\":{\"p\":0.6,\"p_unit\":\"MPa\"}},{\"name\":\"B14\",\"section\":\"gas\",\"type\":\"Splitter\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"S1\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"S11\",\"rule\":\"M\"},{\"name\":\"S12\",\"rule\":\"M\"},{\"name\":\"IMPURE\",\"rule\":\"M\"}],\"params\":{\"output_f\":[3000,3000,-1],\"f_unit\":\"kg/h\"}},{\"name\":\"B7\",\"section\":\"gas\",\"type\":\"Splitter\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-60100\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-6010A\",\"rule\":\"M\"},{\"name\":\"31-6010B\",\"rule\":\"M\"}],\"params\":{\"output_f\":[0.5,0.5],\"f_unit\":\"frac\"}},{\"name\":\"B6\",\"section\":\"gas\",\"type\":\"Mixer\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-60\",\"rule\":\"M\"},{\"name\":\"31-100\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-60100\",\"rule\":\"M\"}]},{\"name\":\"B11\",\"section\":\"gas\",\"type\":\"Mixer\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"S2\",\"rule\":\"M\"},{\"name\":\"S5\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"S6\",\"rule\":\"M\"}]},{\"name\":\"B12\",\"section\":\"gas\",\"type\":\"Mixer\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-94A\",\"rule\":\"M\"},{\"name\":\"S11\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-94AS11\",\"rule\":\"M\"}]},{\"name\":\"B13\",\"section\":\"gas\",\"type\":\"Mixer\",\"physical_method\":\"SRK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-94B\",\"rule\":\"M\"},{\"name\":\"S12\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-94BS12\",\"rule\":\"M\"}]},{\"name\":\"T-109A\",\"section\":\"gas\",\"type\":\"DistilStrict\",\"physical_method\":\"NRTL-RK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-94AS11\",\"rule\":\"M\"},{\"name\":\"31-6010A\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-61A\",\"rule\":\"D\"},{\"name\":\"31-95A\",\"rule\":\"B\"}],\"params\":{\"type\":\"Absorber\",\"N\":4,\"Ns\":[1,4],\"No\":[1,4],\"P_D\":0.09,\"pressure_drop\":0.01,\"p_unit\":\"MPa\",\"eff\":[{\"start\":1,\"end\":4,\"value\":0.1}],\"murphree\":1,\"V_list\":{\"NV\":[],\"W\":[]},\"L_list\":{\"NL\":[],\"U\":[]},\"Q_list\":{\"NQ\":[],\"QH\":[]},\"max_iter_outer\":1000,\"max_iter_inner\":30,\"max_notimproved_count\":100,\"max_inner_notconverged_count\":50,\"TOL\":0.00001,\"im_mode\":2,\"h\":1,\"D_col\":1.785,\"theta\":0.1,\"h_w\":0.0508,\"C_v\":0.7325,\"d_hole\":0.0127}},{\"name\":\"T-109B\",\"section\":\"gas\",\"type\":\"DistilStrict\",\"physical_method\":\"NRTL-RK\",\"phase\":\"VL\",\"mode\":\"TP\",\"inputStreams\":[{\"name\":\"31-94BS12\",\"rule\":\"M\"},{\"name\":\"31-6010B\",\"rule\":\"M\"}],\"outputStreams\":[{\"name\":\"31-61B\",\"rule\":\"D\"},{\"name\":\"31-95B\",\"rule\":\"B\"}],\"params\":{\"type\":\"Absorber\",\"N\":4,\"Ns\":[1,4],\"No\":[1,4],\"P_D\":0.09,\"pressure_drop\":0.01,\"p_unit\":\"MPa\",\"eff\":[{\"start\":1,\"end\":4,\"value\":0.1}],\"murphree\":1,\"V_list\":{\"NV\":[],\"W\":[]},\"L_list\":{\"NL\":[],\"U\":[]},\"Q_list\":{\"NQ\":[],\"QH\":[]},\"max_iter_outer\":1000,\"max_iter_inner\":30,\"max_notimproved_count\":100,\"max_inner_notconverged_count\":50,\"TOL\":0.00001,\"im_mode\":2,\"h\":1,\"D_col\":1.785,\"theta\":0.1,\"h_w\":0.0508,\"C_v\":0.7325,\"d_hole\":0.0127}}]}}",
        "status": "completed",
        "result_path": "/data/user/0/com.allenwuwang.T109T106cal/cache/calc_d6cf09b8-ed08-467e-b140-577a57b9f0a0.json",
        "tags": [
            "test"
        ],
        "created_at": "2026-03-01T17:58:16.226Z",
        "updated_at": "2026-03-01T17:59:13.684Z",
        "started_at": "2026-03-01T17:58:34.832Z",
        "finished_at": "2026-03-01T17:59:13.684Z",
        "rowIndex": 3,
        "selectVisable": false
    }
];
// 临时结果数据
export const tempResult:any = {
    "response": {
        "streams": [
            {
                "name": "31-100",
                "type": "进料",
                "phase": "V",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 1130999.888661736,
                "f_kg_per_h": 49761.5,
                "T_K": 303.65,
                "T_C": 30.5,
                "P_Pa": 100000.0,
                "P_bar": 1.0,
                "P_KPa": 100.0,
                "P_MPa": 0.1,
                "P_atm": 0.9869232667160128,
                "molar_frac": [
                    0.0,
                    0.00027,
                    1e-05,
                    0.00026,
                    0.99931,
                    0.00015,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ],
                "mass_frac": [
                    0.0,
                    0.0001966322043340738,
                    4.581775178713304e-07,
                    0.00016552429917016925,
                    0.9995826913494217,
                    5.4693969556264226e-05,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ],
                "vf": 1.0,
                "H": 166.27970519096584,
                "extra": null,
                "f_nm3_per_h": 25348.78657048352
            },
            {
                "name": "31-60",
                "type": "进料",
                "phase": "V",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 9427992.43109182,
                "f_kg_per_h": 375063.0,
                "T_K": 303.65,
                "T_C": 30.5,
                "P_Pa": 105000.0,
                "P_bar": 1.05,
                "P_KPa": 105.0,
                "P_MPa": 0.105,
                "P_atm": 1.0362694300518134,
                "molar_frac": [
                    0.0,
                    0.00010801,
                    0.000140013,
                    0.000360033,
                    0.735937706,
                    9e-05,
                    0.263344228,
                    0.0,
                    0.0,
                    1e-05,
                    1e-05,
                    0.0
                ],
                "mass_frac": [
                    0.0,
                    8.699629499561526e-05,
                    7.094928836507285e-06,
                    0.00025349921949257236,
                    0.8141519288396692,
                    3.6294147711104424e-05,
                    0.1854405184955137,
                    0.0,
                    0.0,
                    8.56694160442623e-06,
                    1.5101132176753244e-05,
                    0.0
                ],
                "vf": 1.0,
                "H": 164.1342366055326,
                "extra": null,
                "f_nm3_per_h": 211306.9774097548
            },
            {
                "name": "31-60100",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 10558992.319753557,
                "f_kg_per_h": 424824.50004257506,
                "T_K": 303.61293334799615,
                "T_C": 30.46293334799617,
                "P_Pa": 100000.0,
                "P_bar": 1.0,
                "P_KPa": 100.0,
                "P_MPa": 0.1,
                "P_atm": 0.9869232667160128,
                "molar_frac": [
                    0.0,
                    0.00012536115229136097,
                    0.00012608698583271833,
                    0.0003493182200756744,
                    0.7641481732694156,
                    9.642674985981948e-05,
                    0.23513677587203174,
                    0.0,
                    0.0,
                    8.928875246585308e-06,
                    8.928875246585308e-06,
                    0.0
                ],
                "mass_frac": [
                    0.0,
                    9.983841533168757e-05,
                    6.317537928831272e-06,
                    0.00024319434292289938,
                    0.8358722226788754,
                    3.844939709721907e-05,
                    0.1637190818962037,
                    0.0,
                    0.0,
                    7.56345929958659e-06,
                    1.3332272340637752e-05,
                    0.0
                ],
                "vf": 1.0,
                "H": 164.36404307358583,
                "extra": null,
                "f_m3_per_h": 502.16263438752804,
                "f_l_per_h": 502162.63438752806
            },
            {
                "name": "31-6010A",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 5279496.159876779,
                "f_kg_per_h": 212412.25002128753,
                "T_K": 303.61293334799615,
                "T_C": 30.46293334799617,
                "P_Pa": 100000.0,
                "P_bar": 1.0,
                "P_KPa": 100.0,
                "P_MPa": 0.1,
                "P_atm": 0.9869232667160128,
                "molar_frac": [
                    0.0,
                    0.00012536115229136097,
                    0.00012608698583271833,
                    0.0003493182200756744,
                    0.7641481732694156,
                    9.642674985981948e-05,
                    0.23513677587203174,
                    0.0,
                    0.0,
                    8.928875246585308e-06,
                    8.928875246585308e-06,
                    0.0
                ],
                "mass_frac": [
                    0.0,
                    9.983841533168757e-05,
                    6.317537928831272e-06,
                    0.00024319434292289938,
                    0.8358722226788754,
                    3.844939709721907e-05,
                    0.1637190818962037,
                    0.0,
                    0.0,
                    7.56345929958659e-06,
                    1.3332272340637752e-05,
                    0.0
                ],
                "vf": 1.0,
                "H": 164.36404307358583,
                "extra": null,
                "f_m3_per_h": 251.08131719376402,
                "f_l_per_h": 251081.31719376403
            },
            {
                "name": "31-6010B",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 5279496.159876779,
                "f_kg_per_h": 212412.25002128753,
                "T_K": 303.61293334799615,
                "T_C": 30.46293334799617,
                "P_Pa": 100000.0,
                "P_bar": 1.0,
                "P_KPa": 100.0,
                "P_MPa": 0.1,
                "P_atm": 0.9869232667160128,
                "molar_frac": [
                    0.0,
                    0.00012536115229136097,
                    0.00012608698583271833,
                    0.0003493182200756744,
                    0.7641481732694156,
                    9.642674985981948e-05,
                    0.23513677587203174,
                    0.0,
                    0.0,
                    8.928875246585308e-06,
                    8.928875246585308e-06,
                    0.0
                ],
                "mass_frac": [
                    0.0,
                    9.983841533168757e-05,
                    6.317537928831272e-06,
                    0.00024319434292289938,
                    0.8358722226788754,
                    3.844939709721907e-05,
                    0.1637190818962037,
                    0.0,
                    0.0,
                    7.56345929958659e-06,
                    1.3332272340637752e-05,
                    0.0
                ],
                "vf": 1.0,
                "H": 164.36404307358583,
                "extra": null,
                "f_m3_per_h": 251.08131719376402,
                "f_l_per_h": 251081.31719376403
            },
            {
                "name": "31-61A",
                "type": "出料",
                "phase": "V",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 5347315.888814567,
                "f_kg_per_h": 213473.51093511755,
                "T_K": 280.79788810627855,
                "T_C": 7.647888106278572,
                "P_Pa": 90000.0,
                "P_bar": 0.9,
                "P_KPa": 90.0,
                "P_MPa": 0.09,
                "P_atm": 0.8882309400444115,
                "molar_frac": [
                    0.013867370665023306,
                    7.061334536571036e-05,
                    0.0001244851058439583,
                    0.00034486978801307367,
                    0.7533336263811035,
                    9.519887229053123e-05,
                    0.2321463157020703,
                    0.0,
                    0.0,
                    8.77265598816789e-06,
                    8.747484301640001e-06,
                    0.0
                ],
                "mass_frac": [
                    0.006257876502319412,
                    5.667616022398877e-05,
                    6.2859933418926515e-06,
                    0.0002419726654524012,
                    0.8304788868945499,
                    3.8256280048821665e-05,
                    0.16289939288931726,
                    0.0,
                    0.0,
                    7.489171000887874e-06,
                    1.3163443745222744e-05,
                    0.0
                ],
                "vf": 0.994172292409253,
                "H": -915.2308385166693,
                "extra": null,
                "f_nm3_per_h": 119847.90674993256
            },
            {
                "name": "31-61B",
                "type": "出料",
                "phase": "V",
                "mode": "TP",
                "physical_method": "NRTL",
                "f_mol_per_h": 5347304.982680576,
                "f_kg_per_h": 213473.06016389112,
                "T_K": 280.7926997619971,
                "T_C": 7.6426997619971075,
                "P_Pa": 90000.0,
                "P_bar": 0.9,
                "P_KPa": 90.0,
                "P_MPa": 0.09,
                "P_atm": 0.8882309400444115,
                "molar_frac": [
                    0.013867213590652926,
                    7.056068198567055e-05,
                    0.00012448536036467492,
                    0.0003448704866488775,
                    0.7533333624142902,
                    9.519906120472074e-05,
                    0.23214678840621286,
                    0.0,
                    0.0,
                    8.772605381493399e-06,
                    8.747393257865396e-06,
                    0.0
                ],
                "mass_frac": [
                    0.0062578060708293965,
                    5.663389526664114e-05,
                    6.286006647062905e-06,
                    0.0002419731730737561,
                    0.8304786557319962,
                    3.825635872156886e-05,
                    0.16289973632743915,
                    0.0,
                    0.0,
                    7.4891283378221045e-06,
                    1.3163307688577232e-05,
                    0.0
                ],
                "vf": 0.9941693799097683,
                "H": -915.5523259771735,
                "extra": null,
                "f_nm3_per_h": 119847.66231377865
            },
            {
                "name": "31-89",
                "type": "进料",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 868888.0968060605,
                "f_kg_per_h": 27764.900000000012,
                "T_K": 368.2,
                "T_C": 95.05000000000001,
                "P_Pa": 300000.0,
                "P_bar": 3.0,
                "P_KPa": 300.0,
                "P_MPa": 0.3,
                "P_atm": 2.9607698001480385,
                "molar_frac": [
                    0.006248173612206117,
                    0.9937518253629481,
                    0.0,
                    2.4493883019509287e-297,
                    2.1194706939330483e-11,
                    0.0,
                    1.6095980269963245e-15,
                    0.0,
                    0.0,
                    9.997503273269098e-10,
                    3.899026276574948e-12,
                    0.0
                ],
                "mass_frac": [
                    0.0035225878997090384,
                    0.9964774109974915,
                    0.0,
                    2.147062487591491e-297,
                    2.919070237654825e-11,
                    0.0,
                    1.4110778921580105e-15,
                    0.0,
                    0.0,
                    1.0662771173638e-09,
                    7.330243449348544e-12,
                    0.0
                ],
                "vf": 1.0,
                "H": 2853.459075300241,
                "extra": null,
                "f_m3_per_h": 35.28339001997973,
                "f_l_per_h": 35283.39001997973
            },
            {
                "name": "31-891",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 868888.0968060605,
                "f_kg_per_h": 27764.900000000012,
                "T_K": 368.2,
                "T_C": 95.05000000000001,
                "P_Pa": 800000.0,
                "P_bar": 8.0,
                "P_KPa": 800.0,
                "P_MPa": 0.8,
                "P_atm": 7.895386133728103,
                "molar_frac": [
                    0.006248173612206117,
                    0.9937518253629481,
                    0.0,
                    2.4493883019509287e-297,
                    2.1194706939330483e-11,
                    0.0,
                    1.6095980269963245e-15,
                    0.0,
                    0.0,
                    9.997503273269098e-10,
                    3.899026276574948e-12,
                    0.0
                ],
                "mass_frac": [
                    0.0035225878997090384,
                    0.9964774109974915,
                    0.0,
                    2.147062487591491e-297,
                    2.919070237654825e-11,
                    0.0,
                    1.4110778921580105e-15,
                    0.0,
                    0.0,
                    1.0662771173638e-09,
                    7.330243449348544e-12,
                    0.0
                ],
                "vf": 0.0,
                "H": -32874.67308504859,
                "extra": null,
                "f_m3_per_h": 35.28339001997973,
                "f_l_per_h": 35283.39001997973
            },
            {
                "name": "31-90",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 343398.50212149404,
                "f_kg_per_h": 10857.1,
                "T_K": 368.59,
                "T_C": 95.44,
                "P_Pa": 300000.0,
                "P_bar": 3.0,
                "P_KPa": 300.0,
                "P_MPa": 0.3,
                "P_atm": 2.9607698001480385,
                "molar_frac": [
                    0.030337456,
                    0.969662544,
                    0.0,
                    0.0,
                    6.97e-30,
                    0.0,
                    3.64e-42,
                    0.0,
                    0.0,
                    1.5e-23,
                    5.19e-24,
                    0.0
                ],
                "mass_frac": [
                    0.017286407016878856,
                    0.9827135929831211,
                    0.0,
                    0.0,
                    9.702122003915014e-30,
                    0.0,
                    3.2251637123690625e-42,
                    0.0,
                    0.0,
                    1.6169128694102087e-23,
                    9.86157810570103e-24,
                    0.0
                ],
                "vf": 1.0,
                "H": 2856.6253265695555,
                "extra": null,
                "f_m3_per_h": 13.756942142378966,
                "f_l_per_h": 13756.942142378968
            },
            {
                "name": "31-901",
                "type": "进料",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 343398.50212149404,
                "f_kg_per_h": 10857.1,
                "T_K": 368.59,
                "T_C": 95.44,
                "P_Pa": 150000.0,
                "P_bar": 1.5,
                "P_KPa": 150.0,
                "P_MPa": 0.15,
                "P_atm": 1.4803849000740192,
                "molar_frac": [
                    0.030337456,
                    0.969662544,
                    0.0,
                    0.0,
                    6.97e-30,
                    0.0,
                    3.64e-42,
                    0.0,
                    0.0,
                    1.5e-23,
                    5.19e-24,
                    0.0
                ],
                "mass_frac": [
                    0.017286407016878856,
                    0.9827135929831211,
                    0.0,
                    0.0,
                    9.702122003915014e-30,
                    0.0,
                    3.2251637123690625e-42,
                    0.0,
                    0.0,
                    1.6169128694102087e-23,
                    9.86157810570103e-24,
                    0.0
                ],
                "vf": 1.0,
                "H": 3055.050214594887,
                "extra": null,
                "f_m3_per_h": 13.756942142378966,
                "f_l_per_h": 13756.942142378968
            },
            {
                "name": "31-91",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 673900.1558676785,
                "f_kg_per_h": 12140.5,
                "T_K": 409.952203858855,
                "T_C": 136.80220385885502,
                "P_Pa": 330000.0,
                "P_bar": 3.3,
                "P_KPa": 330.0,
                "P_MPa": 0.33,
                "P_atm": 3.2568467801628422,
                "molar_frac": [
                    0.9999999999999865,
                    1.3627390633309484e-14,
                    8.500134079923263e-226,
                    7.899415431664823e-139,
                    2.0953714572944993e-45,
                    7.197414892989935e-87,
                    1.524880246470609e-128,
                    0.0,
                    0.0,
                    2.336667459409309e-31,
                    2.2175933992634506e-28,
                    0.0
                ],
                "mass_frac": [
                    0.9999999999999758,
                    2.423781540198094e-14,
                    9.51150927936481e-227,
                    1.2282117513971584e-138,
                    5.11881462631935e-45,
                    6.409359152267518e-87,
                    2.3711582776664755e-128,
                    0.0,
                    0.0,
                    4.420452154173162e-31,
                    7.394952796742005e-28,
                    0.0
                ],
                "vf": 0.0,
                "H": -37253.01656574104,
                "extra": null,
                "f_m3_per_h": 12.176444548368208,
                "f_l_per_h": 12176.444548368207
            },
            {
                "name": "31-94A",
                "type": "进料",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 446389.3983329707,
                "f_kg_per_h": 8041.83,
                "T_K": 298.34999999999997,
                "T_C": 25.19999999999999,
                "P_Pa": 150000.0,
                "P_bar": 1.5,
                "P_KPa": 150.0,
                "P_MPa": 0.15,
                "P_atm": 1.4803849000740192,
                "molar_frac": [
                    1.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ],
                "mass_frac": [
                    1.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ],
                "vf": 0.0,
                "H": -47010.32730118505,
                "extra": null,
                "f_m3_per_h": 8.065639558700488,
                "f_l_per_h": 8065.639558700487
            },
            {
                "name": "31-94AS11",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 446389.3983329707,
                "f_kg_per_h": 8041.83,
                "T_K": 298.34999999999997,
                "T_C": 25.19999999999999,
                "P_Pa": 150000.0,
                "P_bar": 1.5,
                "P_KPa": 150.0,
                "P_MPa": 0.15,
                "P_atm": 1.4803849000740192,
                "molar_frac": [
                    1.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ],
                "mass_frac": [
                    1.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ],
                "vf": 0.0,
                "H": -47010.32730118505,
                "extra": null,
                "f_m3_per_h": 8.065639558700488,
                "f_l_per_h": 8065.639558700487
            },
            {
                "name": "31-94B",
                "type": "进料",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 446981.67333508,
                "f_kg_per_h": 8052.5,
                "T_K": 298.34999999999997,
                "T_C": 25.19999999999999,
                "P_Pa": 150000.0,
                "P_bar": 1.5,
                "P_KPa": 150.0,
                "P_MPa": 0.15,
                "P_atm": 1.4803849000740192,
                "molar_frac": [
                    1.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ],
                "mass_frac": [
                    1.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ],
                "vf": 0.0,
                "H": -47010.32730118505,
                "extra": null,
                "f_m3_per_h": 8.076341149518912,
                "f_l_per_h": 8076.341149518911
            },
            {
                "name": "31-94BS12",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 446981.67333508,
                "f_kg_per_h": 8052.5,
                "T_K": 298.34999999999997,
                "T_C": 25.19999999999999,
                "P_Pa": 150000.0,
                "P_bar": 1.5,
                "P_KPa": 150.0,
                "P_MPa": 0.15,
                "P_atm": 1.4803849000740192,
                "molar_frac": [
                    1.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ],
                "mass_frac": [
                    1.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0,
                    0.0
                ],
                "vf": 0.0,
                "H": -47010.32730118505,
                "extra": null,
                "f_m3_per_h": 8.076341149518912,
                "f_l_per_h": 8076.341149518911
            },
            {
                "name": "31-95",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 757742.5199264601,
                "f_kg_per_h": 13973.673712857119,
                "T_K": 366.44004035452997,
                "T_C": 93.29004035452999,
                "P_Pa": 600000.0,
                "P_bar": 6.0,
                "P_KPa": 600.0,
                "P_MPa": 0.6,
                "P_atm": 5.921539600296077,
                "molar_frac": [
                    0.9832698190286006,
                    0.000750593420105316,
                    3.523644076007629e-16,
                    6.191994037038531e-10,
                    0.015977433466563242,
                    4.4529996210098775e-08,
                    5.307604261617808e-07,
                    0.0,
                    0.0,
                    6.113025519796964e-07,
                    9.66872556682257e-07,
                    0.0
                ],
                "mass_frac": [
                    0.9605606358258708,
                    0.001304180184647439,
                    3.85183583846977e-17,
                    9.405045478159371e-10,
                    0.03813005857040089,
                    3.873850036171262e-08,
                    8.062605609937238e-07,
                    0.0,
                    0.0,
                    1.1297388628051354e-06,
                    3.1497406519520657e-06,
                    0.0
                ],
                "vf": 0.017779880356023455,
                "H": -40280.02993240851,
                "extra": null,
                "f_m3_per_h": 14.06218907839607,
                "f_l_per_h": 14062.189078396072
            },
            {
                "name": "31-95A",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "NRTL",
                "f_mol_per_h": 378569.66939517955,
                "f_kg_per_h": 6981.276446260078,
                "T_K": 285.0626424199146,
                "T_C": 11.912642419914619,
                "P_Pa": 100000.0,
                "P_bar": 1.0,
                "P_KPa": 100.0,
                "P_MPa": 0.1,
                "P_atm": 0.9869232667160128,
                "molar_frac": [
                    0.9832695854505449,
                    0.0007508185139040463,
                    3.5236474705011914e-16,
                    6.192001312242123e-10,
                    0.015977441949244792,
                    4.453003460003864e-08,
                    5.307609873968187e-07,
                    0.0,
                    0.0,
                    6.113029164639786e-07,
                    9.668731674031004e-07,
                    0.0
                ],
                "mass_frac": [
                    0.9605602316949888,
                    0.0013045710533946995,
                    3.8518388435781814e-17,
                    9.40505480575651e-10,
                    0.03813007182992464,
                    3.8738526662920365e-08,
                    8.062612658630139e-07,
                    0.0,
                    0.0,
                    1.1297393294666743e-06,
                    3.1497420645284497e-06,
                    0.0
                ],
                "vf": 0.016124252865161406,
                "H": -47381.24733549748,
                "extra": null,
                "f_m3_per_h": 7.025499647728953,
                "f_l_per_h": 7025.499647728952
            },
            {
                "name": "31-95B",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "NRTL",
                "f_mol_per_h": 379172.85053128056,
                "f_kg_per_h": 6992.397266597039,
                "T_K": 285.062676505771,
                "T_C": 11.912676505771003,
                "P_Pa": 100000.0,
                "P_bar": 1.0,
                "P_KPa": 100.0,
                "P_MPa": 0.1,
                "P_atm": 0.9869232667160128,
                "molar_frac": [
                    0.9832700522350848,
                    0.0007503686843816246,
                    3.523640686913964e-16,
                    6.191986773408198e-10,
                    0.01597742499737578,
                    4.452995788122892e-08,
                    5.307598658195451e-07,
                    0.0,
                    0.0,
                    6.113021880752293e-07,
                    9.66871946932937e-07,
                    0.0
                ],
                "mass_frac": [
                    0.9605610393140172,
                    0.00130378993754408,
                    3.8518328381407325e-17,
                    9.405036165396994e-10,
                    0.038130045331965304,
                    3.873847410233477e-08,
                    8.062598572454694e-07,
                    0.0,
                    0.0,
                    1.1297383968857835e-06,
                    3.1497392416222673e-06,
                    0.0
                ],
                "vf": 0.01612421138283366,
                "H": -47381.254031678785,
                "extra": null,
                "f_m3_per_h": 7.03668943066712,
                "f_l_per_h": 7036.689430667119
            },
            {
                "name": "31-99o",
                "type": "出料",
                "phase": "V",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 1296128.9629863354,
                "f_kg_per_h": 40455.18758911145,
                "T_K": 370.03583030832,
                "T_C": 96.88583030832001,
                "P_Pa": 300000.0,
                "P_bar": 3.0,
                "P_KPa": 300.0,
                "P_MPa": 0.3,
                "P_atm": 2.9607698001480385,
                "molar_frac": [
                    0.0671314434382207,
                    0.923526572245217,
                    2.0599921622688005e-16,
                    3.6199632455187507e-10,
                    0.009340724323341282,
                    2.6033119832301738e-08,
                    3.102931045855325e-07,
                    0.0,
                    0.0,
                    3.5804968712177696e-07,
                    5.652553121806572e-07,
                    0.0
                ],
                "mass_frac": [
                    0.038747260082885454,
                    0.9480804177619412,
                    1.3304674077822413e-17,
                    3.2486091848475485e-10,
                    0.013170551041350438,
                    1.338071436478249e-08,
                    2.784914993135219e-07,
                    0.0,
                    0.0,
                    3.9095619093459466e-07,
                    1.087960557518176e-06,
                    0.0
                ],
                "vf": 1.0,
                "H": 2902.0739232711235,
                "extra": null,
                "f_nm3_per_h": 29049.77867808548
            },
            {
                "name": "IMPURE",
                "type": "出料",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 673900.1558676756,
                "f_kg_per_h": 12140.5,
                "T_K": 309.65,
                "T_C": 36.5,
                "P_Pa": 330000.0,
                "P_bar": 3.3,
                "P_KPa": 330.0,
                "P_MPa": 0.33,
                "P_atm": 3.2568467801628422,
                "molar_frac": [
                    0.9999999999999807,
                    1.926292839180972e-14,
                    2.583235274308958e-218,
                    5.881989512374646e-136,
                    1.841511014189805e-45,
                    5.090868179252349e-86,
                    8.272730548969335e-126,
                    0.0,
                    0.0,
                    2.0158479077443223e-31,
                    1.9320534406334116e-28,
                    0.0
                ],
                "mass_frac": [
                    0.9999999999999657,
                    3.426124010278499e-14,
                    2.8905974954449025e-219,
                    9.14539652103194e-136,
                    4.498655110122588e-45,
                    4.533461394515167e-86,
                    1.2863930505687067e-125,
                    0.0,
                    0.0,
                    3.8135333251597695e-31,
                    6.442769895965788e-28,
                    0.0
                ],
                "vf": 0.0,
                "H": -46027.57165332638,
                "extra": null,
                "f_m3_per_h": 12.17644454836824,
                "f_l_per_h": 12176.44454836824
            },
            {
                "name": "S1",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 673900.1558676785,
                "f_kg_per_h": 12140.5,
                "T_K": 309.65,
                "T_C": 36.5,
                "P_Pa": 330000.0,
                "P_bar": 3.3,
                "P_KPa": 330.0,
                "P_MPa": 0.33,
                "P_atm": 3.2568467801628422,
                "molar_frac": [
                    0.9999999999999865,
                    1.3627390633309484e-14,
                    8.500134079923263e-226,
                    7.899415431664823e-139,
                    2.0953714572944993e-45,
                    7.197414892989935e-87,
                    1.524880246470609e-128,
                    0.0,
                    0.0,
                    2.336667459409309e-31,
                    2.2175933992634506e-28,
                    0.0
                ],
                "mass_frac": [
                    0.9999999999999758,
                    2.423781540198094e-14,
                    9.51150927936481e-227,
                    1.2282117513971584e-138,
                    5.11881462631935e-45,
                    6.409359152267518e-87,
                    2.3711582776664755e-128,
                    0.0,
                    0.0,
                    4.420452154173162e-31,
                    7.394952796742005e-28,
                    0.0
                ],
                "vf": 0.0,
                "H": -46027.57165332638,
                "extra": null,
                "f_m3_per_h": 12.176444548368208,
                "f_l_per_h": 12176.444548368207
            },
            {
                "name": "S11",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 0.0,
                "f_kg_per_h": 0.0,
                "T_K": 309.65,
                "T_C": 36.5,
                "P_Pa": 330000.0,
                "P_bar": 3.3,
                "P_KPa": 330.0,
                "P_MPa": 0.33,
                "P_atm": 3.2568467801628422,
                "molar_frac": [
                    0.9999999999999807,
                    1.926292839180972e-14,
                    2.583235274308958e-218,
                    5.881989512374646e-136,
                    1.841511014189805e-45,
                    5.090868179252349e-86,
                    8.272730548969335e-126,
                    0.0,
                    0.0,
                    2.0158479077443223e-31,
                    1.9320534406334116e-28,
                    0.0
                ],
                "mass_frac": [
                    0.9999999999999657,
                    3.426124010278499e-14,
                    2.8905974954449025e-219,
                    9.14539652103194e-136,
                    4.498655110122588e-45,
                    4.533461394515167e-86,
                    1.2863930505687067e-125,
                    0.0,
                    0.0,
                    3.8135333251597695e-31,
                    6.442769895965788e-28,
                    0.0
                ],
                "vf": 0.0,
                "H": -46027.57165332638,
                "extra": null,
                "f_m3_per_h": 0.0,
                "f_l_per_h": 0.0
            },
            {
                "name": "S12",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 0.0,
                "f_kg_per_h": 0.0,
                "T_K": 309.65,
                "T_C": 36.5,
                "P_Pa": 330000.0,
                "P_bar": 3.3,
                "P_KPa": 330.0,
                "P_MPa": 0.33,
                "P_atm": 3.2568467801628422,
                "molar_frac": [
                    0.9999999999999807,
                    1.926292839180972e-14,
                    2.583235274308958e-218,
                    5.881989512374646e-136,
                    1.841511014189805e-45,
                    5.090868179252349e-86,
                    8.272730548969335e-126,
                    0.0,
                    0.0,
                    2.0158479077443223e-31,
                    1.9320534406334116e-28,
                    0.0
                ],
                "mass_frac": [
                    0.9999999999999657,
                    3.426124010278499e-14,
                    2.8905974954449025e-219,
                    9.14539652103194e-136,
                    4.498655110122588e-45,
                    4.533461394515167e-86,
                    1.2863930505687067e-125,
                    0.0,
                    0.0,
                    3.8135333251597695e-31,
                    6.442769895965788e-28,
                    0.0
                ],
                "vf": 0.0,
                "H": -46027.57165332638,
                "extra": null,
                "f_m3_per_h": 0.0,
                "f_l_per_h": 0.0
            },
            {
                "name": "S2",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 378569.66939517955,
                "f_kg_per_h": 6981.276446260078,
                "T_K": 285.0626424199146,
                "T_C": 11.912642419914619,
                "P_Pa": 600000.0,
                "P_bar": 6.0,
                "P_KPa": 600.0,
                "P_MPa": 0.6,
                "P_atm": 5.921539600296077,
                "molar_frac": [
                    0.9832695854505449,
                    0.0007508185139040463,
                    3.5236474705011914e-16,
                    6.192001312242123e-10,
                    0.015977441949244792,
                    4.453003460003864e-08,
                    5.307609873968187e-07,
                    0.0,
                    0.0,
                    6.113029164639786e-07,
                    9.668731674031004e-07,
                    0.0
                ],
                "mass_frac": [
                    0.9605602316949888,
                    0.0013045710533946995,
                    3.8518388435781814e-17,
                    9.40505480575651e-10,
                    0.03813007182992464,
                    3.8738526662920365e-08,
                    8.062612658630139e-07,
                    0.0,
                    0.0,
                    1.1297393294666743e-06,
                    3.1497420645284497e-06,
                    0.0
                ],
                "vf": 0.015680424358859982,
                "H": -47381.36834666679,
                "extra": null,
                "f_m3_per_h": 7.025499647728953,
                "f_l_per_h": 7025.499647728952
            },
            {
                "name": "S5",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 379172.85053128056,
                "f_kg_per_h": 6992.397266597039,
                "T_K": 285.062676505771,
                "T_C": 11.912676505771003,
                "P_Pa": 600000.0,
                "P_bar": 6.0,
                "P_KPa": 600.0,
                "P_MPa": 0.6,
                "P_atm": 5.921539600296077,
                "molar_frac": [
                    0.9832700522350848,
                    0.0007503686843816246,
                    3.523640686913964e-16,
                    6.191986773408198e-10,
                    0.01597742499737578,
                    4.452995788122892e-08,
                    5.307598658195451e-07,
                    0.0,
                    0.0,
                    6.113021880752293e-07,
                    9.66871946932937e-07,
                    0.0
                ],
                "mass_frac": [
                    0.9605610393140172,
                    0.00130378993754408,
                    3.8518328381407325e-17,
                    9.405036165396994e-10,
                    0.038130045331965304,
                    3.873847410233477e-08,
                    8.062598572454694e-07,
                    0.0,
                    0.0,
                    1.1297383968857835e-06,
                    3.1497392416222673e-06,
                    0.0
                ],
                "vf": 0.015680405199536084,
                "H": -47381.374445772344,
                "extra": null,
                "f_m3_per_h": 7.03668943066712,
                "f_l_per_h": 7036.689430667119
            },
            {
                "name": "S6",
                "type": "内部",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "f_mol_per_h": 757742.5199264601,
                "f_kg_per_h": 13973.673712857119,
                "T_K": 285.0626594763887,
                "T_C": 11.91265947638874,
                "P_Pa": 600000.0,
                "P_bar": 6.0,
                "P_KPa": 600.0,
                "P_MPa": 0.6,
                "P_atm": 5.921539600296077,
                "molar_frac": [
                    0.9832698190286006,
                    0.000750593420105316,
                    3.523644076007629e-16,
                    6.191994037038531e-10,
                    0.015977433466563242,
                    4.4529996210098775e-08,
                    5.307604261617808e-07,
                    0.0,
                    0.0,
                    6.113025519796964e-07,
                    9.66872556682257e-07,
                    0.0
                ],
                "mass_frac": [
                    0.9605606358258708,
                    0.001304180184647439,
                    3.85183583846977e-17,
                    9.405045478159371e-10,
                    0.03813005857040089,
                    3.873850036171262e-08,
                    8.062605609937238e-07,
                    0.0,
                    0.0,
                    1.1297388628051354e-06,
                    3.1497406519520657e-06,
                    0.0
                ],
                "vf": 0.015680414771584057,
                "H": -47381.37139864706,
                "extra": null,
                "f_m3_per_h": 14.06218907839607,
                "f_l_per_h": 14062.189078396072
            }
        ],
        "elements": [
            {
                "name": "B1",
                "type": "Pump",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "result": {}
            },
            {
                "name": "P-109",
                "type": "Pump",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "result": {}
            },
            {
                "name": "T-106",
                "type": "DistilStrict",
                "phase": "VL",
                "mode": "TP",
                "physical_method": "NRTL",
                "result": {
                    "IsConverged": 1,
                    "outer_iter_count": 91,
                    "deltaT_max": 9.799420922718127e-06,
                    "deltax_max": 3.1898766406079915e-07,
                    "T": [
                        370.03583030832,
                        373.60826790396277,
                        379.2674468084661,
                        386.8759933620222,
                        392.70454610492754,
                        394.9836637233575,
                        395.64082466540003,
                        395.8509216194647,
                        395.9543376085488,
                        396.0330996371229,
                        396.1061321671017,
                        396.17775881348916,
                        396.2489655603607,
                        396.3199775796131,
                        396.3908465342116,
                        396.461584657217,
                        396.53219507962126,
                        396.60267896056513,
                        396.67303690631536,
                        396.7432694904034,
                        396.81337718544256,
                        405.81366549291414,
                        407.5911563319086,
                        407.88211064916084,
                        407.9821269045702,
                        408.0591837855747,
                        408.1334041576753,
                        408.2071755764826,
                        408.2807813980597,
                        408.3542556333537,
                        408.929634565875,
                        409.00804935545597,
                        409.0822066171505,
                        409.1555575978497,
                        409.2286330188739,
                        409.30155056186493,
                        409.3743367247551,
                        409.4469977603554,
                        409.5195354245587,
                        409.59195047269293,
                        409.6642434357822,
                        409.73641479290615,
                        409.8084650094832,
                        409.88039454578717,
                        409.952203858855
                    ],
                    "V": [
                        1296128.9629863354,
                        1263603.6991210834,
                        1235563.6497797891,
                        1205142.1479955371,
                        1190352.9242218826,
                        1189842.245067007,
                        1190750.6623038757,
                        1191058.8244767648,
                        1191136.9331706935,
                        1191156.8493553365,
                        1191163.182850033,
                        1191166.387605234,
                        1191168.8598488667,
                        1191171.146211458,
                        1191173.3713972813,
                        1191175.5638777486,
                        1191177.730269526,
                        1191179.8721373146,
                        1191181.989960507,
                        1191184.0839071139,
                        1191186.1541335224,
                        856322.6392694549,
                        863850.451728534,
                        865568.9623614086,
                        865819.8960453388,
                        865878.8666943903,
                        865914.756808863,
                        865947.845158241,
                        865980.5381840287,
                        866013.1212945818,
                        936161.5921759071,
                        937505.9594044083,
                        937636.6705149864,
                        937758.1648099752,
                        937878.0143810655,
                        937997.3225558712,
                        938116.3337076682,
                        938235.1027779647,
                        938353.6426509046,
                        938471.9568692921,
                        938590.0468979699,
                        938707.9137364223,
                        938825.5582768109,
                        938942.9813835102,
                        939060.1839107815
                    ],
                    "V_kg_per_h": [
                        40455.18758911145,
                        37822.72655605135,
                        34744.87143678094,
                        31089.186154246043,
                        28443.998184037955,
                        27499.840120954817,
                        27266.592641665575,
                        27213.1987761757,
                        27201.16549386347,
                        27198.555547846132,
                        27198.09092833365,
                        27198.11434138981,
                        27198.24839664979,
                        27198.40710631958,
                        27198.57090860674,
                        27198.735322999077,
                        27198.899354572663,
                        27199.06275621987,
                        27199.225495560622,
                        27199.387547126837,
                        27199.54892692902,
                        16504.673350590267,
                        15984.273774098476,
                        15929.33697844716,
                        15923.548190677795,
                        15923.387465158154,
                        15923.888951335222,
                        15924.467663976377,
                        15925.054379642395,
                        15925.640907290826,
                        16868.180839421795,
                        16889.924077381584,
                        16891.895921727435,
                        16894.00005096764,
                        16896.140392825462,
                        16898.285594310855,
                        16900.428688270284,
                        16902.568140959615,
                        16904.703624379323,
                        16906.83507803426,
                        16908.962500720507,
                        16911.085904319516,
                        16913.20530354446,
                        16915.320713665566,
                        16917.432150005618
                    ],
                    "V_nm3_per_h": [
                        29049.77867808548,
                        28320.798967181618,
                        27692.345124432497,
                        27010.516449104285,
                        26679.049681742283,
                        26667.603971594373,
                        26687.964074972973,
                        26694.87082821669,
                        26696.621456692916,
                        26697.06783261114,
                        26697.209783469774,
                        26697.281610758542,
                        26697.337020468854,
                        26697.38826407898,
                        26697.43813655119,
                        26697.487276007334,
                        26697.53583074491,
                        26697.583835833135,
                        26697.631302016496,
                        26697.678233060575,
                        26697.724632470432,
                        19192.52162261415,
                        19361.240393748256,
                        19399.756895552153,
                        19405.381002557875,
                        19406.702695346456,
                        19407.507090520034,
                        19408.248690510238,
                        19408.981430222542,
                        19409.711706435206,
                        20981.92991303515,
                        21012.060842568622,
                        21014.990434408242,
                        21017.713452318392,
                        21020.399607488333,
                        21023.073628493625,
                        21025.740992404666,
                        21028.40293061023,
                        21031.059731879064,
                        21033.71147561505,
                        21036.3581946493,
                        21038.99991138298,
                        21041.63664581186,
                        21044.268417308926,
                        21046.895245020496
                    ],
                    "rho_V": [
                        3.04344460249262,
                        2.8973088039080133,
                        2.687406613535492,
                        2.4223375264411784,
                        2.2154609281275097,
                        2.135276180831825,
                        2.11678261582518,
                        2.115703105964569,
                        2.1188060909385418,
                        2.1228740422857735,
                        2.1271621201344066,
                        2.131499814107258,
                        2.1358481878269098,
                        2.140198351453778,
                        2.1445482790892494,
                        2.148897507293251,
                        2.1532459337268786,
                        2.1575935343881225,
                        2.1619403070938477,
                        2.1662862508997662,
                        2.170631368698558,
                        1.7954678530663968,
                        1.7199103117484738,
                        1.713076035047524,
                        1.7152341542106682,
                        1.718471792439205,
                        1.7218371078778576,
                        1.7252169729322198,
                        1.7285979619052232,
                        1.7319784829055578,
                        1.6982479311085132,
                        1.7012851266226798,
                        1.7045494884232477,
                        1.7078460370572999,
                        1.7111491902469051,
                        1.7144533003021347,
                        1.717757112564159,
                        1.7210603490947816,
                        1.7243629491351127,
                        1.7276649002140922,
                        1.7309662005936683,
                        1.7342668509181236,
                        1.7375668523572407,
                        1.7408662061934452,
                        1.7441649137300397
                    ],
                    "L": [
                        836362.8329408083,
                        808322.7835995146,
                        777901.2818152627,
                        763112.058041608,
                        762601.3788867322,
                        763509.796123601,
                        763817.95829649,
                        763896.0669904185,
                        763915.9831750613,
                        763922.316669758,
                        763925.5214249588,
                        763927.9936685914,
                        763930.2800311825,
                        763932.5052170058,
                        763934.697697473,
                        763936.8640892501,
                        763939.0059570388,
                        763941.1237802315,
                        763943.2177268387,
                        763945.2879532471,
                        772480.2752106735,
                        780008.0876697524,
                        781726.5983026272,
                        781977.5319865573,
                        782036.502635609,
                        782072.3927500818,
                        782105.4810994597,
                        782138.1741252474,
                        782170.7572358006,
                        1610061.7480435863,
                        1611406.1152720873,
                        1611536.826382666,
                        1611658.3206776546,
                        1611778.1702487443,
                        1611897.4784235503,
                        1612016.489575347,
                        1612135.2586456435,
                        1612253.7985185832,
                        1612372.1127369704,
                        1612490.2027656483,
                        1612608.0696041004,
                        1612725.714144489,
                        1612843.137251188,
                        1612960.3397784599,
                        673900.1558676785
                    ],
                    "L_kg_per_h": [
                        25132.4403350262,
                        22054.587653351336,
                        18398.906675541566,
                        15753.72219338948,
                        14809.565614746405,
                        14576.318638573905,
                        14522.924917011123,
                        14510.891668252667,
                        14508.281747243678,
                        14507.817131035004,
                        14507.840560214803,
                        14507.974616800579,
                        14508.133340578357,
                        14508.297143897937,
                        14508.4615709401,
                        14508.625603376513,
                        14508.789016384071,
                        14508.951756447583,
                        14509.113818216945,
                        14509.275198625792,
                        14671.499634613901,
                        14151.10005855913,
                        14096.163263107675,
                        14090.37447588327,
                        14090.213750368634,
                        14090.71523706361,
                        14091.293949706795,
                        14091.880665862465,
                        14092.467193512752,
                        29008.680839416684,
                        29030.42407737986,
                        29032.39592172713,
                        29034.50005096754,
                        29036.640392825437,
                        29038.785594310855,
                        29040.928688270287,
                        29043.068140959625,
                        29045.203624379326,
                        29047.335078034255,
                        29049.462500720503,
                        29051.58590431951,
                        29053.705303544455,
                        29055.820713665555,
                        29057.932150005614,
                        12140.5
                    ],
                    "L_m3_per_h": [
                        31.38606433373833,
                        26.719539876932476,
                        21.14510096904153,
                        17.031708037967885,
                        15.51078975208958,
                        15.123620599023402,
                        15.033884049241024,
                        15.013564651191903,
                        15.00912472699547,
                        15.00830360628108,
                        15.008306172499735,
                        15.008495705212905,
                        15.008727176220061,
                        15.008967536522634,
                        15.009209266955109,
                        15.009450647878415,
                        15.009691298488036,
                        15.00993112695557,
                        15.01017012277291,
                        15.010408279251001,
                        15.178307617819021,
                        14.253605551691713,
                        14.145784040644187,
                        14.133650618796846,
                        14.13273886031608,
                        14.133152926583582,
                        14.133722825905938,
                        14.134310035781796,
                        14.134898156111943,
                        29.096022891424752,
                        29.11667591861482,
                        29.118419317941306,
                        29.120477722990184,
                        29.122612870307233,
                        29.124761863638557,
                        29.126910734594627,
                        29.129056395500335,
                        29.13119817348904,
                        29.133335931556857,
                        29.135469651554498,
                        29.137599341638253,
                        29.13972501573024,
                        29.141846688960634,
                        29.143964376656488,
                        12.176444548368208
                    ],
                    "L_l_per_h": [
                        31386.06433373833,
                        26719.539876932475,
                        21145.100969041527,
                        17031.708037967885,
                        15510.78975208958,
                        15123.6205990234,
                        15033.884049241024,
                        15013.564651191902,
                        15009.12472699547,
                        15008.30360628108,
                        15008.306172499735,
                        15008.495705212905,
                        15008.72717622006,
                        15008.967536522636,
                        15009.209266955108,
                        15009.450647878415,
                        15009.691298488036,
                        15009.93112695557,
                        15010.170122772908,
                        15010.408279251002,
                        15178.307617819022,
                        14253.605551691711,
                        14145.784040644186,
                        14133.650618796844,
                        14132.73886031608,
                        14133.152926583582,
                        14133.722825905937,
                        14134.310035781797,
                        14134.898156111942,
                        29096.022891424753,
                        29116.67591861482,
                        29118.419317941305,
                        29120.477722990185,
                        29122.61287030723,
                        29124.761863638556,
                        29126.910734594625,
                        29129.056395500334,
                        29131.198173489036,
                        29133.335931556856,
                        29135.469651554497,
                        29137.599341638255,
                        29139.72501573024,
                        29141.846688960635,
                        29143.964376656484,
                        12176.444548368207
                    ],
                    "rho_L": [
                        800.751571391198,
                        825.4104582239274,
                        870.126215168201,
                        924.964317041517,
                        954.7912035073064,
                        963.8114460181024,
                        966.0128327080123,
                        966.5187452402032,
                        966.630767025943,
                        966.6526951762477,
                        966.6540909725074,
                        966.6508157617369,
                        966.6464830918608,
                        966.6419164805059,
                        966.6373033309973,
                        966.632686548545,
                        966.6280756783838,
                        966.6234730678875,
                        966.618879036169,
                        966.6142938085216,
                        966.6097172381632,
                        992.8084516748524,
                        996.4921861245767,
                        996.9380774945703,
                        996.9910213181074,
                        996.9972949602668,
                        996.9980396020378,
                        996.998129387857,
                        996.9981416115938,
                        996.9981446490472,
                        997.0377167546169,
                        997.0457394931059,
                        997.0475184905787,
                        997.0479133220408,
                        997.0480009508665,
                        997.0480203991486,
                        997.0480247154868,
                        997.0480256734523,
                        997.0480258860624,
                        997.0480259332492,
                        997.0480259437218,
                        997.0480259460462,
                        997.048025946562,
                        997.0480259466765,
                        997.0480259467017
                    ],
                    "sigma": [
                        17.873421785093214,
                        21.163853816650605,
                        28.044157794743683,
                        37.979664472799044,
                        43.896001655001946,
                        45.705216767918195,
                        46.135569875288994,
                        46.22346827151508,
                        46.231917991222836,
                        46.222222725707994,
                        46.20841154111678,
                        46.193682276451945,
                        46.17876321075933,
                        46.16382020676146,
                        46.14889092900791,
                        46.13398392911124,
                        46.119101038525,
                        46.104242640396286,
                        46.089408709336475,
                        46.07459920230413,
                        46.05981400123621,
                        51.19781667907909,
                        51.85545196628601,
                        51.92000701684424,
                        51.91409651412591,
                        51.89986491892704,
                        51.88466983006503,
                        51.86938220800252,
                        51.854105086616585,
                        51.83885058462374,
                        51.7340212475874,
                        51.719970217784876,
                        51.70504486484287,
                        51.689897305671465,
                        51.674718921466386,
                        51.65955220561248,
                        51.644406517390216,
                        51.6292838650782,
                        51.61418462644383,
                        51.59910881789846,
                        51.58405637607211,
                        51.56902722028085,
                        51.55402126638302,
                        51.53903842985047,
                        51.52407862644692
                    ],
                    "P": [
                        300000.0,
                        300681.8181818182,
                        301363.63636363635,
                        302045.45454545453,
                        302727.2727272727,
                        303409.0909090909,
                        304090.90909090906,
                        304772.72727272724,
                        305454.5454545454,
                        306136.3636363636,
                        306818.18181818177,
                        307499.99999999994,
                        308181.8181818181,
                        308863.6363636363,
                        309545.4545454545,
                        310227.27272727265,
                        310909.0909090908,
                        311590.909090909,
                        312272.7272727272,
                        312954.54545454535,
                        313636.36363636353,
                        314318.1818181817,
                        314999.9999999999,
                        315681.81818181806,
                        316363.63636363624,
                        317045.4545454544,
                        317727.2727272726,
                        318409.09090909077,
                        319090.90909090894,
                        319772.7272727271,
                        320454.5454545453,
                        321136.3636363635,
                        321818.18181818165,
                        322499.9999999998,
                        323181.818181818,
                        323863.6363636362,
                        324545.45454545435,
                        325227.27272727253,
                        325909.0909090907,
                        326590.9090909089,
                        327272.72727272706,
                        327954.54545454524,
                        328636.3636363634,
                        329318.1818181816,
                        330000.0
                    ],
                    "X": [
                        [
                            0.1420926741015453,
                            0.8578536581667794,
                            4.3364016449563027e-29,
                            1.5124585217203883e-17,
                            5.362080677420706e-05,
                            9.629918950443004e-13,
                            2.9004222837348783e-14,
                            0.0,
                            0.0,
                            1.357762449000686e-08,
                            3.334628440391559e-08,
                            0.0
                        ],
                        [
                            0.33923527663674796,
                            0.6607117360621023,
                            4.226637133217248e-29,
                            1.3989012193965097e-17,
                            5.293613044692999e-05,
                            9.283943219942413e-13,
                            2.745865731235052e-14,
                            0.0,
                            0.0,
                            1.463874562808116e-08,
                            3.6531001215060026e-08,
                            0.0
                        ],
                        [
                            0.5981897124012293,
                            0.4017638028960676,
                            3.675293608711459e-29,
                            1.119251287966751e-17,
                            4.643435304988567e-05,
                            7.921871159881409e-13,
                            2.2792321514324283e-14,
                            0.0,
                            0.0,
                            1.4357995426071737e-08,
                            3.5990842728687976e-08,
                            0.0
                        ],
                        [
                            0.8126198015056842,
                            0.18734607456974342,
                            2.6937956524810856e-29,
                            7.332190477145075e-18,
                            3.408111458711367e-05,
                            5.645371474287907e-13,
                            1.5683936321126914e-14,
                            0.0,
                            0.0,
                            1.2218567880212607e-08,
                            3.059083712426581e-08,
                            0.0
                        ],
                        [
                            0.8998917081492077,
                            0.1000822342738939,
                            2.0704217639324508e-29,
                            5.169855385132236e-18,
                            2.6021263549626662e-05,
                            4.238208676330231e-13,
                            1.1480865039770857e-14,
                            0.0,
                            0.0,
                            1.0424362307630815e-08,
                            2.5888551121331786e-08,
                            0.0
                        ],
                        [
                            0.9233157874740241,
                            0.0766608151770829,
                            1.86715026698199e-29,
                            4.507529734972452e-18,
                            2.3363468238947517e-05,
                            3.785497365863016e-13,
                            1.0157275684311454e-14,
                            0.0,
                            0.0,
                            9.763184868503628e-09,
                            2.411708066335674e-08,
                            0.0
                        ],
                        [
                            0.9288478704853329,
                            0.0711294170397091,
                            1.8151029645674467e-29,
                            4.339423351571541e-18,
                            2.2679233880384905e-05,
                            3.6696156416215777e-13,
                            9.819675980133053e-15,
                            0.0,
                            0.0,
                            9.591466191765484e-09,
                            2.3649234609877818e-08,
                            0.0
                        ],
                        [
                            0.9301093473906494,
                            0.06986810977062331,
                            1.8023830097330357e-29,
                            4.2956196722686035e-18,
                            2.250973105258073e-05,
                            3.6406020375580164e-13,
                            9.73362656143873e-15,
                            0.0,
                            0.0,
                            9.556820756460094e-09,
                            2.3550479977947596e-08,
                            0.0
                        ],
                        [
                            0.9303881814974267,
                            0.06958932373615315,
                            1.798936536327921e-29,
                            4.280840583945872e-18,
                            2.2461669324515213e-05,
                            3.6320192121085733e-13,
                            9.706556777893964e-15,
                            0.0,
                            0.0,
                            9.555320969070129e-09,
                            2.3541401655804563e-08,
                            0.0
                        ],
                        [
                            0.9304427492300716,
                            0.06953477616460592,
                            1.7976194143657257e-29,
                            4.272716588722947e-18,
                            2.2441490400810642e-05,
                            3.6281254697780617e-13,
                            9.693017843408397e-15,
                            0.0,
                            0.0,
                            9.561477878276436e-09,
                            2.3553071330010265e-08,
                            0.0
                        ],
                        [
                            0.9304462308304127,
                            0.06953130835875254,
                            1.796788565945934e-29,
                            4.266122300043193e-18,
                            2.242767164893893e-05,
                            3.6253039153645125e-13,
                            9.68257968740838e-15,
                            0.0,
                            0.0,
                            9.569371340371169e-09,
                            2.3569442376663544e-08,
                            0.0
                        ],
                        [
                            0.9304380913801752,
                            0.06953946015372701,
                            1.7960690553934383e-29,
                            4.259890019962782e-18,
                            2.24153012435155e-05,
                            3.622729534960387e-13,
                            9.672864429362873e-15,
                            0.0,
                            0.0,
                            9.577645543694422e-09,
                            2.3586836834536338e-08,
                            0.0
                        ],
                        [
                            0.9304273208252976,
                            0.0695502427238595,
                            1.7953754581886551e-29,
                            4.2537539612640266e-18,
                            2.2403260065507763e-05,
                            3.620214408171198e-13,
                            9.663330604770576e-15,
                            0.0,
                            0.0,
                            9.58599095988849e-09,
                            2.360441480852236e-08,
                            0.0
                        ],
                        [
                            0.9304159679398736,
                            0.06956160755010218,
                            1.7946883221274215e-29,
                            4.247653590897969e-18,
                            2.2391293330605326e-05,
                            3.6177157455354207e-13,
                            9.653854911772203e-15,
                            0.0,
                            0.0,
                            9.59433706693002e-09,
                            2.362198492493199e-08,
                            0.0
                        ],
                        [
                            0.9304044989624515,
                            0.06957308845200792,
                            1.7940032094288136e-29,
                            4.2415750604234155e-18,
                            2.23793429980376e-05,
                            3.615223784390564e-13,
                            9.644409187330629e-15,
                            0.0,
                            0.0,
                            9.602667780852728e-09,
                            2.3639503584663604e-08,
                            0.0
                        ],
                        [
                            0.9303930206403191,
                            0.0695845786953811,
                            1.7933191143518594e-29,
                            4.235515162047755e-18,
                            2.236739598812523e-05,
                            3.612736304727059e-13,
                            9.634986977492704e-15,
                            0.0,
                            0.0,
                            9.610979532161149e-09,
                            2.3656961134501366e-08,
                            0.0
                        ],
                        [
                            0.9303815567238151,
                            0.06959605453286442,
                            1.7926358011774238e-29,
                            4.229473092677264e-18,
                            2.235544932300354e-05,
                            3.6102527831975673e-13,
                            9.625586721593881e-15,
                            0.0,
                            0.0,
                            9.619271514927565e-09,
                            2.3674355448282885e-08,
                            0.0
                        ],
                        [
                            0.9303701130550064,
                            0.06960751012292442,
                            1.7919532215791946e-29,
                            4.223448615276295e-18,
                            2.234350246877682e-05,
                            3.607773104612151e-13,
                            9.61620802500642e-15,
                            0.0,
                            0.0,
                            9.62754364409881e-09,
                            2.369168633325453e-08,
                            0.0
                        ],
                        [
                            0.9303586904295992,
                            0.06961894466997577,
                            1.7912713580330318e-29,
                            4.217441603367197e-18,
                            2.2331555305217767e-05,
                            3.605297225100484e-13,
                            9.606850707233012e-15,
                            0.0,
                            0.0,
                            9.635795910227945e-09,
                            2.3708953825103578e-08,
                            0.0
                        ],
                        [
                            0.9303472894097817,
                            0.06963035761171345,
                            1.7905902119123345e-29,
                            4.211451975301813e-18,
                            2.2319607948356527e-05,
                            3.602825138845882e-13,
                            9.597514689360498e-15,
                            0.0,
                            0.0,
                            9.644028407884852e-09,
                            2.372615821901514e-08,
                            0.0
                        ],
                        [
                            0.9303359096320132,
                            0.0696417493116515,
                            1.789909777055277e-29,
                            4.2054796403865446e-18,
                            2.2307660424831164e-05,
                            3.600356826889888e-13,
                            9.588199863098673e-15,
                            0.0,
                            0.0,
                            9.652241169734782e-09,
                            2.3743299664129376e-08,
                            0.0
                        ],
                        [
                            0.9909656044102059,
                            0.009014076176743826,
                            1.671112811897086e-29,
                            3.4357292178058466e-18,
                            2.028374903622223e-05,
                            3.226560614877234e-13,
                            8.295171600959201e-15,
                            0.0,
                            0.0,
                            1.0468914605033616e-08,
                            2.5194768467061535e-08,
                            0.0
                        ],
                        [
                            0.9988175729713091,
                            0.0011638326456806674,
                            1.5396379448945708e-29,
                            3.0830206899657276e-18,
                            1.8560663253028486e-05,
                            2.947605405725792e-13,
                            7.527901668453435e-15,
                            0.0,
                            0.0,
                            9.934659046411433e-09,
                            2.3784795746508485e-08,
                            0.0
                        ],
                        [
                            0.9997576482746049,
                            0.00022399613836990954,
                            1.5217599201888243e-29,
                            3.0340921336863093e-18,
                            1.8322170359596505e-05,
                            2.909300492048948e-13,
                            7.422088362978618e-15,
                            0.0,
                            0.0,
                            9.855679401493003e-09,
                            2.3560687788054643e-08,
                            0.0
                        ],
                        [
                            0.9998691312214457,
                            0.00011255547200171406,
                            1.5188751002793297e-29,
                            3.023848799534924e-18,
                            1.8279915253279635e-05,
                            2.902385665539614e-13,
                            7.401714540135087e-15,
                            0.0,
                            0.0,
                            9.851112095099548e-09,
                            2.3539889521769594e-08,
                            0.0
                        ],
                        [
                            0.9998823475446548,
                            9.935774137005641e-05,
                            1.5177983961335678e-29,
                            3.0182517274185866e-18,
                            1.826131261153551e-05,
                            2.8992504789104934e-13,
                            7.391617744101939e-15,
                            0.0,
                            0.0,
                            9.855893451817684e-09,
                            2.35451728368312e-08,
                            0.0
                        ],
                        [
                            0.9998839242802744,
                            9.779677258947552e-05,
                            1.5169373619139478e-29,
                            3.013218712168124e-18,
                            1.8245531505080676e-05,
                            2.8965680494131326e-13,
                            7.382758607772853e-15,
                            0.0,
                            0.0,
                            9.861778365354867e-09,
                            2.3553555662494965e-08,
                            0.0
                        ],
                        [
                            0.9998841224402368,
                            9.761402948131815e-05,
                            1.5161029979600963e-29,
                            3.0082660721151653e-18,
                            1.8230099949487526e-05,
                            2.893943733511712e-13,
                            7.374065357252246e-15,
                            0.0,
                            0.0,
                            9.867777575955846e-09,
                            2.3562258085741806e-08,
                            0.0
                        ],
                        [
                            0.9998841573110192,
                            9.75945188018862e-05,
                            1.5152729128399043e-29,
                            3.003336514281715e-18,
                            1.8214725159743247e-05,
                            2.891330784384374e-13,
                            7.365411039123939e-15,
                            0.0,
                            0.0,
                            9.87377358145568e-09,
                            2.3570949187823696e-08,
                            0.0
                        ],
                        [
                            0.9998841728330461,
                            9.759433477475918e-05,
                            1.514444457504267e-29,
                            2.998423206870821e-18,
                            1.8199372540374688e-05,
                            2.888723664270479e-13,
                            7.356780575560895e-15,
                            0.0,
                            0.0,
                            9.879752541953701e-09,
                            2.3579589994639822e-08,
                            0.0
                        ],
                        [
                            0.9999782817218115,
                            2.1677029320086617e-05,
                            1.2557440954062332e-42,
                            2.7773673802210754e-26,
                            3.985335600051958e-08,
                            3.605219157596185e-18,
                            1.9576521663739706e-22,
                            0.0,
                            0.0,
                            3.057113375021448e-10,
                            1.0898012458539694e-09,
                            0.0
                        ],
                        [
                            0.9999951886332156,
                            4.811219847107159e-06,
                            1.0398649036535889e-55,
                            2.56623427262032e-34,
                            8.712868738212288e-11,
                            4.491793875847895e-23,
                            5.1990159913660426e-30,
                            0.0,
                            0.0,
                            9.45868558518487e-12,
                            5.034997455388013e-11,
                            0.0
                        ],
                        [
                            0.9999989321885473,
                            1.067808642805418e-06,
                            8.605758658689878e-69,
                            2.3671063269375782e-42,
                            1.9030971889730286e-13,
                            5.590978476537924e-28,
                            1.3790146950789901e-37,
                            0.0,
                            0.0,
                            2.9280828962396733e-13,
                            2.326899056455867e-12,
                            0.0
                        ],
                        [
                            0.9999997630108878,
                            2.3698899514230097e-07,
                            7.1179076189144e-82,
                            2.1798037700079777e-50,
                            4.153171495189773e-16,
                            6.952672359776839e-33,
                            3.65339135699485e-45,
                            0.0,
                            0.0,
                            9.069388416272633e-15,
                            1.0757015481163052e-13,
                            0.0
                        ],
                        [
                            0.9999999474028279,
                            5.259716689400748e-08,
                            5.88396064174615e-95,
                            2.004011732012166e-58,
                            9.05568485010832e-19,
                            8.638044293868397e-38,
                            9.667347977933443e-53,
                            0.0,
                            0.0,
                            2.8107083414080628e-16,
                            4.974429067324579e-15,
                            0.0
                        ],
                        [
                            0.9999999883266215,
                            1.1673378120324616e-08,
                            4.861186920281881e-108,
                            1.839366558239994e-66,
                            1.972814001713365e-21,
                            1.0722103014270128e-42,
                            2.5550761583571825e-60,
                            0.0,
                            0.0,
                            8.715578704771792e-18,
                            2.30107824731892e-16,
                            0.0
                        ],
                        [
                            0.9999999974092186,
                            2.5907814585156863e-09,
                            4.0139358488368835e-121,
                            1.6854765713112234e-74,
                            4.294125012278551e-24,
                            1.3296765040773744e-47,
                            6.745071511971354e-68,
                            0.0,
                            0.0,
                            2.704073630464095e-19,
                            1.0647688554498201e-17,
                            0.0
                        ],
                        [
                            0.9999999994250045,
                            5.74995531497886e-10,
                            3.312488348165173e-134,
                            1.5419299609983072e-82,
                            9.338714464092679e-27,
                            1.6474564437315562e-52,
                            1.7785095745739982e-75,
                            0.0,
                            0.0,
                            8.394246826006248e-21,
                            4.928492887061053e-19,
                            0.0
                        ],
                        [
                            0.9999999998723871,
                            1.276130253122243e-10,
                            2.732086016421229e-147,
                            1.4082997872975559e-90,
                            2.029193776474674e-29,
                            2.0393146558823265e-57,
                            4.683963377994725e-83,
                            0.0,
                            0.0,
                            2.6072638367690904e-22,
                            2.2819534889146716e-20,
                            0.0
                        ],
                        [
                            0.9999999999716789,
                            2.832113378056574e-11,
                            2.2521157233951828e-160,
                            1.2841482279901767e-98,
                            4.405387300047378e-32,
                            2.5220710202941515e-62,
                            1.2321372744666512e-90,
                            0.0,
                            0.0,
                            8.102654839778462e-24,
                            1.0568961643891054e-21,
                            0.0
                        ],
                        [
                            0.9999999999937157,
                            6.28432252402588e-12,
                            1.855425860365039e-173,
                            1.1690304032113444e-106,
                            9.555841817160035e-35,
                            3.1162591808775316e-67,
                            3.2373801856061385e-98,
                            0.0,
                            0.0,
                            2.519462475013393e-25,
                            4.8965446921234686e-23,
                            0.0
                        ],
                        [
                            0.9999999999986066,
                            1.3934777800347085e-12,
                            1.5277536213776649e-186,
                            1.0624979231615338e-114,
                            2.0709910787132925e-37,
                            3.8469224720023816e-72,
                            8.496068341832126e-106,
                            0.0,
                            0.0,
                            7.838366852528369e-27,
                            2.2692235098255148e-24,
                            0.0
                        ],
                        [
                            0.999999999999692,
                            3.080045421300081e-13,
                            1.257245511949952e-199,
                            9.641021023496121e-123,
                            4.484479634674586e-40,
                            4.7445749684326395e-77,
                            2.22706376111435e-113,
                            0.0,
                            0.0,
                            2.4399135140165564e-28,
                            1.051908295647723e-25,
                            0.0
                        ],
                        [
                            0.9999999999999329,
                            6.709479971698655e-14,
                            1.0340562548045794e-212,
                            8.733969029802632e-131,
                            9.7021889795486e-43,
                            5.846360927305105e-82,
                            5.830936919972293e-121,
                            0.0,
                            0.0,
                            7.596094749313178e-30,
                            4.873517246052404e-27,
                            0.0
                        ],
                        [
                            0.9999999999999865,
                            1.3627390633309484e-14,
                            8.500134079923263e-226,
                            7.899415431664823e-139,
                            2.0953714572944993e-45,
                            7.197414892989935e-87,
                            1.524880246470609e-128,
                            0.0,
                            0.0,
                            2.336667459409309e-31,
                            2.2175933992634506e-28,
                            0.0
                        ]
                    ],
                    "Y": [
                        [
                            0.0671314434382207,
                            0.923526572245217,
                            2.0599921622688005e-16,
                            3.6199632455187507e-10,
                            0.009340724323341282,
                            2.6033119832301738e-08,
                            3.102931045855325e-07,
                            0.0,
                            0.0,
                            3.5804968712177696e-07,
                            5.652553121806572e-07,
                            0.0
                        ],
                        [
                            0.158612367479274,
                            0.8317696627447889,
                            2.1130166793535185e-16,
                            3.71314161859829e-10,
                            0.009616646981397721,
                            2.670385354721056e-08,
                            3.182801084898649e-07,
                            0.0,
                            0.0,
                            3.755653616757179e-07,
                            6.018739019386671e-07,
                            0.0
                        ],
                        [
                            0.2879608177540821,
                            0.7022046047396381,
                            2.1609696127309694e-16,
                            3.7974075301361667e-10,
                            0.009833222979309969,
                            2.7309827360849478e-08,
                            3.255031588921251e-07,
                            0.0,
                            0.0,
                            3.8447458073216664e-07,
                            6.168596627175046e-07,
                            0.0
                        ],
                        [
                            0.45381797235649307,
                            0.5361047307678725,
                            2.2155189868304247e-16,
                            3.893265251746743e-10,
                            0.010075909977942539,
                            2.799909771070688e-08,
                            3.337198221681028e-07,
                            0.0,
                            0.0,
                            3.9362916022216974e-07,
                            6.311602851153151e-07,
                            0.0
                        ],
                        [
                            0.5894914230605098,
                            0.40031457966503703,
                            2.243045010663664e-16,
                            3.9416358020704453e-10,
                            0.010192598604761018,
                            2.8346807802934096e-08,
                            3.378660110622853e-07,
                            0.0,
                            0.0,
                            3.96969758562038e-07,
                            6.350929519221103e-07,
                            0.0
                        ],
                        [
                            0.6453306194117059,
                            0.3444761930471112,
                            2.244007637456877e-16,
                            3.9433273602787454e-10,
                            0.010191792453475618,
                            2.8358882659710117e-08,
                            3.3801100605321563e-07,
                            0.0,
                            0.0,
                            3.95984925841759e-07,
                            6.323385603142508e-07,
                            0.0
                        ],
                        [
                            0.6605443815601545,
                            0.32927189330699086,
                            2.2422956485583264e-16,
                            3.9403189234177093e-10,
                            0.010182332641623576,
                            2.833721850291328e-08,
                            3.3775313098727073e-07,
                            0.0,
                            0.0,
                            3.9526682828419655e-07,
                            6.307400214225591e-07,
                            0.0
                        ],
                        [
                            0.664160064238129,
                            0.32565927866957584,
                            2.2417154878734336e-16,
                            3.939299420385196e-10,
                            0.010179265362740431,
                            2.8329879328948915e-08,
                            3.3766574202338334e-07,
                            0.0,
                            0.0,
                            3.9505696307620744e-07,
                            6.302830402231448e-07,
                            0.0
                        ],
                        [
                            0.664986429356784,
                            0.3248336884914505,
                            2.2415684781001125e-16,
                            3.9390410833468614e-10,
                            0.010178490596853829,
                            2.832801964126937e-08,
                            3.3764359809632816e-07,
                            0.0,
                            0.0,
                            3.9500946588308326e-07,
                            6.30179924577418e-07,
                            0.0
                        ],
                        [
                            0.6651696863695111,
                            0.3246506321443754,
                            2.241530998082629e-16,
                            3.9389752191797585e-10,
                            0.010178289960698255,
                            2.8327545436659726e-08,
                            3.3763795245266736e-07,
                            0.0,
                            0.0,
                            3.9500205925961526e-07,
                            6.301639595377196e-07,
                            0.0
                        ],
                        [
                            0.6652060923597793,
                            0.32461429311885914,
                            2.241519073512603e-16,
                            3.938954263905564e-10,
                            0.010178222991741754,
                            2.832739448988984e-08,
                            3.376361562405358e-07,
                            0.0,
                            0.0,
                            3.950039573336962e-07,
                            6.301682164090178e-07,
                            0.0
                        ],
                        [
                            0.6652090397654848,
                            0.32461138188780414,
                            2.241513042779041e-16,
                            3.938943664949756e-10,
                            0.01017818680518354,
                            2.8327318093336028e-08,
                            3.376352477722772e-07,
                            0.0,
                            0.0,
                            3.950079827356525e-07,
                            6.301770836965112e-07,
                            0.0
                        ],
                        [
                            0.665204370272293,
                            0.3246160804049098,
                            2.241508384901563e-16,
                            3.938935479309326e-10,
                            0.010178157767631315,
                            2.8327259063639798e-08,
                            3.3763454613585044e-07,
                            0.0,
                            0.0,
                            3.950124882629803e-07,
                            6.301869786441679e-07,
                            0.0
                        ],
                        [
                            0.6651979727644218,
                            0.32462250511429286,
                            2.241504082573726e-16,
                            3.9389279178173576e-10,
                            0.010178130552101271,
                            2.8327204529723283e-08,
                            3.3763389802398315e-07,
                            0.0,
                            0.0,
                            3.950171007272041e-07,
                            6.301970877399362e-07,
                            0.0
                        ],
                        [
                            0.6651911873500908,
                            0.32462931718512017,
                            2.241499889980622e-16,
                            3.938920549864048e-10,
                            0.010178103881524864,
                            2.8327151385000338e-08,
                            3.376332664754471e-07,
                            0.0,
                            0.0,
                            3.950217323962568e-07,
                            6.302072213077544e-07,
                            0.0
                        ],
                        [
                            0.6651843209001733,
                            0.3246362099772129,
                            2.2414957644424554e-16,
                            3.9389132992009353e-10,
                            0.010178077525271171,
                            2.832709908706449e-08,
                            3.3763264500094476e-07,
                            0.0,
                            0.0,
                            3.950263658351394e-07,
                            6.302173402287216e-07,
                            0.0
                        ],
                        [
                            0.6651774419061717,
                            0.3246431151122635,
                            2.2414916828289446e-16,
                            3.9389061263179465e-10,
                            0.010178051370170095,
                            2.832704734565956e-08,
                            3.376320301715187e-07,
                            0.0,
                            0.0,
                            3.95030994573973e-07,
                            6.30227431685179e-07,
                            0.0
                        ],
                        [
                            0.6651705673226719,
                            0.3246500156036135,
                            2.241487652637867e-16,
                            3.938899043347035e-10,
                            0.010178025448288788,
                            2.8326996253505647e-08,
                            3.376314230659408e-07,
                            0.0,
                            0.0,
                            3.950356195741219e-07,
                            6.302374966855124e-07,
                            0.0
                        ],
                        [
                            0.6651636996989438,
                            0.3246569089528072,
                            2.241483662739457e-16,
                            3.938892031675359e-10,
                            0.010177999708821779,
                            2.8326945671733598e-08,
                            3.376308220534986e-07,
                            0.0,
                            0.0,
                            3.950402386921683e-07,
                            6.302475317735701e-07,
                            0.0
                        ],
                        [
                            0.6651568408258025,
                            0.3246637933251755,
                            2.2414797228157953e-16,
                            3.938885107453477e-10,
                            0.010177974195615318,
                            2.8326895721072113e-08,
                            3.376302285508554e-07,
                            0.0,
                            0.0,
                            3.9504485374914606e-07,
                            6.302575398913847e-07,
                            0.0
                        ],
                        [
                            0.665149989919303,
                            0.32467066955036383,
                            2.2414758227817226e-16,
                            3.9388782537354825e-10,
                            0.010177948862975919,
                            2.8326846275522123e-08,
                            3.376296410763639e-07,
                            0.0,
                            0.0,
                            3.9504946292157443e-07,
                            6.302675182198487e-07,
                            0.0
                        ],
                        [
                            0.9223525079649076,
                            0.06348732561796659,
                            3.1180011414831385e-16,
                            5.479169914402784e-10,
                            0.014158230185132577,
                            3.9404014834213975e-08,
                            4.6965913964649423e-07,
                            0.0,
                            0.0,
                            5.496364162445331e-07,
                            8.769845044826291e-07,
                            0.0
                        ],
                        [
                            0.9771672617777258,
                            0.008797597865049344,
                            3.0908300811578303e-16,
                            5.431423018125518e-10,
                            0.014033218659063686,
                            3.9060607544914267e-08,
                            4.6556640855670706e-07,
                            0.0,
                            0.0,
                            5.456682657673342e-07,
                            8.70859736299729e-07,
                            0.0
                        ],
                        [
                            0.9842860536404376,
                            0.0017081891271548218,
                            3.0846935113114467e-16,
                            5.420639404831373e-10,
                            0.014003841034730168,
                            3.898303160937812e-08,
                            4.646420669396717e-07,
                            0.0,
                            0.0,
                            5.441231692679197e-07,
                            8.679073459458966e-07,
                            0.0
                        ],
                        [
                            0.9851393075769589,
                            0.0008592046742512538,
                            3.0837994939715664e-16,
                            5.419068374456242e-10,
                            0.013999572370439282,
                            3.8971730027925035e-08,
                            4.6450740255133694e-07,
                            0.0,
                            0.0,
                            5.438970171628124e-07,
                            8.674602928736736e-07,
                            0.0
                        ],
                        [
                            0.9852409913004151,
                            0.000758511458023791,
                            3.0835894719169155e-16,
                            5.418699308907059e-10,
                            0.013998582014292806,
                            3.8969075254926415e-08,
                            4.6447576727334615e-07,
                            0.0,
                            0.0,
                            5.438565212268161e-07,
                            8.673840347057187e-07,
                            0.0
                        ],
                        [
                            0.9852535342758885,
                            0.0007465648256127342,
                            3.0834616595373946e-16,
                            5.418474707924119e-10,
                            0.013997985740140615,
                            3.8967459745839024e-08,
                            4.644565151025664e-07,
                            0.0,
                            0.0,
                            5.438387055045035e-07,
                            8.673538297352166e-07,
                            0.0
                        ],
                        [
                            0.9852555173248606,
                            0.0007451302618914698,
                            3.083343838750004e-16,
                            5.418267664943521e-10,
                            0.013997437313907339,
                            3.8965970546305536e-08,
                            4.644387679527159e-07,
                            0.0,
                            0.0,
                            5.43823616839962e-07,
                            8.673291584973462e-07,
                            0.0
                        ],
                        [
                            0.9852562485822443,
                            0.0007449407718682887,
                            3.083227429833358e-16,
                            5.418063102936805e-10,
                            0.013996895604309244,
                            3.8964499194347244e-08,
                            4.64421233467491e-07,
                            0.0,
                            0.0,
                            5.438088759501152e-07,
                            8.67305162330021e-07,
                            0.0
                        ],
                        [
                            0.9852568304402347,
                            0.0007448987947888742,
                            3.0831114256552936e-16,
                            5.417859252230021e-10,
                            0.013996355780927337,
                            3.896303295844001e-08,
                            4.6440375995055624e-07,
                            0.0,
                            0.0,
                            5.437942023029967e-07,
                            8.672812667744865e-07,
                            0.0
                        ],
                        [
                            0.999800794122742,
                            0.00016784805834334088,
                            2.604624152072669e-29,
                            5.156851718168027e-18,
                            3.130027320356781e-05,
                            4.968184463510977e-13,
                            1.265259235732057e-14,
                            0.0,
                            0.0,
                            1.6991737109940446e-08,
                            4.055346453933272e-08,
                            0.0
                        ],
                        [
                            0.9999626701398001,
                            3.725896072607387e-05,
                            2.1584009141732567e-42,
                            4.773800899773707e-26,
                            6.850083575140127e-08,
                            6.196730969349223e-18,
                            3.3648561367090154e-22,
                            0.0,
                            0.0,
                            5.254634545398922e-10,
                            1.873174649382687e-09,
                            0.0
                        ],
                        [
                            0.9999917305977716,
                            8.269149683418204e-06,
                            1.7872387484251506e-55,
                            4.410643453250541e-34,
                            1.4974999698809893e-10,
                            7.720145219488607e-23,
                            8.935663470134503e-30,
                            0.0,
                            0.0,
                            1.6256851567770932e-11,
                            8.65376119597627e-11,
                            0.0
                        ],
                        [
                            0.9999981648283359,
                            1.8351668346541006e-06,
                            1.479010592894592e-68,
                            4.068177450639373e-42,
                            3.2707179151411486e-13,
                            9.60881744357264e-28,
                            2.370014571271331e-37,
                            0.0,
                            0.0,
                            5.032288020996601e-13,
                            3.9990760725476136e-12,
                            0.0
                        ],
                        [
                            0.9999995927254243,
                            4.0727437414092665e-07,
                            1.2232388400351768e-81,
                            3.7460736748592415e-50,
                            7.137379345589629e-16,
                            1.1948425475373315e-32,
                            6.278488630352924e-45,
                            0.0,
                            0.0,
                            1.5586080576083393e-14,
                            1.8486330319994155e-13,
                            0.0
                        ],
                        [
                            0.9999999096146239,
                            9.038536675233438e-08,
                            1.0111266984521741e-94,
                            3.443785384795896e-58,
                            1.5561702877318961e-18,
                            1.4844010250533003e-37,
                            1.6612812761592684e-52,
                            0.0,
                            0.0,
                            4.830049721816061e-16,
                            8.548286345278861e-15,
                            0.0
                        ],
                        [
                            0.9999999799410069,
                            2.005899296130553e-08,
                            8.353242786258432e-108,
                            3.1606839411588757e-66,
                            3.389993966278218e-21,
                            1.8424374772301534e-42,
                            4.390526807165683e-60,
                            0.0,
                            0.0,
                            1.4976454547976538e-17,
                            3.9540683360135945e-16,
                            0.0
                        ],
                        [
                            0.9999999955483639,
                            4.45163581239733e-09,
                            6.897000036642657e-121,
                            2.896093114598971e-74,
                            7.378438889662027e-24,
                            2.284734794664294e-47,
                            1.1589811152332836e-67,
                            0.0,
                            0.0,
                            4.646311409879568e-19,
                            1.829553613807726e-17,
                            0.0
                        ],
                        [
                            0.999999999012068,
                            9.879319589793869e-10,
                            5.691427728624873e-134,
                            2.649302280711923e-82,
                            1.6045526161970086e-26,
                            2.830615024125672e-52,
                            3.0557869626812353e-75,
                            0.0,
                            0.0,
                            1.442276746014403e-20,
                            8.468002944276935e-19,
                            0.0
                        ],
                        [
                            0.9999999997807606,
                            2.1923990381758848e-10,
                            4.693948811516756e-147,
                            2.419575032854519e-90,
                            3.486322047849256e-29,
                            3.5037105522302204e-57,
                            8.047434890178148e-83,
                            0.0,
                            0.0,
                            4.47949402530273e-22,
                            3.920584038939362e-20,
                            0.0
                        ],
                        [
                            0.9999999999513545,
                            4.864569762685915e-11,
                            3.8691168387064974e-160,
                            2.2061564069287735e-98,
                            7.568420222366156e-32,
                            4.33289788427268e-62,
                            2.116802003873346e-90,
                            0.0,
                            0.0,
                            1.392029618490404e-23,
                            1.8157390171401247e-21,
                            0.0
                        ],
                        [
                            0.9999999999892136,
                            1.0786066326108728e-11,
                            3.1874395539108053e-173,
                            2.0082795150035196e-106,
                            1.6415998521015872e-34,
                            5.353427472151905e-67,
                            5.5615014726114104e-98,
                            0.0,
                            0.0,
                            4.328187619700265e-25,
                            8.411767364782138e-23,
                            0.0
                        ],
                        [
                            0.9999999999976158,
                            2.3839508284375698e-12,
                            2.624393361273729e-186,
                            1.8251715832285918e-114,
                            3.5575731187017245e-37,
                            6.608289226476661e-72,
                            1.4594647357556277e-105,
                            0.0,
                            0.0,
                            1.3464672185215922e-26,
                            3.8979399851491295e-24,
                            0.0
                        ],
                        [
                            0.99999999999948,
                            5.192855430010406e-13,
                            2.1595984532793435e-199,
                            1.6560595279779718e-122,
                            7.703074923171253e-40,
                            8.149861475194566e-77,
                            3.825476733214549e-113,
                            0.0,
                            0.0,
                            4.1894163896068025e-28,
                            1.8052945551497383e-25,
                            0.0
                        ],
                        [
                            0.9999999999998953,
                            1.0546475302376446e-13,
                            1.7761286853451245e-212,
                            1.5001749469675795e-130,
                            1.6649758563249458e-42,
                            1.0041848196932604e-81,
                            1.0015406961395109e-120,
                            0.0,
                            0.0,
                            1.287961275692407e-29,
                            8.21177015023102e-27,
                            0.0
                        ]
                    ],
                    "K": [
                        [
                            0.47244828391656657,
                            1.0765548606738407,
                            4750464155635.615,
                            23934296.44577967,
                            174.19961414122218,
                            27033.580082101944,
                            10698203.865063554,
                            11.81980848668156,
                            2.6815590341919266,
                            26.37056793266258,
                            16.951072470024407,
                            556542.0384166664
                        ],
                        [
                            0.4675585275538009,
                            1.2588993157045738,
                            4999285087535.649,
                            26543268.920975998,
                            181.66506740314978,
                            28763.478375713505,
                            11591246.529207641,
                            7.500815134163139,
                            2.6754235875531034,
                            25.65556649435433,
                            16.475700147224227,
                            593976.1982914892
                        ],
                        [
                            0.4813869889161537,
                            1.7478041101044675,
                            5879718174168.451,
                            33928096.43669708,
                            211.76607038525677,
                            34473.95174440328,
                            14281260.284543274,
                            5.47249776611676,
                            2.8905591360661376,
                            26.777727075030423,
                            17.13934598157487,
                            714890.6088208128
                        ],
                        [
                            0.5584626800560842,
                            2.8615735154717545,
                            8224522526895.625,
                            53098239.354595,
                            295.64487513172486,
                            49596.53973522464,
                            21277803.75290225,
                            5.544425814337386,
                            3.6055861824453626,
                            32.21564446232833,
                            20.63232489017384,
                            1033038.929641235
                        ],
                        [
                            0.6550691819915889,
                            3.9998558792366796,
                            10833757049599.322,
                            76242657.74723673,
                            391.70261244996385,
                            66883.92492911742,
                            29428614.80976773,
                            6.228765623748511,
                            4.349670555055827,
                            38.08095698377711,
                            24.53180340021428,
                            1396589.8674266646
                        ],
                        [
                            0.6989272734109763,
                            4.49351046331851,
                            12018355246431.719,
                            87483109.08568904,
                            436.2276961186942,
                            74914.5447570338,
                            33277721.209172443,
                            6.539362409242048,
                            4.66219412111681,
                            40.558988749354484,
                            26.21953030889809,
                            1565488.1747175655
                        ],
                        [
                            0.711143765550047,
                            4.6291942541473015,
                            12353545009247.451,
                            90802822.13981384,
                            448.9716253934266,
                            77221.2157090165,
                            34395546.951347,
                            6.618980524985911,
                            4.744958794468543,
                            41.210260746834834,
                            26.6706311188426,
                            1614018.6067303417
                        ],
                        [
                            0.7140666453344788,
                            4.661057503759606,
                            12437508933878.387,
                            91705032.2096634,
                            452.2162124804631,
                            77816.46804366697,
                            34690640.58422222,
                            6.631932061735681,
                            4.762096812826176,
                            41.33769707586358,
                            26.7630654747204,
                            1626562.7167779244
                        ],
                        [
                            0.7147408377084247,
                            4.667866714387069,
                            12460520029810.16,
                            92015598.3263901,
                            453.1493377748417,
                            77995.23609111694,
                            34785105.08453134,
                            6.6288680132220215,
                            4.7634727455379196,
                            41.33921471574066,
                            26.76900605709372,
                            1630349.501491677
                        ],
                        [
                            0.7148958775203138,
                            4.6688959067874345,
                            12469441406175.566,
                            92189012.151456,
                            453.54786017164474,
                            78077.63442533996,
                            34833109.51903416,
                            6.622133193121247,
                            4.761224884846059,
                            41.3118206083459,
                            26.75506519160908,
                            1632109.8279712938
                        ],
                        [
                            0.7149323300494393,
                            4.6686061359229845,
                            12475141004827.754,
                            92331020.62056127,
                            453.82432659057395,
                            78137.98546850566,
                            34870475.3126988,
                            6.61457951200624,
                            4.758158117782788,
                            41.27794219155037,
                            26.736662064450037,
                            1633406.406559657
                        ],
                        [
                            0.7149417520941614,
                            4.668016992463017,
                            12480105006912.41,
                            92465853.42664412,
                            454.0731657796921,
                            78193.30093157654,
                            34905404.70039909,
                            6.606857880032694,
                            4.754912972497653,
                            41.24270214817077,
                            26.717320666799903,
                            1634596.924283831
                        ],
                        [
                            0.7149450095698635,
                            4.667360852486672,
                            12484900431595.07,
                            92599043.39394173,
                            454.31592234851763,
                            78247.46230286312,
                            34939769.702708535,
                            6.599116398087027,
                            4.751635307160281,
                            41.20726689920362,
                            26.697843742398586,
                            1635762.9929961509
                        ],
                        [
                            0.7149468573692425,
                            4.666690669359957,
                            12489656579673.838,
                            92731853.73813191,
                            454.5575101489286,
                            78301.35506350748,
                            34973997.526015304,
                            6.591388696277869,
                            4.748358302067406,
                            41.17190147797501,
                            26.678413745759183,
                            1636923.2312156316
                        ],
                        [
                            0.7149483774677277,
                            4.666018487882342,
                            12494402890457.125,
                            92864572.5047052,
                            454.7990473118573,
                            78355.18091320642,
                            35008185.54045071,
                            6.583682334369869,
                            4.7450894612671375,
                            41.13666547223672,
                            26.659071695182178,
                            1638081.8805438024
                        ],
                        [
                            0.7149498177124435,
                            4.665347062124726,
                            12499146109476.068,
                            92997265.88566117,
                            455.04078904266646,
                            78408.98610088865,
                            35042356.11220398,
                            6.5759989581299525,
                            4.741830460754932,
                            41.101571830447334,
                            26.63982648801809,
                            1639239.9141560085
                        ],
                        [
                            0.7149512334120696,
                            4.664677000794821,
                            12503887739312.717,
                            93129948.7605626,
                            455.2827911108959,
                            78462.78094764217,
                            35076514.26794173,
                            6.56833884983907,
                            4.738581631865033,
                            41.066622740995456,
                            26.620679608337802,
                            1640397.5498302553
                        ],
                        [
                            0.7149526383514926,
                            4.664008450512975,
                            12508628152028.428,
                            93262624.9322349,
                            455.52506627583494,
                            78516.56802463868,
                            35110661.29289006,
                            6.56070199887482,
                            4.735343016638858,
                            41.031818080412535,
                            26.601630947168275,
                            1641554.8423953357
                        ],
                        [
                            0.7149540346098153,
                            4.6633414270339575,
                            12513367399835.639,
                            93395295.06479357,
                            455.76761512936866,
                            78570.34770934768,
                            35144797.41271518,
                            6.553088312377449,
                            4.73211457561411,
                            40.99715707653578,
                            26.58267994862786,
                            1642711.800552879
                        ],
                        [
                            0.7149554237262326,
                            4.662675940610811,
                            12518105521006.994,
                            93527959.6846414,
                            456.01043774476636,
                            78624.12028357467,
                            35178922.80655973,
                            6.545497694636398,
                            4.728896266165933,
                            40.96263893624585,
                            26.563826042828413,
                            1643868.4309866014
                        ],
                        [
                            0.7149568050941856,
                            4.662011977166962,
                            12522842494572.781,
                            93660618.73434287,
                            456.2535319476477,
                            78677.88562232052,
                            35213037.45672382,
                            6.537930035325027,
                            4.725688030897438,
                            40.92826275202105,
                            26.54506858133097,
                            1645024.7318229459
                        ],
                        [
                            0.9307613742959939,
                            7.0431316936534705,
                            18658232519468.965,
                            159476185.87838823,
                            698.0085465436231,
                            122123.89454960116,
                            56618375.38466874,
                            7.959846717334345,
                            6.14915618115387,
                            52.50175752760122,
                            34.80819859532557,
                            2557754.6660484117
                        ],
                        [
                            0.9783240585476457,
                            7.559160586654978,
                            20075044858964.08,
                            176172123.51452267,
                            756.0731244991165,
                            132516.40625794136,
                            61845442.33472009,
                            8.24263356888134,
                            6.44204456995917,
                            54.92571644340984,
                            36.614135582482945,
                            2775837.18185313
                        ],
                        [
                            0.984524654861668,
                            7.625975784841677,
                            20270566140566.297,
                            178657706.02337208,
                            764.3112556806464,
                            133994.5176334516,
                            62602605.11641066,
                            8.271194512335363,
                            6.47648669896535,
                            55.20909793090994,
                            36.837097190414745,
                            2806853.674675137
                        ],
                        [
                            0.9852682484044001,
                            7.63361086715145,
                            20303180250481.965,
                            179210957.08070526,
                            765.8444897645523,
                            134274.8156789124,
                            62756730.21715549,
                            8.266728320808447,
                            6.4771931082209555,
                            55.21173771027295,
                            36.85065267828185,
                            2812742.9262594185
                        ],
                        [
                            0.9853569209369618,
                            7.634145538592639,
                            20316199303511.36,
                            179531059.63783345,
                            766.5704164716287,
                            134410.86079805647,
                            62838174.7192454,
                            8.258335566128872,
                            6.473868190367483,
                            55.18084421995647,
                            36.83914493620696,
                            2815606.052330104
                        ],
                        [
                            0.985367911542175,
                            7.6338390912857825,
                            20326888485192.305,
                            179823478.6580597,
                            767.2007656182847,
                            134529.75756193598,
                            62910971.327521525,
                            8.249504775446484,
                            6.470076164005235,
                            55.14610908334948,
                            36.82475130902936,
                            2818109.2044242634
                        ],
                        [
                            0.9853696995378864,
                            7.633434106072986,
                            20337297946286.938,
                            180112647.4496366,
                            767.8201080828919,
                            134646.60730671202,
                            62982730.073717535,
                            8.240649266847626,
                            6.466239571043471,
                            55.11105338979705,
                            36.810103485019965,
                            2820569.140292735
                        ],
                        [
                            0.9853703965166596,
                            7.6330185444521925,
                            20347670730720.688,
                            180401466.0712053,
                            768.4384738855198,
                            134763.201097294,
                            63054353.78829577,
                            8.23181781566148,
                            6.4624083874051905,
                            55.07609339547177,
                            36.795512789901736,
                            2823023.428285666
                        ],
                        [
                            0.985370963145358,
                            7.632602819533151,
                            20358035650032.83,
                            180690278.80035374,
                            769.0570512563152,
                            134879.75135694494,
                            63125949.614829905,
                            8.223016047399414,
                            6.458588474918428,
                            55.04127760100306,
                            36.78101557119227,
                            2825476.5247943923
                        ],
                        [
                            0.99982250854574,
                            7.743130106289218,
                            20741679467973.758,
                            185674093.92399424,
                            785.3861341852311,
                            137805.33849214495,
                            64631463.007809475,
                            8.275096461240734,
                            6.523847843910166,
                            55.580984495920916,
                            37.211798659249546,
                            2886845.035683039
                        ],
                        [
                            0.999967481350033,
                            7.744181706531892,
                            20756551226889.824,
                            186023581.3505387,
                            786.2030039654882,
                            137956.70817995677,
                            64721019.17548801,
                            8.26711384588933,
                            6.520866280047023,
                            55.553538576530826,
                            37.20309028911239,
                            2890026.0100674448
                        ],
                        [
                            0.9999927984015095,
                            7.744037041780011,
                            20767939461332.645,
                            186330601.33621716,
                            786.8751940561954,
                            138082.18457440613,
                            64797449.23691654,
                            8.25850206167901,
                            6.517205486426224,
                            55.52046217218794,
                            37.190101444094104,
                            2892663.732457761
                        ],
                        [
                            0.9999984018170641,
                            7.743679547449694,
                            20778727009106.055,
                            186630443.8323117,
                            787.5229614113684,
                            138203.22526863622,
                            64871631.305900075,
                            8.249802317126282,
                            6.513435577288701,
                            55.48652003885351,
                            37.17644619504824,
                            2895208.1649035313
                        ],
                        [
                            0.9999996453225777,
                            7.743275887114907,
                            20789378354375.99,
                            186928729.75837946,
                            788.1656068788939,
                            138323.27166757814,
                            64945305.00695864,
                            8.241106318412276,
                            6.5096507612910495,
                            55.45250051905183,
                            37.16271771051054,
                            2897731.4694389356
                        ],
                        [
                            0.9999999212880015,
                            7.742862933135323,
                            20799996277319.508,
                            187226704.18076414,
                            788.8074022084096,
                            138443.08556611513,
                            65018855.532956384,
                            8.232434217218183,
                            6.505871820717431,
                            55.41857730194786,
                            37.14904677943402,
                            2900249.6202690084
                        ],
                        [
                            0.9999999825317882,
                            7.742448864366102,
                            20810603609120.824,
                            187524644.06550658,
                            789.4492956271474,
                            138562.83626734983,
                            65092368.5445476,
                            8.223790358579395,
                            6.502103319557162,
                            55.384788266309734,
                            37.13546199041638,
                            2902766.1681569912
                        ],
                        [
                            0.9999999961233594,
                            7.742035491650941,
                            20821205425410.74,
                            187822611.1336422,
                            790.0914968577416,
                            138682.56143326475,
                            65165863.13632252,
                            8.215175583033881,
                            6.498346224378255,
                            55.351141158785246,
                            37.121969245627156,
                            2905281.903663031
                        ],
                        [
                            0.999999999139681,
                            7.741623212538563,
                            20831802858389.13,
                            188120619.24654394,
                            790.734051522967,
                            138802.26947621198,
                            65239343.60881925,
                            8.206589954810262,
                            6.49460070401425,
                            55.31763704442225,
                            37.108569413938554,
                            2907797.0040622624
                        ],
                        [
                            0.9999999998090817,
                            7.741212110937211,
                            20842396164440.348,
                            188418671.62339982,
                            791.3769687881386,
                            138921.96230943486,
                            65312810.97442328,
                            8.198033366865289,
                            6.4908667506500235,
                            55.284275510681944,
                            37.09526225034123,
                            2910311.510360291
                        ],
                        [
                            0.9999999999576388,
                            7.7408022011727695,
                            20852985405438.31,
                            188716769.11639148,
                            792.0202497256766,
                            139041.64040208445,
                            65386265.5144723,
                            8.189505675062163,
                            6.487144317602239,
                            55.25105582225448,
                            37.08204726612429,
                            2912825.4332797457
                        ],
                        [
                            0.9999999999906071,
                            7.740393482155181,
                            20863570600058.562,
                            189014912.05062777,
                            792.6638936182736,
                            139161.30390237278,
                            65459707.347553015,
                            8.181006727916872,
                            6.483433349882016,
                            55.217977177275785,
                            37.068923922037705,
                            2915338.7768085417
                        ],
                        [
                            0.9999999999979238,
                            7.739985949399762,
                            20874151757387.223,
                            189313100.63326988,
                            793.3078993589583,
                            139280.95288711807,
                            65533136.55579215,
                            8.172536373189455,
                            6.479733790972176,
                            55.18503876414267,
                            37.055891671135974,
                            2917851.543432312
                        ],
                        [
                            0.999999999999547,
                            7.739579597695288,
                            20884728884382.35,
                            189611335.0444746,
                            793.9522657627766,
                            139400.5874172272,
                            65606553.21293936,
                            8.164094459336454,
                            6.476045584327792,
                            55.15223977407074,
                            37.042949968260494,
                            2920363.735296907
                        ],
                        [
                            0.9999999999999089,
                            7.739174421695711,
                            20895301987532.402,
                            189909615.45763564,
                            794.5969916354251,
                            139520.20754997828,
                            65679957.39059597,
                            8.15568083582509,
                            6.472368673706367,
                            55.11957940382297,
                            37.03009827211097,
                            2922875.3544666884
                        ]
                    ],
                    "HV": [
                        [
                            3277.4054561704424
                        ],
                        [
                            3360.7968985143293
                        ],
                        [
                            3490.493003333311
                        ],
                        [
                            3640.611271829261
                        ],
                        [
                            3718.6019968437677
                        ],
                        [
                            3738.635954255372
                        ],
                        [
                            3744.830268317993
                        ],
                        [
                            3748.4033630959525
                        ],
                        [
                            3751.423255009448
                        ],
                        [
                            3754.3163525412615
                        ],
                        [
                            3757.176937761486
                        ],
                        [
                            3760.026295473853
                        ],
                        [
                            3762.8692668590647
                        ],
                        [
                            3765.706966672958
                        ],
                        [
                            3768.53966320671
                        ],
                        [
                            3771.367432830504
                        ],
                        [
                            3774.1903078154196
                        ],
                        [
                            3777.0083106942657
                        ],
                        [
                            3779.821461340603
                        ],
                        [
                            3782.62977926213
                        ],
                        [
                            3785.433283484905
                        ],
                        [
                            3754.9398682556184
                        ],
                        [
                            3734.0588981242117
                        ],
                        [
                            3733.1787222949783
                        ],
                        [
                            3735.313055331486
                        ],
                        [
                            3737.8114622141115
                        ],
                        [
                            3740.3493505957804
                        ],
                        [
                            3742.8880827017497
                        ],
                        [
                            3745.423087541331
                        ],
                        [
                            3747.953837638582
                        ],
                        [
                            3758.2605372621106
                        ],
                        [
                            3760.730293878295
                        ],
                        [
                            3763.231574515077
                        ],
                        [
                            3765.7404593407855
                        ],
                        [
                            3768.247747495444
                        ],
                        [
                            3770.751397335136
                        ],
                        [
                            3773.2509675611523
                        ],
                        [
                            3775.746372594569
                        ],
                        [
                            3778.237605859202
                        ],
                        [
                            3780.7246782672705
                        ],
                        [
                            3783.2076045455397
                        ],
                        [
                            3785.686400196176
                        ],
                        [
                            3788.1610808218006
                        ],
                        [
                            3790.6316619759245
                        ],
                        [
                            3793.0981591303957
                        ]
                    ],
                    "HL": [
                        [
                            -34154.59863487925
                        ],
                        [
                            -35257.729422819444
                        ],
                        [
                            -36540.495357844855
                        ],
                        [
                            -37197.555988131455
                        ],
                        [
                            -37193.697852065714
                        ],
                        [
                            -37135.336425174064
                        ],
                        [
                            -37113.271629656694
                        ],
                        [
                            -37104.38461327957
                        ],
                        [
                            -37098.80831320479
                        ],
                        [
                            -37094.0091775281
                        ],
                        [
                            -37089.394883221205
                        ],
                        [
                            -37084.82972952373
                        ],
                        [
                            -37080.282745483906
                        ],
                        [
                            -37075.74684398235
                        ],
                        [
                            -37071.22038329543
                        ],
                        [
                            -37066.70295911289
                        ],
                        [
                            -37062.19445244442
                        ],
                        [
                            -37057.6948064786
                        ],
                        [
                            -37053.20398162449
                        ],
                        [
                            -37048.72193966588
                        ],
                        [
                            -37044.24864547895
                        ],
                        [
                            -36673.62350876132
                        ],
                        [
                            -36585.76775569371
                        ],
                        [
                            -36570.46638284058
                        ],
                        [
                            -36564.66080256554
                        ],
                        [
                            -36560.001316592476
                        ],
                        [
                            -36555.48545298472
                        ],
                        [
                            -36550.99425087147
                        ],
                        [
                            -36546.5135855186
                        ],
                        [
                            -36542.04175319835
                        ],
                        [
                            -36506.98304471479
                        ],
                        [
                            -36502.26163229984
                        ],
                        [
                            -36497.766414643294
                        ],
                        [
                            -36493.31351002039
                        ],
                        [
                            -36488.8765341392
                        ],
                        [
                            -36484.44963627961
                        ],
                        [
                            -36480.031491937945
                        ],
                        [
                            -36475.62178137734
                        ],
                        [
                            -36471.220408044166
                        ],
                        [
                            -36466.827325078826
                        ],
                        [
                            -36462.4424968048
                        ],
                        [
                            -36458.06589017939
                        ],
                        [
                            -36453.69747289457
                        ],
                        [
                            -36449.3372129545
                        ],
                        [
                            -36444.985078580205
                        ]
                    ],
                    "hydraulics": {
                        "Q_L": [
                            34409.593574285704,
                            29246.20552022335,
                            23015.729886754158,
                            18376.21996999454,
                            16660.273083285396,
                            16226.192487305567,
                            16126.730951197977,
                            16105.1478084709,
                            16101.365739800165,
                            16101.638996122281,
                            16102.834286230069,
                            16104.237805677656,
                            16105.686953221802,
                            16107.144674400754,
                            16108.602541583079,
                            16110.058630922944,
                            16111.512520266808,
                            16112.964111510888,
                            16114.413397833234,
                            16115.8603765937,
                            16297.327952704258,
                            15268.690184054365,
                            15152.792544581665,
                            15140.757580501699,
                            15140.819982679783,
                            15142.309416925122,
                            15143.965519615807,
                            15145.639075722045,
                            15147.31242128533,
                            31182.17465695933,
                            31220.717579270422,
                            31224.76853382132,
                            31229.125903940363,
                            31233.56380601463,
                            31238.014402227232,
                            31242.462615663742,
                            31246.905119010764,
                            31251.341192883792,
                            31255.77069664634,
                            31260.193618011424,
                            31264.609973071743,
                            31269.019784110842,
                            31273.423074679184,
                            31277.819868501836,
                            13068.862866888192
                        ],
                        "Q_V": [
                            13292446.59852577,
                            13054323.913063265,
                            12928675.30032767,
                            12834292.639769968,
                            12838796.310229773,
                            12878761.898868771,
                            12881091.887379652,
                            12862427.955230651,
                            12837911.829954404,
                            12812081.807934849,
                            12786035.926988557,
                            12760026.77755175,
                            12734111.400197692,
                            12708302.22179042,
                            12682601.520186711,
                            12657009.272847464,
                            12631524.935951503,
                            12606147.854348332,
                            12580877.349624176,
                            12555712.744963476,
                            12530653.366128793,
                            9192397.054337827,
                            9293663.59872285,
                            9298672.430521337,
                            9283597.981109418,
                            9266013.967671575,
                            9248194.87755945,
                            9230412.222882397,
                            9212697.747391105,
                            9195054.80849151,
                            9932696.20677869,
                            9927744.504774662,
                            9909888.820550926,
                            9891992.41845039,
                            9874148.022284886,
                            9856369.71931954,
                            9838660.28826203,
                            9821020.018181538,
                            9803448.649170943,
                            9785945.802301772,
                            9768511.074867457,
                            9751144.061461331,
                            9733844.358621046,
                            9716611.56583214,
                            9699445.28572491
                        ],
                        "F_factor": [
                            3237.738802347878,
                            3102.4583712558633,
                            2959.2039943181762,
                            2788.967487603179,
                            2668.151844591007,
                            2627.576246338879,
                            2616.6461311206717,
                            2612.188434772883,
                            2609.120759703217,
                            2606.3696012280216,
                            2603.6967500926307,
                            2601.0483224578566,
                            2598.4120430496682,
                            2595.785082669167,
                            2593.1667630133575,
                            2590.556893328727,
                            2587.9553961628835,
                            2585.3622181751452,
                            2582.7773136285136,
                            2580.200637023997,
                            2577.6321448385324,
                            1719.7755767318738,
                            1701.7432388436491,
                            1699.274162259649,
                            1697.5876952939325,
                            1695.9706795114023,
                            1694.365849508603,
                            1692.7668405108673,
                            1691.1728837691767,
                            1689.5838657945276,
                            1807.265195937735,
                            1807.9787835640666,
                            1806.4576092978662,
                            1804.9381242331533,
                            1803.423633586058,
                            1801.9137573974583,
                            1800.4083913253078,
                            1798.9074945585005,
                            1797.4110404821747,
                            1795.9190057498938,
                            1794.431367863301,
                            1792.9481046351782,
                            1791.4691940694188,
                            1789.9946143333596,
                            1788.5243437505271
                        ],
                        "delta_P_tray": [
                            null,
                            null,
                            null,
                            null,
                            null,
                            642090074.2635106,
                            636759289.9585949,
                            634591582.5478201,
                            633101967.4847229,
                            631767536.7258871,
                            630472436.6903284,
                            629190481.4456162,
                            627915702.1554371,
                            626646714.9585292,
                            625383179.0275745,
                            624124989.8243625,
                            622872097.7604119,
                            621624465.0313469,
                            620382057.6272917,
                            619144841.7788904,
                            617912784.7892724,
                            275060912.7951321,
                            269322969.74885,
                            268542009.9375808,
                            268009238.40158504,
                            267498903.9633741,
                            266992896.2492871,
                            266489200.35402206,
                            265987569.26619402,
                            265487962.82662463,
                            303758956.8431348,
                            303998878.9120667,
                            303487544.70171565,
                            302977207.9911747,
                            302468976.04436225,
                            301962717.2943009,
                            301458392.91141087,
                            300955985.4518614,
                            300455482.27470005,
                            299956871.8714579,
                            299460143.0535791,
                            298965284.77199537,
                            298472286.0765192,
                            297981136.1061903,
                            297491824.0864613
                        ],
                        "alarms": [
                            {
                                "tray": 0,
                                "metric": "F_factor",
                                "value": 3237.738802347878,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 00 F_factor 3237.74 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 0,
                                "metric": "Q_L",
                                "value": 34409.593574285704,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 00 Q_L 34409.59 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 1,
                                "metric": "F_factor",
                                "value": 3102.4583712558633,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 01 F_factor 3102.46 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 1,
                                "metric": "Q_L",
                                "value": 29246.20552022335,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 01 Q_L 29246.21 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 2,
                                "metric": "F_factor",
                                "value": 2959.2039943181762,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 02 F_factor 2959.20 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 2,
                                "metric": "Q_L",
                                "value": 23015.729886754158,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 02 Q_L 23015.73 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 3,
                                "metric": "F_factor",
                                "value": 2788.967487603179,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 03 F_factor 2788.97 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 3,
                                "metric": "Q_L",
                                "value": 18376.21996999454,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 03 Q_L 18376.22 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 4,
                                "metric": "F_factor",
                                "value": 2668.151844591007,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 04 F_factor 2668.15 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 4,
                                "metric": "Q_L",
                                "value": 16660.273083285396,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 04 Q_L 16660.27 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 5,
                                "metric": "F_factor",
                                "value": 2627.576246338879,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 05 F_factor 2627.58 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 5,
                                "metric": "Q_L",
                                "value": 16226.192487305567,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 05 Q_L 16226.19 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 5,
                                "metric": "delta_P_tray",
                                "value": 642090074.2635106,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 05 delta_P_tray 642090074.26 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 6,
                                "metric": "F_factor",
                                "value": 2616.6461311206717,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 06 F_factor 2616.65 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 6,
                                "metric": "Q_L",
                                "value": 16126.730951197977,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 06 Q_L 16126.73 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 6,
                                "metric": "delta_P_tray",
                                "value": 636759289.9585949,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 06 delta_P_tray 636759289.96 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 7,
                                "metric": "F_factor",
                                "value": 2612.188434772883,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 07 F_factor 2612.19 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 7,
                                "metric": "Q_L",
                                "value": 16105.1478084709,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 07 Q_L 16105.15 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 7,
                                "metric": "delta_P_tray",
                                "value": 634591582.5478201,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 07 delta_P_tray 634591582.55 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 8,
                                "metric": "F_factor",
                                "value": 2609.120759703217,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 08 F_factor 2609.12 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 8,
                                "metric": "Q_L",
                                "value": 16101.365739800165,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 08 Q_L 16101.37 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 8,
                                "metric": "delta_P_tray",
                                "value": 633101967.4847229,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 08 delta_P_tray 633101967.48 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 9,
                                "metric": "F_factor",
                                "value": 2606.3696012280216,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 09 F_factor 2606.37 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 9,
                                "metric": "Q_L",
                                "value": 16101.638996122281,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 09 Q_L 16101.64 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 9,
                                "metric": "delta_P_tray",
                                "value": 631767536.7258871,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 09 delta_P_tray 631767536.73 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 10,
                                "metric": "F_factor",
                                "value": 2603.6967500926307,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 10 F_factor 2603.70 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 10,
                                "metric": "Q_L",
                                "value": 16102.834286230069,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 10 Q_L 16102.83 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 10,
                                "metric": "delta_P_tray",
                                "value": 630472436.6903284,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 10 delta_P_tray 630472436.69 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 11,
                                "metric": "F_factor",
                                "value": 2601.0483224578566,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 11 F_factor 2601.05 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 11,
                                "metric": "Q_L",
                                "value": 16104.237805677656,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 11 Q_L 16104.24 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 11,
                                "metric": "delta_P_tray",
                                "value": 629190481.4456162,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 11 delta_P_tray 629190481.45 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 12,
                                "metric": "F_factor",
                                "value": 2598.4120430496682,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 12 F_factor 2598.41 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 12,
                                "metric": "Q_L",
                                "value": 16105.686953221802,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 12 Q_L 16105.69 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 12,
                                "metric": "delta_P_tray",
                                "value": 627915702.1554371,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 12 delta_P_tray 627915702.16 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 13,
                                "metric": "F_factor",
                                "value": 2595.785082669167,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 13 F_factor 2595.79 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 13,
                                "metric": "Q_L",
                                "value": 16107.144674400754,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 13 Q_L 16107.14 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 13,
                                "metric": "delta_P_tray",
                                "value": 626646714.9585292,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 13 delta_P_tray 626646714.96 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 14,
                                "metric": "F_factor",
                                "value": 2593.1667630133575,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 14 F_factor 2593.17 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 14,
                                "metric": "Q_L",
                                "value": 16108.602541583079,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 14 Q_L 16108.60 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 14,
                                "metric": "delta_P_tray",
                                "value": 625383179.0275745,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 14 delta_P_tray 625383179.03 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 15,
                                "metric": "F_factor",
                                "value": 2590.556893328727,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 15 F_factor 2590.56 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 15,
                                "metric": "Q_L",
                                "value": 16110.058630922944,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 15 Q_L 16110.06 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 15,
                                "metric": "delta_P_tray",
                                "value": 624124989.8243625,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 15 delta_P_tray 624124989.82 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 16,
                                "metric": "F_factor",
                                "value": 2587.9553961628835,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 16 F_factor 2587.96 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 16,
                                "metric": "Q_L",
                                "value": 16111.512520266808,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 16 Q_L 16111.51 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 16,
                                "metric": "delta_P_tray",
                                "value": 622872097.7604119,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 16 delta_P_tray 622872097.76 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 17,
                                "metric": "F_factor",
                                "value": 2585.3622181751452,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 17 F_factor 2585.36 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 17,
                                "metric": "Q_L",
                                "value": 16112.964111510888,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 17 Q_L 16112.96 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 17,
                                "metric": "delta_P_tray",
                                "value": 621624465.0313469,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 17 delta_P_tray 621624465.03 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 18,
                                "metric": "F_factor",
                                "value": 2582.7773136285136,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 18 F_factor 2582.78 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 18,
                                "metric": "Q_L",
                                "value": 16114.413397833234,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 18 Q_L 16114.41 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 18,
                                "metric": "delta_P_tray",
                                "value": 620382057.6272917,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 18 delta_P_tray 620382057.63 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 19,
                                "metric": "F_factor",
                                "value": 2580.200637023997,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 19 F_factor 2580.20 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 19,
                                "metric": "Q_L",
                                "value": 16115.8603765937,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 19 Q_L 16115.86 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 19,
                                "metric": "delta_P_tray",
                                "value": 619144841.7788904,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 19 delta_P_tray 619144841.78 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 20,
                                "metric": "F_factor",
                                "value": 2577.6321448385324,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 20 F_factor 2577.63 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 20,
                                "metric": "Q_L",
                                "value": 16297.327952704258,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 20 Q_L 16297.33 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 20,
                                "metric": "delta_P_tray",
                                "value": 617912784.7892724,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 20 delta_P_tray 617912784.79 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 21,
                                "metric": "F_factor",
                                "value": 1719.7755767318738,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 21 F_factor 1719.78 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 21,
                                "metric": "Q_L",
                                "value": 15268.690184054365,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 21 Q_L 15268.69 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 21,
                                "metric": "delta_P_tray",
                                "value": 275060912.7951321,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 21 delta_P_tray 275060912.80 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 22,
                                "metric": "F_factor",
                                "value": 1701.7432388436491,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 22 F_factor 1701.74 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 22,
                                "metric": "Q_L",
                                "value": 15152.792544581665,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 22 Q_L 15152.79 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 22,
                                "metric": "delta_P_tray",
                                "value": 269322969.74885,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 22 delta_P_tray 269322969.75 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 23,
                                "metric": "F_factor",
                                "value": 1699.274162259649,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 23 F_factor 1699.27 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 23,
                                "metric": "Q_L",
                                "value": 15140.757580501699,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 23 Q_L 15140.76 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 23,
                                "metric": "delta_P_tray",
                                "value": 268542009.9375808,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 23 delta_P_tray 268542009.94 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 24,
                                "metric": "F_factor",
                                "value": 1697.5876952939325,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 24 F_factor 1697.59 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 24,
                                "metric": "Q_L",
                                "value": 15140.819982679783,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 24 Q_L 15140.82 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 24,
                                "metric": "delta_P_tray",
                                "value": 268009238.40158504,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 24 delta_P_tray 268009238.40 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 25,
                                "metric": "F_factor",
                                "value": 1695.9706795114023,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 25 F_factor 1695.97 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 25,
                                "metric": "Q_L",
                                "value": 15142.309416925122,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 25 Q_L 15142.31 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 25,
                                "metric": "delta_P_tray",
                                "value": 267498903.9633741,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 25 delta_P_tray 267498903.96 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 26,
                                "metric": "F_factor",
                                "value": 1694.365849508603,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 26 F_factor 1694.37 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 26,
                                "metric": "Q_L",
                                "value": 15143.965519615807,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 26 Q_L 15143.97 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 26,
                                "metric": "delta_P_tray",
                                "value": 266992896.2492871,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 26 delta_P_tray 266992896.25 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 27,
                                "metric": "F_factor",
                                "value": 1692.7668405108673,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 27 F_factor 1692.77 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 27,
                                "metric": "Q_L",
                                "value": 15145.639075722045,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 27 Q_L 15145.64 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 27,
                                "metric": "delta_P_tray",
                                "value": 266489200.35402206,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 27 delta_P_tray 266489200.35 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 28,
                                "metric": "F_factor",
                                "value": 1691.1728837691767,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 28 F_factor 1691.17 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 28,
                                "metric": "Q_L",
                                "value": 15147.31242128533,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 28 Q_L 15147.31 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 28,
                                "metric": "delta_P_tray",
                                "value": 265987569.26619402,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 28 delta_P_tray 265987569.27 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 29,
                                "metric": "F_factor",
                                "value": 1689.5838657945276,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 29 F_factor 1689.58 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 29,
                                "metric": "Q_L",
                                "value": 31182.17465695933,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 29 Q_L 31182.17 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 29,
                                "metric": "delta_P_tray",
                                "value": 265487962.82662463,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 29 delta_P_tray 265487962.83 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 30,
                                "metric": "F_factor",
                                "value": 1807.265195937735,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 30 F_factor 1807.27 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 30,
                                "metric": "Q_L",
                                "value": 31220.717579270422,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 30 Q_L 31220.72 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 30,
                                "metric": "delta_P_tray",
                                "value": 303758956.8431348,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 30 delta_P_tray 303758956.84 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 31,
                                "metric": "F_factor",
                                "value": 1807.9787835640666,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 31 F_factor 1807.98 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 31,
                                "metric": "Q_L",
                                "value": 31224.76853382132,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 31 Q_L 31224.77 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 31,
                                "metric": "delta_P_tray",
                                "value": 303998878.9120667,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 31 delta_P_tray 303998878.91 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 32,
                                "metric": "F_factor",
                                "value": 1806.4576092978662,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 32 F_factor 1806.46 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 32,
                                "metric": "Q_L",
                                "value": 31229.125903940363,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 32 Q_L 31229.13 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 32,
                                "metric": "delta_P_tray",
                                "value": 303487544.70171565,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 32 delta_P_tray 303487544.70 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 33,
                                "metric": "F_factor",
                                "value": 1804.9381242331533,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 33 F_factor 1804.94 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 33,
                                "metric": "Q_L",
                                "value": 31233.56380601463,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 33 Q_L 31233.56 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 33,
                                "metric": "delta_P_tray",
                                "value": 302977207.9911747,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 33 delta_P_tray 302977207.99 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 34,
                                "metric": "F_factor",
                                "value": 1803.423633586058,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 34 F_factor 1803.42 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 34,
                                "metric": "Q_L",
                                "value": 31238.014402227232,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 34 Q_L 31238.01 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 34,
                                "metric": "delta_P_tray",
                                "value": 302468976.04436225,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 34 delta_P_tray 302468976.04 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 35,
                                "metric": "F_factor",
                                "value": 1801.9137573974583,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 35 F_factor 1801.91 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 35,
                                "metric": "Q_L",
                                "value": 31242.462615663742,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 35 Q_L 31242.46 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 35,
                                "metric": "delta_P_tray",
                                "value": 301962717.2943009,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 35 delta_P_tray 301962717.29 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 36,
                                "metric": "F_factor",
                                "value": 1800.4083913253078,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 36 F_factor 1800.41 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 36,
                                "metric": "Q_L",
                                "value": 31246.905119010764,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 36 Q_L 31246.91 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 36,
                                "metric": "delta_P_tray",
                                "value": 301458392.91141087,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 36 delta_P_tray 301458392.91 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 37,
                                "metric": "F_factor",
                                "value": 1798.9074945585005,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 37 F_factor 1798.91 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 37,
                                "metric": "Q_L",
                                "value": 31251.341192883792,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 37 Q_L 31251.34 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 37,
                                "metric": "delta_P_tray",
                                "value": 300955985.4518614,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 37 delta_P_tray 300955985.45 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 38,
                                "metric": "F_factor",
                                "value": 1797.4110404821747,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 38 F_factor 1797.41 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 38,
                                "metric": "Q_L",
                                "value": 31255.77069664634,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 38 Q_L 31255.77 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 38,
                                "metric": "delta_P_tray",
                                "value": 300455482.27470005,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 38 delta_P_tray 300455482.27 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 39,
                                "metric": "F_factor",
                                "value": 1795.9190057498938,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 39 F_factor 1795.92 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 39,
                                "metric": "Q_L",
                                "value": 31260.193618011424,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 39 Q_L 31260.19 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 39,
                                "metric": "delta_P_tray",
                                "value": 299956871.8714579,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 39 delta_P_tray 299956871.87 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 40,
                                "metric": "F_factor",
                                "value": 1794.431367863301,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 40 F_factor 1794.43 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 40,
                                "metric": "Q_L",
                                "value": 31264.609973071743,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 40 Q_L 31264.61 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 40,
                                "metric": "delta_P_tray",
                                "value": 299460143.0535791,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 40 delta_P_tray 299460143.05 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 41,
                                "metric": "F_factor",
                                "value": 1792.9481046351782,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 41 F_factor 1792.95 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 41,
                                "metric": "Q_L",
                                "value": 31269.019784110842,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 41 Q_L 31269.02 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 41,
                                "metric": "delta_P_tray",
                                "value": 298965284.77199537,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 41 delta_P_tray 298965284.77 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 42,
                                "metric": "F_factor",
                                "value": 1791.4691940694188,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 42 F_factor 1791.47 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 42,
                                "metric": "Q_L",
                                "value": 31273.423074679184,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 42 Q_L 31273.42 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 42,
                                "metric": "delta_P_tray",
                                "value": 298472286.0765192,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 42 delta_P_tray 298472286.08 > 3500.0 – high ΔP"
                            },
                            {
                                "tray": 43,
                                "metric": "F_factor",
                                "value": 1789.9946143333596,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 43 F_factor 1789.99 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 43,
                                "metric": "Q_L",
                                "value": 31277.819868501836,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 43 Q_L 31277.82 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 43,
                                "metric": "delta_P_tray",
                                "value": 297981136.1061903,
                                "limit": 3500.0,
                                "comparison": ">",
                                "warning": "high ΔP",
                                "description": "Tray 43 delta_P_tray 297981136.11 > 3500.0 – high ΔP"
                            }
                        ]
                    }
                }
            },
            {
                "name": "E128-A",
                "type": "ShellAndTubeExchanger",
                "phase": "VL",
                "mode": "TP",
                "physical_method": "SRK",
                "result": {}
            },
            {
                "name": "P-110",
                "type": "Pump",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "result": {}
            },
            {
                "name": "P-111",
                "type": "Pump",
                "phase": "L",
                "mode": "TP",
                "physical_method": "SRK",
                "result": {}
            },
            {
                "name": "B14",
                "type": "Splitter",
                "phase": "VL",
                "mode": "TP",
                "physical_method": "SRK",
                "result": {}
            },
            {
                "name": "B7",
                "type": "Splitter",
                "phase": "VL",
                "mode": "TP",
                "physical_method": "SRK",
                "result": {}
            },
            {
                "name": "B6",
                "type": "Mixer",
                "phase": "VL",
                "mode": "TP",
                "physical_method": "SRK",
                "result": {}
            },
            {
                "name": "B11",
                "type": "Mixer",
                "phase": "VL",
                "mode": "TP",
                "physical_method": "SRK",
                "result": {}
            },
            {
                "name": "B12",
                "type": "Mixer",
                "phase": "VL",
                "mode": "TP",
                "physical_method": "SRK",
                "result": {}
            },
            {
                "name": "B13",
                "type": "Mixer",
                "phase": "VL",
                "mode": "TP",
                "physical_method": "SRK",
                "result": {}
            },
            {
                "name": "T-109A",
                "type": "DistilStrict",
                "phase": "VL",
                "mode": "TP",
                "physical_method": "NRTL",
                "result": {
                    "IsConverged": 1,
                    "outer_iter_count": 334,
                    "deltaT_max": 9.90992890592679e-06,
                    "deltax_max": 2.911430133645254e-07,
                    "T": [
                        280.79788810627855,
                        284.0344769544991,
                        284.66408581049143,
                        284.80926491711915,
                        284.8645121090485,
                        284.89843297018706,
                        284.92922196037847,
                        284.9551070171522,
                        284.979942971607,
                        285.00098077991254,
                        285.0199771685021,
                        285.0355208329852,
                        285.04817569368527,
                        285.0573370762942,
                        285.0629947936527,
                        285.0648372709315,
                        285.0626424199146
                    ],
                    "V": [
                        5347315.888814567,
                        5355008.4026418235,
                        5354534.507530414,
                        5354363.917320311,
                        5354245.68330544,
                        5354177.820681888,
                        5354090.501799633,
                        5354039.196287992,
                        5353974.528602322,
                        5353936.2782144295,
                        5353896.27813759,
                        5353874.5918563185,
                        5353859.762906868,
                        5353859.444136984,
                        5353870.7721101325,
                        5353896.306012887,
                        5353936.2807593485
                    ],
                    "V_kg_per_h": [
                        213473.51093511755,
                        213797.0997074114,
                        213779.66786721573,
                        213772.51205466382,
                        213773.2856936316,
                        213771.27173607357,
                        213772.20310425374,
                        213771.5537511587,
                        213772.09266538802,
                        213772.31995688847,
                        213772.91750523826,
                        213773.69412194952,
                        213774.65954932652,
                        213775.90443986125,
                        213777.37627973905,
                        213779.13520698258,
                        213781.17538872996
                    ],
                    "V_nm3_per_h": [
                        119847.90674993256,
                        120020.31692711511,
                        120009.69564752319,
                        120005.87225649525,
                        120003.2223103384,
                        120001.7013241935,
                        119999.74427032282,
                        119998.59437413141,
                        119997.14499524242,
                        119996.28769991583,
                        119995.39118929654,
                        119994.90514069391,
                        119994.57278356598,
                        119994.56563906504,
                        119994.8195297829,
                        119995.39181405783,
                        119996.2877569544
                    ],
                    "rho_V": [
                        1.538934654307536,
                        1.5320818485250296,
                        1.53924667780905,
                        1.5489969715320582,
                        1.5592719807000244,
                        1.569625803184591,
                        1.5800221063595459,
                        1.5904215116566787,
                        1.6008379524147114,
                        1.611264059627998,
                        1.6217037546359263,
                        1.632157829392574,
                        1.6426269197779946,
                        1.653113174163802,
                        1.6636174725731256,
                        1.6741416665636282,
                        1.6846873295332028
                    ],
                    "L": [
                        454081.9121602268,
                        453608.0170488158,
                        453437.42683871364,
                        453319.19282384263,
                        453251.33020029124,
                        453164.01131803734,
                        453112.7058063973,
                        453048.03812072496,
                        453009.78773283196,
                        452969.7876559932,
                        452948.10137472115,
                        452933.2724252695,
                        452932.9536553849,
                        452944.2816285339,
                        452969.8155312874,
                        453009.7902777497,
                        378569.66939517955
                    ],
                    "L_kg_per_h": [
                        8367.070331642451,
                        8347.211530926088,
                        8342.794363644283,
                        8340.924082733194,
                        8341.17659261021,
                        8340.36858842935,
                        8340.961028186563,
                        8340.722495156328,
                        8341.429414055196,
                        8341.796411697827,
                        8342.71474721812,
                        8343.648054724401,
                        8344.926385966428,
                        8346.398432903257,
                        8348.16168631937,
                        8350.20194161411,
                        6981.276446260078
                    ],
                    "L_m3_per_h": [
                        8.416975674460451,
                        8.395610672821682,
                        8.391071462285494,
                        8.389300659583292,
                        8.389820656538289,
                        8.389180517919621,
                        8.390044582408391,
                        8.38999490087533,
                        8.390955358102023,
                        8.391532491827014,
                        8.392691314863868,
                        8.393849674230765,
                        8.395364428366346,
                        8.397070504875307,
                        8.399072629118718,
                        8.401354139703432,
                        7.025499647728953
                    ],
                    "L_l_per_h": [
                        8416.975674460451,
                        8395.610672821682,
                        8391.071462285494,
                        8389.300659583292,
                        8389.820656538288,
                        8389.180517919622,
                        8390.04458240839,
                        8389.99490087533,
                        8390.95535810202,
                        8391.532491827014,
                        8392.691314863867,
                        8393.849674230765,
                        8395.364428366347,
                        8397.070504875308,
                        8399.072629118718,
                        8401.354139703431,
                        7025.499647728952
                    ],
                    "rho_L": [
                        994.0708700193317,
                        994.2351850530334,
                        994.2466109532976,
                        994.2335387879041,
                        994.2020138547099,
                        994.1815616691038,
                        994.1497862449094,
                        994.1272424714035,
                        994.0976990183833,
                        994.0730635104342,
                        994.0452274758114,
                        994.0192377211039,
                        993.9921556913602,
                        993.9655059532214,
                        993.9385042792885,
                        993.9114341285073,
                        993.7053300567497
                    ],
                    "sigma": [
                        69.81211576634003,
                        69.54690130136409,
                        69.47360740200065,
                        69.44215554265841,
                        69.39589591295204,
                        69.37079204358295,
                        69.32775054047623,
                        69.3001603504607,
                        69.26126077163913,
                        69.23069180165626,
                        69.19511790141497,
                        69.16291219957124,
                        69.12926101272222,
                        69.0967324401159,
                        69.06407744001068,
                        69.03181704879785,
                        68.94800322449517
                    ],
                    "P": [
                        90000.0,
                        90625.0,
                        91250.0,
                        91875.0,
                        92500.0,
                        93125.0,
                        93750.0,
                        94375.0,
                        95000.0,
                        95625.0,
                        96250.0,
                        96875.0,
                        97500.0,
                        98125.0,
                        98750.0,
                        99375.0,
                        100000.0
                    ],
                    "X": [
                        [
                            0.9841743656055736,
                            2.5867586229088146e-05,
                            4.117680008146021e-16,
                            7.608075877397504e-10,
                            0.01579776088419237,
                            5.05916917268955e-08,
                            6.340628850590729e-07,
                            0.0,
                            0.0,
                            5.40418653092449e-07,
                            7.800899670414186e-07,
                            0.0
                        ],
                        [
                            0.9851070869696851,
                            4.9851871138679545e-05,
                            3.356590611681254e-16,
                            5.978798770201569e-10,
                            0.014841077188864111,
                            4.215218543136103e-08,
                            5.086553092864239e-07,
                            0.0,
                            0.0,
                            5.624910077892151e-07,
                            8.700739293236839e-07,
                            0.0
                        ],
                        [
                            0.9852047279955407,
                            7.332080860677397e-05,
                            3.268821668546737e-16,
                            5.754713200976123e-10,
                            0.014719966521340123,
                            4.123200398427751e-08,
                            4.927912422305869e-07,
                            0.0,
                            0.0,
                            5.635220075583193e-07,
                            8.865537871321095e-07,
                            0.0
                        ],
                        [
                            0.9851682423891595,
                            9.633180863522104e-05,
                            3.2824990952622077e-16,
                            5.806603287381889e-10,
                            0.014733433417956656,
                            4.139517805556912e-08,
                            4.958788094351318e-07,
                            0.0,
                            0.0,
                            5.637499030079227e-07,
                            8.9077969755404e-07,
                            0.0
                        ],
                        [
                            0.985030442332115,
                            0.00011890532152077191,
                            3.2823244650690977e-16,
                            5.757325000245376e-10,
                            0.01484865159500773,
                            4.145430602089996e-08,
                            4.940384293046017e-07,
                            0.0,
                            0.0,
                            5.677720453608472e-07,
                            8.969108430419762e-07,
                            0.0
                        ],
                        [
                            0.9849524119826103,
                            0.0001410745840286551,
                            3.311683527706352e-16,
                            5.852888313107889e-10,
                            0.014904499429848546,
                            4.178807202798362e-08,
                            5.00076168682599e-07,
                            0.0,
                            0.0,
                            5.701489256019322e-07,
                            9.014050569012429e-07,
                            0.0
                        ],
                        [
                            0.9848119231823251,
                            0.00016284653611687384,
                            3.3186754010714127e-16,
                            5.82079595108019e-10,
                            0.015023206706474185,
                            4.1923221705659216e-08,
                            4.994979427401021e-07,
                            0.0,
                            0.0,
                            5.742360339957332e-07,
                            9.073358054095583e-07,
                            0.0
                        ],
                        [
                            0.9847212407185102,
                            0.00018425052246795993,
                            3.3444195177670636e-16,
                            5.899115774546422e-10,
                            0.015092471668885634,
                            4.2224392651486154e-08,
                            5.045843850973823e-07,
                            0.0,
                            0.0,
                            5.772342010621998e-07,
                            9.124572453049337e-07,
                            0.0
                        ],
                        [
                            0.984591722250747,
                            0.00020529248404459706,
                            3.357280643083999e-16,
                            5.893584836968979e-10,
                            0.015200937508546647,
                            4.241519471194892e-08,
                            5.054905337902907e-07,
                            0.0,
                            0.0,
                            5.810415271083656e-07,
                            9.182200473585967e-07,
                            0.0
                        ],
                        [
                            0.9844884681397116,
                            0.0002259988724273552,
                            3.379414527070553e-16,
                            5.94943509367338e-10,
                            0.015283472176622046,
                            4.268570827981981e-08,
                            5.094407390464637e-07,
                            0.0,
                            0.0,
                            5.844008325598647e-07,
                            9.236890151029392e-07,
                            0.0
                        ],
                        [
                            0.9843671712339496,
                            0.00024637840648523496,
                            3.396558923587882e-16,
                            5.966364922192689e-10,
                            0.015384377785886427,
                            4.291606101314607e-08,
                            5.115396566547756e-07,
                            0.0,
                            0.0,
                            5.880898250665277e-07,
                            9.294314991277846e-07,
                            0.0
                        ],
                        [
                            0.9842554605745594,
                            0.00026645343968056875,
                            3.4172420351501297e-16,
                            6.008606755094374e-10,
                            0.015476000543550012,
                            4.317659803120833e-08,
                            5.148676799246852e-07,
                            0.0,
                            0.0,
                            5.916642980143604e-07,
                            9.351327730600001e-07,
                            0.0
                        ],
                        [
                            0.984137279799396,
                            0.0002862361039119578,
                            3.4369222773784996e-16,
                            6.038580204924795e-10,
                            0.015574386068747326,
                            4.343094293967301e-08,
                            5.1766271229709e-07,
                            0.0,
                            0.0,
                            5.953663825702035e-07,
                            9.409640485215867e-07,
                            0.0
                        ],
                        [
                            0.9840209995245559,
                            0.00030574536498617486,
                            3.4579026399741966e-16,
                            6.076899786289985e-10,
                            0.015671144000373356,
                            4.3697275672592304e-08,
                            5.208743706608535e-07,
                            0.0,
                            0.0,
                            5.990800434937058e-07,
                            9.468507044497771e-07,
                            0.0
                        ],
                        [
                            0.9839023475151789,
                            0.00032499561965223535,
                            3.4792228744235357e-16,
                            6.113381070138097e-10,
                            0.015770532540161093,
                            4.3968485638652684e-08,
                            5.240492781334421e-07,
                            0.0,
                            0.0,
                            6.028642678198965e-07,
                            9.528316379235024e-07,
                            0.0
                        ],
                        [
                            0.9837829005587955,
                            0.0003440038350334504,
                            3.501294426636669e-16,
                            6.152565958370817e-10,
                            0.015870957742773115,
                            4.4247730355364315e-08,
                            5.273880452422408e-07,
                            0.0,
                            0.0,
                            6.067047283711834e-07,
                            9.589076368624947e-07,
                            0.0
                        ],
                        [
                            0.9832695854505449,
                            0.0007508185139040463,
                            3.5236474705011914e-16,
                            6.192001312242123e-10,
                            0.015977441949244792,
                            4.453003460003864e-08,
                            5.307609873968187e-07,
                            0.0,
                            0.0,
                            6.113029164639786e-07,
                            9.668731674031004e-07,
                            0.0
                        ]
                    ],
                    "Y": [
                        [
                            0.013867370665023306,
                            7.061334536571036e-05,
                            0.0001244851058439583,
                            0.00034486978801307367,
                            0.7533336263811035,
                            9.519887229053123e-05,
                            0.2321463157020703,
                            0.0,
                            0.0,
                            8.77265598816789e-06,
                            8.747484301640001e-06,
                            0.0
                        ],
                        [
                            0.013941977339090934,
                            7.270598682212085e-05,
                            0.00012431348014438917,
                            0.00034441379310404816,
                            0.7535717533075083,
                            9.507071884453347e-05,
                            0.2318321593861665,
                            0.0,
                            0.0,
                            8.805372746704582e-06,
                            8.800615573737624e-06,
                            0.0
                        ],
                        [
                            0.013935145110706084,
                            7.474204480075022e-05,
                            0.00012431507027862727,
                            0.00034438167189771514,
                            0.7535843315231355,
                            9.507297134050098e-05,
                            0.23182439384950737,
                            0.0,
                            0.0,
                            8.808451792062872e-06,
                            8.80930654176663e-06,
                            0.0
                        ],
                        [
                            0.013912487992919697,
                            7.673079065357205e-05,
                            0.00012432870987205268,
                            0.00034446689491135843,
                            0.7535656671806396,
                            9.508141719394087e-05,
                            0.23186361794713864,
                            0.0,
                            0.0,
                            8.808387296628949e-06,
                            8.81067937485047e-06,
                            0.0
                        ],
                        [
                            0.013887886373532221,
                            7.867922566573425e-05,
                            0.00012432255747559136,
                            0.0003444012304871642,
                            0.7536139333096571,
                            9.507858699800877e-05,
                            0.23183807840889936,
                            0.0,
                            0.0,
                            8.808906994486771e-06,
                            8.811400290009341e-06,
                            0.0
                        ],
                        [
                            0.01386400553141415,
                            8.059028937019026e-05,
                            0.00012433125808047058,
                            0.00034447019714698834,
                            0.7536066635802808,
                            9.508369646870284e-05,
                            0.23186723444374016,
                            0.0,
                            0.0,
                            8.809116326533512e-06,
                            8.811887169815112e-06,
                            0.0
                        ],
                        [
                            0.013841454767222022,
                            8.246617350889278e-05,
                            0.0001243280133541854,
                            0.000344425641820478,
                            0.7536436692508255,
                            9.508244827553499e-05,
                            0.23185095162641425,
                            0.0,
                            0.0,
                            8.809604263432863e-06,
                            8.812474314606083e-06,
                            0.0
                        ],
                        [
                            0.013820366585445705,
                            8.430844394181046e-05,
                            0.0001243326975537283,
                            0.000344465678126097,
                            0.7536463693508225,
                            9.508521674485995e-05,
                            0.2318674491020079,
                            0.0,
                            0.0,
                            8.809927275024751e-06,
                            8.812998083164759e-06,
                            0.0
                        ],
                        [
                            0.01380087748225087,
                            8.611878949506103e-05,
                            0.00012433208312304016,
                            0.00034444668417228376,
                            0.7536701704395796,
                            9.508529930609215e-05,
                            0.23186134533830166,
                            0.0,
                            0.0,
                            8.810333326060447e-06,
                            8.813550445598016e-06,
                            0.0
                        ],
                        [
                            0.013783056526400692,
                            8.789870430103835e-05,
                            0.00012433414802844216,
                            0.0003444638290918541,
                            0.7536790733349158,
                            9.508659542990809e-05,
                            0.23186846210785117,
                            0.0,
                            0.0,
                            8.810679096233129e-06,
                            8.814074884876416e-06,
                            0.0
                        ],
                        [
                            0.013767021749453285,
                            8.964978417213613e-05,
                            0.00012433453376478192,
                            0.00034445931903773474,
                            0.7536942358259916,
                            9.508706407879321e-05,
                            0.231867586089008,
                            0.0,
                            0.0,
                            8.811035716840673e-06,
                            8.814598776205565e-06,
                            0.0
                        ],
                        [
                            0.013752866816205194,
                            9.137352024047325e-05,
                            0.00012433532552553808,
                            0.0003444651907511489,
                            0.7537041337957409,
                            9.508761312340348e-05,
                            0.23187011126068163,
                            0.0,
                            0.0,
                            8.811369304733364e-06,
                            8.815108424750623e-06,
                            0.0
                        ],
                        [
                            0.013740712611265323,
                            9.307147319186273e-05,
                            0.00012433561843992478,
                            0.0003444651157500664,
                            0.7537142954607352,
                            9.508788047565348e-05,
                            0.231870404538803,
                            0.0,
                            0.0,
                            8.811692789453495e-06,
                            8.815608551190344e-06,
                            0.0
                        ],
                        [
                            0.013730676352760032,
                            9.474513708570347e-05,
                            0.0001243356761111295,
                            0.0003444662037088823,
                            0.753722284604979,
                            9.508793508982005e-05,
                            0.2318707759904654,
                            0.0,
                            0.0,
                            8.812001795059286e-06,
                            8.816098006034035e-06,
                            0.0
                        ],
                        [
                            0.013722889926990788,
                            9.639606633134236e-05,
                            0.00012433541790045393,
                            0.00034446547821942377,
                            0.7537289048636987,
                            9.508776171032965e-05,
                            0.23187029161231612,
                            0.0,
                            0.0,
                            8.812296558600227e-06,
                            8.816576275104342e-06,
                            0.0
                        ],
                        [
                            0.013717491229620746,
                            9.802577016798917e-05,
                            0.0001243348243925032,
                            0.00034446394498556206,
                            0.7537337509472002,
                            9.508733169240587e-05,
                            0.231869216331614,
                            0.0,
                            0.0,
                            8.812576587239662e-06,
                            8.817043738728816e-06,
                            0.0
                        ],
                        [
                            0.013714628917734404,
                            9.963579939292508e-05,
                            0.0001243338960094948,
                            0.00034446137327902245,
                            0.7537367377311933,
                            9.508664565024161e-05,
                            0.2318674852974478,
                            0.0,
                            0.0,
                            8.812840215507798e-06,
                            8.817499078483426e-06,
                            0.0
                        ]
                    ],
                    "K": [
                        [
                            0.011639331111049462,
                            0.11248165080760629,
                            316135785669.9021,
                            474008.06885222386,
                            47.169597851817784,
                            1965.2013153482117,
                            382844.2413965877,
                            0.10077365668625773,
                            0.5481824733407475,
                            14.265878614561668,
                            9.01095922267585,
                            32077.409408599593
                        ],
                        [
                            0.014377064674998975,
                            0.13746246172512894,
                            369880372524.19965,
                            576056.0460531292,
                            50.77636095259184,
                            2252.2506225626216,
                            455454.2456917524,
                            0.1485282609288571,
                            0.6239379901681017,
                            15.479482084269334,
                            9.788593538483054,
                            37344.706601373735
                        ],
                        [
                            0.01488789471600798,
                            0.14205009770963029,
                            379170262384.40356,
                            594952.3861145221,
                            51.215495733928975,
                            2300.0406933033214,
                            468444.9223647227,
                            0.15876706878423782,
                            0.63607293465235,
                            15.636646487833508,
                            9.890110872107261,
                            38250.47432610508
                        ],
                        [
                            0.0149293575760608,
                            0.14237121825875798,
                            379344850265.47974,
                            596254.9502719606,
                            51.04811885577719,
                            2299.1015744939345,
                            469020.9428745205,
                            0.16039163724067984,
                            0.6355476032108863,
                            15.590859943714793,
                            9.861639616244123,
                            38260.88415635302
                        ],
                        [
                            0.014882744406410998,
                            0.14188720169552868,
                            377824403785.5087,
                            594255.5986065248,
                            50.77133903302778,
                            2289.1319778600764,
                            467277.847218076,
                            0.16041047083433285,
                            0.6326899748741792,
                            15.508334923873434,
                            9.809625022397606,
                            38104.823477086895
                        ],
                        [
                            0.014816040560843034,
                            0.14122699981370737,
                            375924147260.05963,
                            591505.5542090838,
                            50.47194450238905,
                            2277.1585616229645,
                            465011.31287733046,
                            0.16000485219548327,
                            0.6293182468400358,
                            15.418107958360464,
                            9.752665660224386,
                            37911.52802006998
                        ],
                        [
                            0.014747246510631147,
                            0.14054350251859973,
                            373991591461.5713,
                            588680.4951487812,
                            50.17273272915317,
                            2265.0368364282217,
                            462696.34940914146,
                            0.15958541915864385,
                            0.6259117200496721,
                            15.327809493614566,
                            9.695649397022537,
                            37715.14694545639
                        ],
                        [
                            0.014674649687040606,
                            0.13983043817928947,
                            371993612662.28375,
                            585716.0093004925,
                            49.87149945403399,
                            2252.5895489223662,
                            460287.67819458595,
                            0.15905427375640252,
                            0.6224246831432463,
                            15.236704451683881,
                            9.63810556175907,
                            37512.42258245756
                        ],
                        [
                            0.014602049175472087,
                            0.1391148968826647,
                            370003366765.1108,
                            582754.6753862663,
                            49.57299834677782,
                            2240.2068679221643,
                            457885.4137001368,
                            0.15853508356736082,
                            0.61895778332686,
                            15.146386036261553,
                            9.581054911190261,
                            37310.54288350794
                        ],
                        [
                            0.01452677430720249,
                            0.13837805408840978,
                            367969247364.94507,
                            579696.1150101122,
                            49.27381472498522,
                            2227.612868186716,
                            455419.00318645977,
                            0.15793932497822175,
                            0.6154398372870609,
                            15.05571400812951,
                            9.523767233644904,
                            37104.433846393804
                        ],
                        [
                            0.014450565365812502,
                            0.13763202167623348,
                            365924684920.7985,
                            576605.6085157556,
                            48.97609831768691,
                            2214.9856123996706,
                            452934.24041300843,
                            0.1573258594158578,
                            0.6119167392766964,
                            14.965410137009316,
                            9.466705071028926,
                            36897.379369314986
                        ],
                        [
                            0.014372075536952284,
                            0.1368668734442727,
                            363843610767.0481,
                            573432.4966591987,
                            48.678108803521425,
                            2202.1855440242207,
                            450395.50250177976,
                            0.15665309171097208,
                            0.6083524877716875,
                            14.874894348209194,
                            9.40949702599911,
                            36686.815459683334
                        ],
                        [
                            0.014291885048385038,
                            0.13608654653373262,
                            361737090250.74896,
                            570198.5008459456,
                            48.380533270955574,
                            2189.2713386590635,
                            447817.9869894245,
                            0.1559414170563334,
                            0.6047621796431636,
                            14.784398847918412,
                            9.352292030850709,
                            36473.82800113927
                        ],
                        [
                            0.014209445444855513,
                            0.13528676050672045,
                            359594442327.02563,
                            566882.9527478248,
                            48.082638446316075,
                            2176.1855971561713,
                            445187.1291999054,
                            0.1551756090295463,
                            0.6011309900671962,
                            14.693680459866673,
                            9.294934491272635,
                            36257.36551859518
                        ],
                        [
                            0.01412478898370318,
                            0.13446745991273035,
                            357416170870.05316,
                            563487.0007040411,
                            47.78442157190893,
                            2162.9306264246493,
                            442503.6770791254,
                            0.15435881066233412,
                            0.5974594753126233,
                            14.602740434427956,
                            9.237425387024143,
                            36037.475971529835
                        ],
                        [
                            0.014037663807937683,
                            0.13362649430137452,
                            355197304123.2945,
                            560001.1256489006,
                            47.48552225870133,
                            2149.4795086559448,
                            439760.88670819136,
                            0.1534853881049531,
                            0.5937406538086799,
                            14.51146029404696,
                            9.17968899921474,
                            35813.66919559323
                        ],
                        [
                            0.013947964602212199,
                            0.13270310690633555,
                            352856694606.2625,
                            556296.3952707348,
                            47.175273197044056,
                            2135.343066981627,
                            436857.9426757267,
                            0.15274296024320794,
                            0.5898396694571424,
                            14.416575145498955,
                            9.119659554010767,
                            35577.76995042169
                        ]
                    ],
                    "HV": [
                        [
                            -605.9824975810727
                        ],
                        [
                            -493.79182081445606
                        ],
                        [
                            -471.9180491720517
                        ],
                        [
                            -466.8690685021435
                        ],
                        [
                            -464.95248206961554
                        ],
                        [
                            -463.7715112155316
                        ],
                        [
                            -462.70397168530843
                        ],
                        [
                            -461.8034642347548
                        ],
                        [
                            -460.9416397876257
                        ],
                        [
                            -460.21042044233775
                        ],
                        [
                            -459.55089375063613
                        ],
                        [
                            -459.01097044726333
                        ],
                        [
                            -458.57161713368987
                        ],
                        [
                            -458.2536230197004
                        ],
                        [
                            -458.0574354252302
                        ],
                        [
                            -457.9938576902323
                        ],
                        [
                            -458.0706132999533
                        ]
                    ],
                    "HL": [
                        [
                            -44901.13057878435
                        ],
                        [
                            -44689.31896895872
                        ],
                        [
                            -44646.33393276307
                        ],
                        [
                            -44635.219558593504
                        ],
                        [
                            -44627.8823098632
                        ],
                        [
                            -44623.77928662668
                        ],
                        [
                            -44618.139088083466
                        ],
                        [
                            -44614.25716396614
                        ],
                        [
                            -44609.343317963736
                        ],
                        [
                            -44605.44665898145
                        ],
                        [
                            -44601.17835244249
                        ],
                        [
                            -44597.43021963396
                        ],
                        [
                            -44593.70245896239
                        ],
                        [
                            -44590.27967989198
                        ],
                        [
                            -44587.04048729829
                        ],
                        [
                            -44584.053569937896
                        ],
                        [
                            -44580.36105873858
                        ]
                    ],
                    "hydraulics": {
                        "Q_L": [
                            8394.15651116917,
                            8374.816393784266,
                            8370.802768809726,
                            8369.15870382778,
                            8369.72707768132,
                            8369.116314089288,
                            8370.006861908116,
                            8369.979043317919,
                            8370.96022012207,
                            8371.554348543636,
                            8372.728018220661,
                            8373.897718541246,
                            8375.420786579623,
                            8377.131535881179,
                            8379.134638799293,
                            8381.41309218412,
                            7008.746054442597
                        ],
                        "Q_V": [
                            138714337.8859565,
                            139545996.49847773,
                            138885118.02249187,
                            138006274.1855984,
                            137097361.45910224,
                            136191734.3507285,
                            135296203.0610195,
                            134411123.60923314,
                            133536864.83967362,
                            132672920.54794826,
                            131819208.95473443,
                            130975374.34693404,
                            130141205.85491692,
                            129316429.34421302,
                            128500793.20104964,
                            127694046.44150795,
                            126895929.07688002
                        ],
                        "F_factor": [
                            24026.22989000439,
                            24116.40398102336,
                            24058.248695111204,
                            23981.60805758391,
                            23902.549117606475,
                            23823.359288259955,
                            23744.956358138108,
                            23667.125706484174,
                            23590.060080564668,
                            23513.638373372,
                            23437.897331204284,
                            23362.80101432719,
                            23288.337142754855,
                            23214.49193219945,
                            23141.24553029286,
                            23068.583997352333,
                            22996.48873104561
                        ],
                        "delta_P_tray": [
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null
                        ],
                        "alarms": [
                            {
                                "tray": 0,
                                "metric": "F_factor",
                                "value": 24026.22989000439,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 00 F_factor 24026.23 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 0,
                                "metric": "Q_L",
                                "value": 8394.15651116917,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 00 Q_L 8394.16 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 1,
                                "metric": "F_factor",
                                "value": 24116.40398102336,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 01 F_factor 24116.40 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 1,
                                "metric": "Q_L",
                                "value": 8374.816393784266,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 01 Q_L 8374.82 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 2,
                                "metric": "F_factor",
                                "value": 24058.248695111204,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 02 F_factor 24058.25 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 2,
                                "metric": "Q_L",
                                "value": 8370.802768809726,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 02 Q_L 8370.80 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 3,
                                "metric": "F_factor",
                                "value": 23981.60805758391,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 03 F_factor 23981.61 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 3,
                                "metric": "Q_L",
                                "value": 8369.15870382778,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 03 Q_L 8369.16 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 4,
                                "metric": "F_factor",
                                "value": 23902.549117606475,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 04 F_factor 23902.55 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 4,
                                "metric": "Q_L",
                                "value": 8369.72707768132,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 04 Q_L 8369.73 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 5,
                                "metric": "F_factor",
                                "value": 23823.359288259955,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 05 F_factor 23823.36 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 5,
                                "metric": "Q_L",
                                "value": 8369.116314089288,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 05 Q_L 8369.12 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 6,
                                "metric": "F_factor",
                                "value": 23744.956358138108,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 06 F_factor 23744.96 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 6,
                                "metric": "Q_L",
                                "value": 8370.006861908116,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 06 Q_L 8370.01 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 7,
                                "metric": "F_factor",
                                "value": 23667.125706484174,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 07 F_factor 23667.13 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 7,
                                "metric": "Q_L",
                                "value": 8369.979043317919,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 07 Q_L 8369.98 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 8,
                                "metric": "F_factor",
                                "value": 23590.060080564668,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 08 F_factor 23590.06 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 8,
                                "metric": "Q_L",
                                "value": 8370.96022012207,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 08 Q_L 8370.96 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 9,
                                "metric": "F_factor",
                                "value": 23513.638373372,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 09 F_factor 23513.64 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 9,
                                "metric": "Q_L",
                                "value": 8371.554348543636,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 09 Q_L 8371.55 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 10,
                                "metric": "F_factor",
                                "value": 23437.897331204284,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 10 F_factor 23437.90 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 10,
                                "metric": "Q_L",
                                "value": 8372.728018220661,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 10 Q_L 8372.73 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 11,
                                "metric": "F_factor",
                                "value": 23362.80101432719,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 11 F_factor 23362.80 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 11,
                                "metric": "Q_L",
                                "value": 8373.897718541246,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 11 Q_L 8373.90 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 12,
                                "metric": "F_factor",
                                "value": 23288.337142754855,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 12 F_factor 23288.34 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 12,
                                "metric": "Q_L",
                                "value": 8375.420786579623,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 12 Q_L 8375.42 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 13,
                                "metric": "F_factor",
                                "value": 23214.49193219945,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 13 F_factor 23214.49 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 13,
                                "metric": "Q_L",
                                "value": 8377.131535881179,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 13 Q_L 8377.13 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 14,
                                "metric": "F_factor",
                                "value": 23141.24553029286,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 14 F_factor 23141.25 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 14,
                                "metric": "Q_L",
                                "value": 8379.134638799293,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 14 Q_L 8379.13 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 15,
                                "metric": "F_factor",
                                "value": 23068.583997352333,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 15 F_factor 23068.58 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 15,
                                "metric": "Q_L",
                                "value": 8381.41309218412,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 15 Q_L 8381.41 > 45.0 – liquid flooding risk"
                            }
                        ]
                    }
                }
            },
            {
                "name": "T-109B",
                "type": "DistilStrict",
                "phase": "VL",
                "mode": "TP",
                "physical_method": "NRTL",
                "result": {
                    "IsConverged": 1,
                    "outer_iter_count": 334,
                    "deltaT_max": 9.926103530233377e-06,
                    "deltax_max": 2.914335770487497e-07,
                    "T": [
                        280.7926997619971,
                        284.0325635311862,
                        284.6635674565545,
                        284.80915716411994,
                        284.8645152481916,
                        284.8984632803899,
                        284.9292638275064,
                        284.95515197271317,
                        284.97999207198427,
                        285.0010310211998,
                        285.0200289760233,
                        285.035572408519,
                        285.04822644759537,
                        285.05738562795506,
                        285.063039977347,
                        285.06487767784773,
                        285.062676505771
                    ],
                    "V": [
                        5347304.982680576,
                        5355008.647365841,
                        5354533.959702649,
                        5354363.125634127,
                        5354244.833052139,
                        5354177.032731407,
                        5354089.73138382,
                        5354038.50204343,
                        5353973.866617515,
                        5353935.683759744,
                        5353895.728083023,
                        5353874.102857061,
                        5353859.326983584,
                        5353859.067758028,
                        5353870.454492642,
                        5353896.050187677,
                        5353936.088795245
                    ],
                    "V_kg_per_h": [
                        213473.06016389112,
                        213797.11792625458,
                        213779.64562270325,
                        213772.47510654354,
                        213773.24758091802,
                        213771.23465366528,
                        213772.16809593845,
                        213771.52123372853,
                        213772.0622181218,
                        213772.2921813676,
                        213772.89193383645,
                        213773.67118219775,
                        213774.63902716598,
                        213775.8865471132,
                        213777.3609991509,
                        213779.1226489204,
                        213781.16562571452
                    ],
                    "V_nm3_per_h": [
                        119847.66231377865,
                        120020.32241204659,
                        120009.68336921156,
                        120005.85451265256,
                        120003.20325384718,
                        120001.68366407811,
                        119999.72700320705,
                        119998.57881422073,
                        119997.1301583607,
                        119996.27437656798,
                        119995.37886107621,
                        119994.89418088929,
                        119994.56301333841,
                        119994.55720338799,
                        119994.81241111024,
                        119995.38608031842,
                        119996.28345451622
                    ],
                    "rho_V": [
                        1.5389629790781398,
                        1.5320922301404931,
                        1.5392494779959505,
                        1.5489975188765293,
                        1.5592719331340767,
                        1.5696255949091258,
                        1.5800218427961885,
                        1.5904212250488061,
                        1.600837646528618,
                        1.611263745136257,
                        1.6217034324877564,
                        1.6321575079932251,
                        1.6426266033584316,
                        1.6531128704535132,
                        1.6636171886634248,
                        1.674141410911736,
                        1.6846871115575421
                    ],
                    "L": [
                        454685.3380203442,
                        454210.65035715216,
                        454039.8162886294,
                        453921.52370664105,
                        453853.7233859092,
                        453766.422038322,
                        453715.1926979326,
                        453650.5572720186,
                        453612.3744142461,
                        453572.41873752564,
                        453550.7935115646,
                        453536.01763808733,
                        453535.7584125309,
                        453547.14514714514,
                        453572.7408421792,
                        453612.77944974607,
                        379172.85053128056
                    ],
                    "L_kg_per_h": [
                        8378.210277609227,
                        8358.309319363341,
                        8353.879319943595,
                        8352.005934552906,
                        8352.261087612715,
                        8351.453835828619,
                        8352.049673557965,
                        8351.812586900038,
                        8352.522540438473,
                        8352.8915351487,
                        8353.81261828432,
                        8354.748305728814,
                        8356.029303070263,
                        8357.503961835862,
                        8359.26994861544,
                        8361.312999347187,
                        6992.397266597039
                    ],
                    "L_m3_per_h": [
                        8.428184669664402,
                        8.4067735962251,
                        8.402220343371361,
                        8.400446117992601,
                        8.400968941146717,
                        8.40032959168013,
                        8.401197316542014,
                        8.401149186631779,
                        8.402112920472963,
                        8.402692210780307,
                        8.403854007421755,
                        8.405014945123266,
                        8.40653259082993,
                        8.40824150229715,
                        8.410246595531234,
                        8.412531143650149,
                        7.03668943066712
                    ],
                    "L_l_per_h": [
                        8428.184669664402,
                        8406.7735962251,
                        8402.22034337136,
                        8400.4461179926,
                        8400.968941146717,
                        8400.329591680129,
                        8401.197316542013,
                        8401.149186631777,
                        8402.112920472962,
                        8402.692210780308,
                        8403.854007421754,
                        8405.014945123266,
                        8406.53259082993,
                        8408.24150229715,
                        8410.246595531235,
                        8412.531143650149,
                        7036.689430667119
                    ],
                    "rho_L": [
                        994.0705627589001,
                        994.2350919402039,
                        994.2466370254259,
                        994.2336177437121,
                        994.2021147947069,
                        994.1816859305237,
                        994.1499239772317,
                        994.1273986884738,
                        994.0978679406157,
                        994.0732476708221,
                        994.0454237908892,
                        994.0194467561752,
                        993.9923759036209,
                        993.9657370155904,
                        993.9387452749744,
                        993.9116844349965,
                        993.7055394434423
                    ],
                    "sigma": [
                        69.81246391750095,
                        69.54701487334923,
                        69.47365097227484,
                        69.442189601733,
                        69.39592262795041,
                        69.37082892672548,
                        69.32778563382246,
                        69.30020429456944,
                        69.26130523145162,
                        69.2307424058859,
                        69.19517065342878,
                        69.16296926816075,
                        69.12932095487683,
                        69.09679583336991,
                        69.06414385891414,
                        69.03188653011489,
                        68.94806089738807
                    ],
                    "P": [
                        90000.0,
                        90625.0,
                        91250.0,
                        91875.0,
                        92500.0,
                        93125.0,
                        93750.0,
                        94375.0,
                        95000.0,
                        95625.0,
                        96250.0,
                        96875.0,
                        97500.0,
                        98125.0,
                        98750.0,
                        99375.0,
                        100000.0
                    ],
                    "X": [
                        [
                            0.9841726107214663,
                            2.5817337519947504e-05,
                            4.1190404536338474e-16,
                            7.611052765166631e-10,
                            0.015799565904886674,
                            5.0606533628612635e-08,
                            6.342890908476733e-07,
                            0.0,
                            0.0,
                            5.404008895239702e-07,
                            7.799785073387377e-07,
                            0.0
                        ],
                        [
                            0.985106433493294,
                            4.9755127446741644e-05,
                            3.356901420877631e-16,
                            5.979493483206235e-10,
                            0.014841827360287132,
                            4.2155620538324585e-08,
                            5.087077458888546e-07,
                            0.0,
                            0.0,
                            5.625047397306749e-07,
                            8.700529162396394e-07,
                            0.0
                        ],
                        [
                            0.9852046576996959,
                            7.318012871330708e-05,
                            3.2688996323012334e-16,
                            5.754869802058422e-10,
                            0.014720177476786757,
                            4.123286321737719e-08,
                            4.928037597552152e-07,
                            0.0,
                            0.0,
                            5.635304382975298e-07,
                            8.86552255433966e-07,
                            0.0
                        ],
                        [
                            0.9851683973857256,
                            9.614946444029328e-05,
                            3.282519909921324e-16,
                            5.806669956006818e-10,
                            0.014733460759520376,
                            4.139540482807649e-08,
                            4.958830457015608e-07,
                            0.0,
                            0.0,
                            5.637516193228128e-07,
                            8.907795764558887e-07,
                            0.0
                        ],
                        [
                            0.9850306577338632,
                            0.00011868354105123341,
                            3.2823230647301255e-16,
                            5.757295652205408e-10,
                            0.014848657977966973,
                            4.1454293355009454e-08,
                            4.940372603353338e-07,
                            0.0,
                            0.0,
                            5.677716202126663e-07,
                            8.969082148150482e-07,
                            0.0
                        ],
                        [
                            0.9849526982232474,
                            0.00014081542394520465,
                            3.31168166093991e-16,
                            5.852908259049588e-10,
                            0.014904472352820008,
                            4.178804482022934e-08,
                            5.000767090987584e-07,
                            0.0,
                            0.0,
                            5.701476442115458e-07,
                            9.01402298049643e-07,
                            0.0
                        ],
                        [
                            0.9848122297187606,
                            0.00016255203530850102,
                            3.3186688335899007e-16,
                            5.820757922459359e-10,
                            0.015023194678097502,
                            4.192315344468142e-08,
                            4.994960105531851e-07,
                            0.0,
                            0.0,
                            5.742344529680714e-07,
                            9.073321404548241e-07,
                            0.0
                        ],
                        [
                            0.9847215977400735,
                            0.00018392255955065277,
                            3.3444138272159637e-16,
                            5.89912012671117e-10,
                            0.015092442615819891,
                            4.222432359858028e-08,
                            5.045840282519137e-07,
                            0.0,
                            0.0,
                            5.772325817216978e-07,
                            9.12453710034865e-07,
                            0.0
                        ],
                        [
                            0.9845921011048411,
                            0.00020493291662036515,
                            3.357273294535198e-16,
                            5.893554153111054e-10,
                            0.015200918229229409,
                            4.241511639223727e-08,
                            5.0548879284643e-07,
                            0.0,
                            0.0,
                            5.810397934993178e-07,
                            9.182162505225826e-07,
                            0.0
                        ],
                        [
                            0.9844888852531465,
                            0.0002256094150541581,
                            3.3794070754996645e-16,
                            5.949426636657715e-10,
                            0.015283444527115516,
                            4.2685621979475274e-08,
                            5.094397711154536e-07,
                            0.0,
                            0.0,
                            5.843991018898593e-07,
                            9.236852458077351e-07,
                            0.0
                        ],
                        [
                            0.9843676123783258,
                            0.0002459607469534226,
                            3.3965509865895355e-16,
                            5.966340642921624e-10,
                            0.015384354308303294,
                            4.291597426457579e-08,
                            5.115380880636124e-07,
                            0.0,
                            0.0,
                            5.880880539085201e-07,
                            9.294276667978585e-07,
                            0.0
                        ],
                        [
                            0.9842559312213424,
                            0.00026600914054141205,
                            3.417233892251401e-16,
                            6.008590930374941e-10,
                            0.015475974202870819,
                            4.3176506090084665e-08,
                            5.148663897997386e-07,
                            0.0,
                            0.0,
                            5.916625330849579e-07,
                            9.351289569338639e-07,
                            0.0
                        ],
                        [
                            0.9841377738746439,
                            0.00028576669650178465,
                            3.43691417304503e-16,
                            6.038559605995852e-10,
                            0.015574361408013757,
                            4.3430853293148815e-08,
                            5.176612575638351e-07,
                            0.0,
                            0.0,
                            5.953646248861253e-07,
                            9.409602485677302e-07,
                            0.0
                        ],
                        [
                            0.9840215174158466,
                            0.00030525226961324985,
                            3.457894728485943e-16,
                            6.076882392865921e-10,
                            0.015671119211344568,
                            4.3697187334911256e-08,
                            5.208730458047303e-07,
                            0.0,
                            0.0,
                            5.990783141931427e-07,
                            9.468469598045977e-07,
                            0.0
                        ],
                        [
                            0.9839028863417599,
                            0.0003244802249030244,
                            3.479215468029331e-16,
                            6.113363950199223e-10,
                            0.015770509115049045,
                            4.3968403379638175e-08,
                            5.240480082364253e-07,
                            0.0,
                            0.0,
                            6.028625789407479e-07,
                            9.52827960774219e-07,
                            0.0
                        ],
                        [
                            0.9837834589142076,
                            0.0003434674434697613,
                            3.501287781626205e-16,
                            6.152551234029556e-10,
                            0.015870935785321137,
                            4.4247656418767474e-08,
                            5.273869281099251e-07,
                            0.0,
                            0.0,
                            6.067031008757462e-07,
                            9.589040606225844e-07,
                            0.0
                        ],
                        [
                            0.9832700522350848,
                            0.0007503686843816246,
                            3.523640686913964e-16,
                            6.191986773408198e-10,
                            0.01597742499737578,
                            4.452995788122892e-08,
                            5.307598658195451e-07,
                            0.0,
                            0.0,
                            6.113021880752293e-07,
                            9.66871946932937e-07,
                            0.0
                        ]
                    ],
                    "Y": [
                        [
                            0.013867213590652926,
                            7.056068198567055e-05,
                            0.00012448536036467492,
                            0.0003448704866488775,
                            0.7533333624142902,
                            9.519906120472074e-05,
                            0.23214678840621286,
                            0.0,
                            0.0,
                            8.772605381493399e-06,
                            8.747393257865396e-06,
                            0.0
                        ],
                        [
                            0.013941941533232602,
                            7.265189970593304e-05,
                            0.00012431347877800818,
                            0.00034441379734276317,
                            0.753571843238436,
                            9.507071911756192e-05,
                            0.2318321593857535,
                            0.0,
                            0.0,
                            8.805362732269468e-06,
                            8.800584902217177e-06,
                            0.0
                        ],
                        [
                            0.013935164263843815,
                            7.468672123883954e-05,
                            0.000124315082348054,
                            0.0003443816768277946,
                            0.7535843531301011,
                            9.507298037446924e-05,
                            0.23182440840199464,
                            0.0,
                            0.0,
                            8.808448543876284e-06,
                            8.809294726653317e-06,
                            0.0
                        ],
                        [
                            0.01391252333336017,
                            7.667438390122245e-05,
                            0.00012432873160463703,
                            0.0003444669776352801,
                            0.7535656411917012,
                            9.508143284868393e-05,
                            0.2318636648934848,
                            0.0,
                            0.0,
                            8.808383872659984e-06,
                            8.810671592902403e-06,
                            0.0
                        ],
                        [
                            0.013887925979576124,
                            7.862187917886569e-05,
                            0.0001243225768109329,
                            0.00034440125155344543,
                            0.7536139239301658,
                            9.507860147739464e-05,
                            0.23183810548497724,
                            0.0,
                            0.0,
                            8.808903216795582e-06,
                            8.811393043615984e-06,
                            0.0
                        ],
                        [
                            0.013864046167340537,
                            8.053214140305887e-05,
                            0.00012433127818661926,
                            0.00034447027227330133,
                            0.7536066380333665,
                            9.508371098584188e-05,
                            0.23186727740335497,
                            0.0,
                            0.0,
                            8.809112683820228e-06,
                            8.81188040554861e-06,
                            0.0
                        ],
                        [
                            0.013841495622566275,
                            8.240735668258092e-05,
                            0.0001243280312848037,
                            0.0003444256684747936,
                            0.7536436600534271,
                            9.508246173856326e-05,
                            0.2318509787370737,
                            0.0,
                            0.0,
                            8.809600795947204e-06,
                            8.812467955412487e-06,
                            0.0
                        ],
                        [
                            0.01382040732326513,
                            8.424908502255471e-05,
                            0.00012433271438950868,
                            0.0003444657344368771,
                            0.7536463537878959,
                            9.508522903467979e-05,
                            0.2318674832096035,
                            0.0,
                            0.0,
                            8.809924121562466e-06,
                            8.812992229862262e-06,
                            0.0
                        ],
                        [
                            0.013800917986871811,
                            8.605900929079724e-05,
                            0.00012433209864630448,
                            0.00034444671531265166,
                            0.753670163969285,
                            9.508531094115392e-05,
                            0.23186137103408694,
                            0.0,
                            0.0,
                            8.810330452304645e-06,
                            8.813545112741013e-06,
                            0.0
                        ],
                        [
                            0.013783096672171934,
                            8.783861802559923e-05,
                            0.0001243341620273413,
                            0.00034446387029755905,
                            0.7536790664277436,
                            9.508660577880874e-05,
                            0.23186848889733985,
                            0.0,
                            0.0,
                            8.810676533900015e-06,
                            8.814070080586447e-06,
                            0.0
                        ],
                        [
                            0.013767061478988485,
                            8.958950153362114e-05,
                            0.00012433454659706143,
                            0.0003444593496987152,
                            0.7536942337428544,
                            9.508707368933978e-05,
                            0.23186760867866232,
                            0.0,
                            0.0,
                            8.811033459873455e-06,
                            8.814594515665897e-06,
                            0.0
                        ],
                        [
                            0.013752906073158109,
                            9.13131458364638e-05,
                            0.0001243353368944938,
                            0.00034446522211055333,
                            0.7537041337004285,
                            9.50876216037095e-05,
                            0.23187013242789667,
                            0.0,
                            0.0,
                            8.811367360082989e-06,
                            8.81510471110424e-06,
                            0.0
                        ],
                        [
                            0.013740751382208365,
                            9.301110663552214e-05,
                            0.00012433562855675056,
                            0.0003444651423607297,
                            0.753714298540566,
                            9.508788805963625e-05,
                            0.23187042301505714,
                            0.0,
                            0.0,
                            8.811691160350672e-06,
                            8.8156053942896e-06,
                            0.0
                        ],
                        [
                            0.013730714647284962,
                            9.468487333573578e-05,
                            0.00012433568484189713,
                            0.00034446622774724953,
                            0.753722290298753,
                            9.508794163546469e-05,
                            0.23187079223050058,
                            0.0,
                            0.0,
                            8.81200048640607e-06,
                            8.81609541404814e-06,
                            0.0
                        ],
                        [
                            0.013722927792555574,
                            9.633599584544307e-05,
                            0.00012433542527223433,
                            0.0003444654984628672,
                            0.75372891334147,
                            9.50877672513612e-05,
                            0.2318703053093093,
                            0.0,
                            0.0,
                            8.812295575882927e-06,
                            8.816574257584664e-06,
                            0.0
                        ],
                        [
                            0.01371752874995789,
                            9.796597917572314e-05,
                            0.00012433483033349676,
                            0.00034446396144385594,
                            0.7537337621146433,
                            9.50873361689883e-05,
                            0.23186922741002983,
                            0.0,
                            0.0,
                            8.812575937385704e-06,
                            8.817042307618396e-06,
                            0.0
                        ],
                        [
                            0.013714666218778116,
                            9.957637007681527e-05,
                            0.00012433390046701184,
                            0.00034446138562788136,
                            0.753736751528116,
                            9.50866490249881e-05,
                            0.23186749360975684,
                            0.0,
                            0.0,
                            8.812839905365594e-06,
                            8.817498246254652e-06,
                            0.0
                        ]
                    ],
                    "K": [
                        [
                            0.011635208193746702,
                            0.11244375843759859,
                            316052287454.60834,
                            473854.3104479371,
                            47.16344221249862,
                            1964.7503042206856,
                            382733.11086715554,
                            0.10070742766440144,
                            0.5480612010256103,
                            14.26382920286891,
                            9.009648105945562,
                            32069.220834390853
                        ],
                        [
                            0.014375234367136641,
                            0.13744581010046256,
                            369844732981.65326,
                            575987.4865988259,
                            50.77396775775401,
                            2252.0599116619846,
                            455405.7862036097,
                            0.1484950116282834,
                            0.6238883266538858,
                            15.478681922976605,
                            9.788081111779709,
                            37341.206005944085
                        ],
                        [
                            0.014887383766478338,
                            0.14204547628803157,
                            379160408978.1863,
                            594933.259242105,
                            51.21484756237499,
                            2299.988071205036,
                            468431.4647452815,
                            0.15875753215286426,
                            0.6360593233938123,
                            15.636429528486827,
                            9.889971895676732,
                            38249.506171012144
                        ],
                        [
                            0.01492925117542807,
                            0.14237028281073288,
                            379342835189.8969,
                            596251.0186423798,
                            51.04798913250084,
                            2299.0908408553832,
                            469018.18370693084,
                            0.1603895538088424,
                            0.6355448347282494,
                            15.590816384954254,
                            9.861611701866563,
                            38260.68622938248
                        ],
                        [
                            0.014882747459221099,
                            0.1418872650262236,
                            377824510973.4208,
                            594255.7893485606,
                            50.77134934711351,
                            2289.1325845333477,
                            467277.98754336266,
                            0.16041041935350903,
                            0.6326901367679737,
                            15.508338188142291,
                            9.809627097645421,
                            38104.83413413264
                        ],
                        [
                            0.014816070194533206,
                            0.14122731228541566,
                            375924775123.8272,
                            591506.7554758721,
                            50.47198947409139,
                            2277.1619539520866,
                            465012.16425968544,
                            0.16000526584281857,
                            0.6293191284943301,
                            15.418122789739435,
                            9.75267514241985,
                            37911.58986887559
                        ],
                        [
                            0.01474728726388865,
                            0.14054391980025832,
                            373992440922.79944,
                            588682.1256628232,
                            50.172792674096236,
                            2265.041416790734,
                            462697.50312248495,
                            0.15958603575885938,
                            0.6259129087586732,
                            15.327829307893271,
                            9.695662068831416,
                            37715.23059282654
                        ],
                        [
                            0.014674693206667446,
                            0.13983088697100765,
                            371994522078.38556,
                            585717.7546332511,
                            49.87156374376604,
                            2252.594453884905,
                            460288.913243017,
                            0.15905491762057902,
                            0.6224259560252238,
                            15.236725694253202,
                            9.63811914638564,
                            37512.51214089984
                        ],
                        [
                            0.01460209647723846,
                            0.1391153838015125,
                            370004355222.64056,
                            582756.5729538149,
                            49.5730681932065,
                            2240.212199007384,
                            457886.75627941935,
                            0.15853579082333258,
                            0.6189591664804014,
                            15.146409114601429,
                            9.581069669823348,
                            37310.64022785108
                        ],
                        [
                            0.014526822435842421,
                            0.13837855356699816,
                            367970257469.3579,
                            579698.0531164588,
                            49.273886346650194,
                            2227.6183187016554,
                            455420.3748098166,
                            0.1579400299208408,
                            0.6154412515973554,
                            15.055737658466995,
                            9.523782356876504,
                            37104.53333438515
                        ],
                        [
                            0.014450614733722781,
                            0.1376325360898905,
                            365925724201.0203,
                            576607.6019656966,
                            48.97617217931955,
                            2214.9912222421813,
                            452935.65142977063,
                            0.15732657817316717,
                            0.6119181949975834,
                            14.965434516518455,
                            9.466720659678302,
                            36897.4817397801
                        ],
                        [
                            0.014372124401432873,
                            0.136867387313618,
                            363844645276.04346,
                            573434.4793440568,
                            48.678182665913575,
                            2202.1911317470026,
                            450396.9064743845,
                            0.1566537878801846,
                            0.6083539381335229,
                            14.874918708985332,
                            9.409512601085108,
                            36686.917374824974
                        ],
                        [
                            0.014291932860149523,
                            0.13608705423257889,
                            361738109049.8541,
                            570200.4514975261,
                            48.38060639938536,
                            2189.2768456435088,
                            447819.3689664827,
                            0.15594208362123965,
                            0.6047636095416189,
                            14.784422945497118,
                            9.3523074358842,
                            36473.92838461682
                        ],
                        [
                            0.014209490907574255,
                            0.13528725019652477,
                            359595420124.27405,
                            566884.8220714325,
                            48.082709172847196,
                            2176.1908882062994,
                            445188.45456935023,
                            0.15517622095536213,
                            0.6011323646821577,
                            14.693703737328088,
                            9.294949369594388,
                            36257.46188329347
                        ],
                        [
                            0.014124831031875848,
                            0.1344679215833693,
                            357417086830.9891,
                            563488.7480893135,
                            47.78448852067508,
                            2162.935590146949,
                            442504.91732785635,
                            0.1543593491727631,
                            0.5974607659609267,
                            14.60276243254976,
                            9.237439444554608,
                            36037.566268486
                        ],
                        [
                            0.01403770116876429,
                            0.13362691619955785,
                            355198133440.54266,
                            560002.7027301979,
                            47.48558379600048,
                            2149.484012467416,
                            439762.00788193196,
                            0.15348582960410848,
                            0.5937418263489948,
                            14.511480467227113,
                            9.179701886532804,
                            35813.75098540442
                        ],
                        [
                            0.013947995915519784,
                            0.13270345974501904,
                            352857388902.62067,
                            556297.7157765271,
                            47.175324676969275,
                            2135.346837119253,
                            436858.8813776919,
                            0.15274333274107316,
                            0.5898406509429462,
                            14.416592023701218,
                            9.119670336555897,
                            35577.8384224469
                        ]
                    ],
                    "HV": [
                        [
                            -606.1620312127245
                        ],
                        [
                            -493.85827555645545
                        ],
                        [
                            -471.9360572500879
                        ],
                        [
                            -466.8728025305036
                        ],
                        [
                            -464.95236327991944
                        ],
                        [
                            -463.7704461401597
                        ],
                        [
                            -462.7025063739925
                        ],
                        [
                            -461.8018907756294
                        ],
                        [
                            -460.9399230310607
                        ],
                        [
                            -460.2086638733145
                        ],
                        [
                            -459.54908313002284
                        ],
                        [
                            -459.00916802899894
                        ],
                        [
                            -458.5698435599077
                        ],
                        [
                            -458.2519262606874
                        ],
                        [
                            -458.0558560547944
                        ],
                        [
                            -457.99244470925134
                        ],
                        [
                            -458.0694204235723
                        ]
                    ],
                    "HL": [
                        [
                            -44901.46292459165
                        ],
                        [
                            -44689.43900961096
                        ],
                        [
                            -44646.36646897603
                        ],
                        [
                            -44635.227108329294
                        ],
                        [
                            -44627.882374469016
                        ],
                        [
                            -44623.77837126606
                        ],
                        [
                            -44618.13697366041
                        ],
                        [
                            -44614.255375313005
                        ],
                        [
                            -44609.341014814105
                        ],
                        [
                            -44605.444574044945
                        ],
                        [
                            -44601.17609399913
                        ],
                        [
                            -44597.42811750598
                        ],
                        [
                            -44593.70042357275
                        ],
                        [
                            -44590.27786179926
                        ],
                        [
                            -44587.03892674917
                        ],
                        [
                            -44584.05236512458
                        ],
                        [
                            -44580.35999514311
                        ]
                    ],
                    "hydraulics": {
                        "Q_L": [
                            8405.332925412562,
                            8385.950195063833,
                            8381.924314085742,
                            8380.277353423022,
                            8380.848719224296,
                            8380.238811399802,
                            8381.133068456662,
                            8381.10683662141,
                            8382.09132465242,
                            8382.687636691282,
                            8383.86430468157,
                            8385.036601943908,
                            8386.5625758492,
                            8388.27616860968,
                            8390.282243410064,
                            8392.563730992091,
                            7019.909268707156
                        ],
                        "Q_V": [
                            138711491.93052208,
                            139545062.81177348,
                            138884850.9126902,
                            138006201.56780627,
                            137097341.19884655,
                            136191728.79736698,
                            135296203.47309598,
                            134411127.38567492,
                            133536871.33630976,
                            132672929.20528868,
                            131819219.37226163,
                            130975386.08345841,
                            130141218.43066172,
                            129316442.27869244,
                            128500805.94568126,
                            127694058.44007508,
                            126895939.70041038
                        ],
                        "F_factor": [
                            24025.95805304505,
                            24116.324328345912,
                            24058.224308505596,
                            23981.599675652,
                            23902.545220710126,
                            23823.356736262816,
                            23744.95445001178,
                            23667.124238928744,
                            23590.058974453386,
                            23513.637612979197,
                            23437.896855529805,
                            23362.800807571166,
                            23288.33715012375,
                            23214.492121671938,
                            23141.24585080761,
                            23068.58440359629,
                            22996.489168559143
                        ],
                        "delta_P_tray": [
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null
                        ],
                        "alarms": [
                            {
                                "tray": 0,
                                "metric": "F_factor",
                                "value": 24025.95805304505,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 00 F_factor 24025.96 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 0,
                                "metric": "Q_L",
                                "value": 8405.332925412562,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 00 Q_L 8405.33 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 1,
                                "metric": "F_factor",
                                "value": 24116.324328345912,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 01 F_factor 24116.32 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 1,
                                "metric": "Q_L",
                                "value": 8385.950195063833,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 01 Q_L 8385.95 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 2,
                                "metric": "F_factor",
                                "value": 24058.224308505596,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 02 F_factor 24058.22 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 2,
                                "metric": "Q_L",
                                "value": 8381.924314085742,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 02 Q_L 8381.92 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 3,
                                "metric": "F_factor",
                                "value": 23981.599675652,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 03 F_factor 23981.60 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 3,
                                "metric": "Q_L",
                                "value": 8380.277353423022,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 03 Q_L 8380.28 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 4,
                                "metric": "F_factor",
                                "value": 23902.545220710126,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 04 F_factor 23902.55 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 4,
                                "metric": "Q_L",
                                "value": 8380.848719224296,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 04 Q_L 8380.85 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 5,
                                "metric": "F_factor",
                                "value": 23823.356736262816,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 05 F_factor 23823.36 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 5,
                                "metric": "Q_L",
                                "value": 8380.238811399802,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 05 Q_L 8380.24 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 6,
                                "metric": "F_factor",
                                "value": 23744.95445001178,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 06 F_factor 23744.95 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 6,
                                "metric": "Q_L",
                                "value": 8381.133068456662,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 06 Q_L 8381.13 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 7,
                                "metric": "F_factor",
                                "value": 23667.124238928744,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 07 F_factor 23667.12 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 7,
                                "metric": "Q_L",
                                "value": 8381.10683662141,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 07 Q_L 8381.11 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 8,
                                "metric": "F_factor",
                                "value": 23590.058974453386,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 08 F_factor 23590.06 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 8,
                                "metric": "Q_L",
                                "value": 8382.09132465242,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 08 Q_L 8382.09 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 9,
                                "metric": "F_factor",
                                "value": 23513.637612979197,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 09 F_factor 23513.64 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 9,
                                "metric": "Q_L",
                                "value": 8382.687636691282,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 09 Q_L 8382.69 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 10,
                                "metric": "F_factor",
                                "value": 23437.896855529805,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 10 F_factor 23437.90 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 10,
                                "metric": "Q_L",
                                "value": 8383.86430468157,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 10 Q_L 8383.86 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 11,
                                "metric": "F_factor",
                                "value": 23362.800807571166,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 11 F_factor 23362.80 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 11,
                                "metric": "Q_L",
                                "value": 8385.036601943908,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 11 Q_L 8385.04 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 12,
                                "metric": "F_factor",
                                "value": 23288.33715012375,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 12 F_factor 23288.34 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 12,
                                "metric": "Q_L",
                                "value": 8386.5625758492,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 12 Q_L 8386.56 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 13,
                                "metric": "F_factor",
                                "value": 23214.492121671938,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 13 F_factor 23214.49 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 13,
                                "metric": "Q_L",
                                "value": 8388.27616860968,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 13 Q_L 8388.28 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 14,
                                "metric": "F_factor",
                                "value": 23141.24585080761,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 14 F_factor 23141.25 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 14,
                                "metric": "Q_L",
                                "value": 8390.282243410064,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 14 Q_L 8390.28 > 45.0 – liquid flooding risk"
                            },
                            {
                                "tray": 15,
                                "metric": "F_factor",
                                "value": 23068.58440359629,
                                "limit": 2.2,
                                "comparison": ">",
                                "warning": "flooding risk",
                                "description": "Tray 15 F_factor 23068.58 > 2.2 – flooding risk"
                            },
                            {
                                "tray": 15,
                                "metric": "Q_L",
                                "value": 8392.563730992091,
                                "limit": 45.0,
                                "comparison": ">",
                                "warning": "liquid flooding risk",
                                "description": "Tray 15 Q_L 8392.56 > 45.0 – liquid flooding risk"
                            }
                        ]
                    }
                }
            }
        ],
        "carbon_emission": null,
        "energy_consumption": null,
        "productivity": null,
        "purity": null,
        "production": null
    }
}
// 临时输入数据
export const tempInput: any = t_inputs